import React, { useState, useRef, useEffect, useMemo } from "react";
import Select, { components as RSComponents } from "react-select";
import Modal from "react-modal";
import { FiEdit2, FiPlus, FiTrash2, FiDownload, FiCopy } from "react-icons/fi";
import { FaAngleDoubleRight } from "react-icons/fa";
import { RiAlignItemBottomFill } from "react-icons/ri";
import { MdTab, MdImage, MdLightbulb, MdDescription } from "react-icons/md";
import { HiSparkles } from "react-icons/hi";
import NavigateBack from "../NavigateBack";
import { IoClose } from "react-icons/io5";
import { AiOutlineInfoCircle } from "react-icons/ai";
import SnackBar from "../SnackBar";
import { optimizeAndConvertToWebp, uploadImageToS3Bucket } from "../../services/imageOptimizerService";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemPanel,
    AccordionItemButton,
} from "react-accessible-accordion";
import { FaChevronDown } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { customSelect } from "../Styles/CustomStyles";
import { getCoupons, createCatogory, getCategories, getDeliveryOptions, getShowcaseSections, createProduct, updateProduct, deleteImageFromS3, generateProductDescription, fetchGstGroups, getMasterProductCounts, fetchBranchDataById, getMetricsForProducts, getLastProductDetailsTabs, getVendors, getProducts, getScopedBranchIdForUser, isBranchMarketplaceEnabled } from "../../services/ClientService";
import { toast } from "react-toastify";


// Set the app element for accessibility
Modal.setAppElement('#root');

const CreateProduct = () => {
    const textAreaRefs = useRef({});
    const navigate = useNavigate();
    const location = useLocation();
    const fileInputRef = useRef(null);

    const [formData, setFormData] = useState({
        productName: "",
        variantName: "", // Optional variant name for product variant display
        description: "",
        hideReviews: false,
        materials: "",
        ingredients: "",
        uses: "",
        instructions: "",
        fullDetails: "",
        category: null,
        images: [],
        sections: [],
        coupons: [],
        gstGroupId: null,
        barcode: "", // New field for barcode
        vendorId: null, // Optional vendor ID
        hsnNumber: "", // Optional HSN number
    });

    const [errors, setErrors] = useState({});
    const [snackBarMessage, setSnackBarMessage] = useState("");
    const [isSnackBarVisible, setIsSnackBarVisible] = useState(false);
    const [productOptions, setProductOptions] = useState([]); // Unified product options
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
    const [newLabelCategory, setNewLabelCategory] = useState("");
    const [deliveryOptionsData, setDeliveryOptionsData] = useState([]);
    const [, setSelectedSubscription] = useState('');
    const [couponsOffline, setCouponsOffline] = useState([]); // For offline store
    const [coupons, setCoupons] = useState([]); // For online store
    const [couponsData, setCouponsData] = useState([]);
    const [couponsDataOnline, setCouponsDataOnline] = useState([]);
    const [couponsDataOffline, setCouponsDataOffline] = useState([]);
    const [categories, setCategories] = useState([]);
    const [sections, setSections] = useState([]);
    const [sectionsData, setSectionsData] = useState([]);
    const [gstGroups, setGstGroups] = useState([]); // New state for GST groups
    const [gstGroupLoading, setGstGroupLoading] = useState(false); // Loading state for GST groups
    const [vendors, setVendors] = useState([]); // Vendors list for dropdown
    const [vendorsLoading, setVendorsLoading] = useState(false); // Loading state for vendors
    const [metrics, setMetrics] = useState([]); // Metrics for weight configuration
    const [mainMetric, setMainMetric] = useState(null); // Selected main metric (primary only)
    const [isUploading, setIsUploading] = useState(false);
    const [isGenerating, setIsGenerating] = useState(false);
    const [masterCountData, setMasterCountData] = useState(null);
    const [enableOnlineStore, setEnableOnlineStore] = useState(true);
    const [enableOfflineStore, setEnableOfflineStore] = useState(true);
    const [enableMarketplace, setEnableMarketplace] = useState(false);

    const [currentProductOption, setCurrentProductOption] = useState({
        weightValue: "",
        selectedMetric: null,
        weightLabel: "",
        originalPrice: "",
        discount: null,
        discountPrice: "",
        barcode: "",
        useDifferentOfflinePrice: false,
        offlineOriginalPrice: "",
        offlineDiscount: null,
        offlineDiscountPrice: "",
        useDifferentMarketplacePrice: false,
        marketplaceOriginalPrice: "",
        marketplaceDiscount: null,
        marketplaceDiscountPrice: "",
        mainMetricLabel: "", // Store main metric label for later use
        mainMetricId: null, // Store main metric ID
        images: [], // Option-specific images (NEW: Feature 1)
        bulkOffers: [], // Bulk Offers: [{minQuantity, discountPercentage}]
        isFlashDiscount: false,
        flashDiscountPrice: "",
        flashMinimumCartValue: "",
        maxAllowedQuantityInOneOrder: "",
        expiryDate: "",
    });

    // NEW: State for option-specific image upload
    const optionImageInputRef = useRef(null);

    // =====================================================================
    // FEATURE 2: MULTI-ATTRIBUTE OPTIONS (RAM + ROM Style)
    // =====================================================================
    const [useMultiAttributeMode, setUseMultiAttributeMode] = useState(false); // Toggle between simple and multi-attribute mode
    const [optionGroups, setOptionGroups] = useState([]); // Array of { groupName: "RAM", values: ["4GB", "8GB", "12GB"] }
    const [variantCombinations, setVariantCombinations] = useState([]); // Array of combination pricing
    const [isOptionGroupModalOpen, setIsOptionGroupModalOpen] = useState(false);
    const [isVariantCombinationModalOpen, setIsVariantCombinationModalOpen] = useState(false);
    const [currentOptionGroup, setCurrentOptionGroup] = useState({ groupName: "", values: [] });
    const [currentOptionGroupValue, setCurrentOptionGroupValue] = useState("");
    const [editOptionGroupIndex, setEditOptionGroupIndex] = useState(null);
    const [currentVariantCombination, setCurrentVariantCombination] = useState({
        selectedOptions: {}, // { "RAM": "8GB", "ROM": "128GB" }
        originalPrice: "",
        discount: null,
        discountPrice: "",
        barcode: "",
        useDifferentOfflinePrice: false,
        offlineOriginalPrice: "",
        offlineDiscount: null,
        offlineDiscountPrice: "",
        useDifferentMarketplacePrice: false,
        marketplaceOriginalPrice: "",
        marketplaceDiscount: null,
        marketplaceDiscountPrice: "",
        images: [], // Variant-specific images
    });
    const [editVariantCombinationIndex, setEditVariantCombinationIndex] = useState(null);
    const variantImageInputRef = useRef(null);

    const [editOptionIndex, setEditOptionIndex] = useState(null);

    const isValidExpiryDateFormat = (value) => {
        if (!value) return true;
        const match = String(value).trim().match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
        if (!match) return false;
        const day = Number(match[1]);
        const month = Number(match[2]);
        const year = Number(match[3]);
        if (month < 1 || month > 12 || day < 1 || year < 1900) return false;
        const date = new Date(year, month - 1, day);
        return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
    };

    // =====================================================================
    // FEATURE 3: DYNAMIC PRODUCT DETAILS (Flipkart Style)
    // =====================================================================
    // Product Highlights - Key features shown prominently (Plain text only)
    const [productHighlights, setProductHighlights] = useState([]);
    const [currentHighlight, setCurrentHighlight] = useState({ text: '' });
    const [isHighlightModalOpen, setIsHighlightModalOpen] = useState(false);
    const [editHighlightIndex, setEditHighlightIndex] = useState(null);

    // Dynamic Product Details Tabs - User creates custom tab names with sections
    const [productDetailsTabs, setProductDetailsTabs] = useState([]);
    const [currentTab, setCurrentTab] = useState({ tabName: '', sections: [] });
    const [currentSection, setCurrentSection] = useState({ sectionName: '', fields: [] });
    const [currentField, setCurrentField] = useState({ fieldName: '', fieldValue: '' });
    const [isTabModalOpen, setIsTabModalOpen] = useState(false);
    const [isSectionModalOpen, setIsSectionModalOpen] = useState(false);
    const [editTabIndex, setEditTabIndex] = useState(null);
    const [editSectionIndex, setEditSectionIndex] = useState(null);
    const [selectedTabForSection, setSelectedTabForSection] = useState(null);
    const [isImportingTabs, setIsImportingTabs] = useState(false); // Loading state for importing tabs from last product

    // Showcase Images (Brand imagery)
    const [showcaseImages, setShowcaseImages] = useState([]);
    const showcaseImageInputRef = useRef(null);

    // State to control Advanced Product Details section expansion
    const [isAdvancedDetailsExpanded, setIsAdvancedDetailsExpanded] = useState(false);

    // Check if selected main metric has sub-units configured
    // Returns true if metric has sub-units (like Kg -> gm), false if no sub-units (like Unit, Pair)
    const mainMetricHasSubUnits = useMemo(() => {
        if (!mainMetric) return false;
        // Check if the main metric has a supporting metric label configured
        return !!(mainMetric.supportingMetricLabel && mainMetric.supportingMetricLabel.trim() !== '');
    }, [mainMetric]);

    // =====================================================================
    // CLONE PRODUCT FEATURE
    // =====================================================================
    const [cloneSearchTerm, setCloneSearchTerm] = useState("");
    const [cloneSearchResults, setCloneSearchResults] = useState([]);
    const [isCloneSearching, setIsCloneSearching] = useState(false);
    const [showCloneDropdown, setShowCloneDropdown] = useState(false);
    const [isCloneExpanded, setIsCloneExpanded] = useState(false);
    const cloneSearchRef = useRef(null);
    const cloneDebounceRef = useRef(null);

    const [removedImages, setRemovedImages] = useState([]); // Track removed images
    const [newCategoryImage, setNewCategoryImage] = useState(null); // New state for category image
    const [newCategoryImagePreview, setNewCategoryImagePreview] = useState(""); // New state for category image preview
    const newCategoryImageInputRef = useRef(null); // Ref for the new image input
    const [saveAttempted, setSaveAttempted] = useState(false);
    const [isSavingCategory, setIsSavingCategory] = useState(false);
    const [, setDeliveryLocations] = useState([]); // Keep for UI state, but not in payload
    const [isSubmitting, setIsSubmitting] = useState(false); // New state for submission loader
    const [storeType] = useState('online'); // 'offline' or 'online'
    const [isOnlineProduct, setIsOnlineProduct] = useState(location.state?.isOnlineProduct ?? true);
    const [isOfflineProduct, setIsOfflineProduct] = useState(location.state?.isOfflineProduct ?? false);
    const [isMarketplaceProduct, setIsMarketplaceProduct] = useState(location.state?.isMarketplaceProduct ?? false);
    const [commonInventoryType, setCommonInventoryType] = useState(location.state?.commonInventoryType ?? false); // Global common inventory flag
    const hasLoadedProductData = useRef(false); // Prevent overriding initial state repeatedly

    useEffect(() => {
        if (location.state) {
            const {
                productName,
                variantName,
                description,
                hideReviews,
                materials,
                ingredients,
                uses,
                instructions,
                fullDetails,
                category,
                images,
                coupons: savedCoupons,
                couponsOffline: savedCouponsOffline,
                sections: savedSections,
                productOptions: savedProductOptions,
                isOnlineProduct: savedIsOnlineProduct,
                isOfflineProduct: savedIsOfflineProduct,
                gstGroupId,
                vendorId: savedVendorId,
                hsnNumber: savedHsnNumber,
                // FEATURE 3: Dynamic Product Details Fields
                productHighlights: savedProductHighlights,
                productDetailsTabs: savedProductDetailsTabs,
                showcaseImages: savedShowcaseImages

            } = location.state;

            setFormData({
                productName: productName || "",
                variantName: variantName || "",
                description: description || "",
                hideReviews: hideReviews || false,
                materials: materials || "",
                ingredients: ingredients || "",
                uses: uses || "",
                instructions: instructions || "",
                fullDetails: fullDetails || "",
                category: category || null,
                images: images || [],
                coupons: savedCoupons || [],
                sections: savedSections || [],
                gstGroupId: gstGroupId || null, // Set GST group ID if available
                vendorId: savedVendorId || null, // Load vendor ID if available
                hsnNumber: savedHsnNumber || "", // Load HSN number if available
            });

            if (category) {
                setFormData(prevFormData => ({ ...prevFormData, category: { value: category, label: category } }));
            }

            // --- START OF NEW FILTERING LOGIC ---

            // Filter Categories
            if (categories.length) {
                const selectedCategory = categories.find(cat => cat.value === category);
                setFormData(prevFormData => ({ ...prevFormData, category: selectedCategory || null })); // set object or null if not found
            }

            // Filter Coupons (Online)
            if (savedCoupons && couponsData.length) {
                const filteredCoupons = couponsData.filter(coupon => savedCoupons.includes(coupon._id));
                setCoupons(filteredCoupons);
            }

            // Filter Coupons (Offline)
            if (savedCouponsOffline && couponsData.length) {
                const filteredCouponsOffline = couponsData.filter(coupon => savedCouponsOffline.includes(coupon._id));
                setCouponsOffline(filteredCouponsOffline);
            }

            // Filter Sections
            if (savedSections && sectionsData.length) {
                const filteredSections = sectionsData.filter(section => savedSections.includes(section.value)); // Assuming section 'value' is _id
                setSections(filteredSections);
            }

            // Process unified product options (includes offline pricing if present)
            if (savedProductOptions && savedProductOptions.length && metrics.length) {
                const processedOptions = savedProductOptions.map(option => {
                    // Parse weight structure from saved option
                    const weightData = option.weight || {};
                    let weightValue = weightData.weightValue || "";
                    const metricId = weightData.metricId || null;
                    const metricType = weightData.metricType || 'primary';
                    const weightLabel = weightData.weightLabel || "";
                    const metricLabel = weightData.metricLabel || "";
                    const conversionFactor = weightData.conversionFactor || 1;

                    // Find metric from metrics list (considering both primary and supporting)
                    const selectedMetric = metricId ? metrics.find(m => m.metricId === metricId && m.metricType === metricType) : null;

                    // REVERSE CONVERT: If supporting metric was selected, convert back from primary to supporting
                    // Example: DB has 0.4 Kg (converted), but user selected "gm", so show 400 gm
                    if (metricType === 'supporting' && conversionFactor && weightValue) {
                        weightValue = parseFloat(weightValue) / conversionFactor;
                    }

                    return {
                        ...option,
                        weightValue: weightValue,
                        selectedMetric: selectedMetric,
                        weightLabel: weightLabel,
                        mainMetricLabel: metricLabel, // Store the primary metric label
                        mainMetricId: metricId, // Store the primary metric ID
                        useDifferentOfflinePrice: !!option.offlinePrice, // Set checkbox state if offlinePrice exists
                        offlineOriginalPrice: option.offlinePrice?.originalPrice || "",
                        offlineDiscount: option.offlinePrice?.discount ?? null,
                        offlineDiscountPrice: option.offlinePrice?.discountPrice || "",
                        useDifferentMarketplacePrice: !!option.marketplacePrice,
                        marketplaceOriginalPrice: option.marketplacePrice?.originalPrice || "",
                        marketplaceDiscount: option.marketplacePrice?.discount ?? null,
                        marketplaceDiscountPrice: option.marketplacePrice?.discountPrice || "",
                        images: option.images || [], // Load option-specific images if available
                        isFlashDiscount: !!option.flashDiscount?.enabled,
                        flashDiscountPrice: option.flashDiscount?.discountPrice ?? "",
                        flashMinimumCartValue: option.flashDiscount?.minimumCartValue ?? "",
                        maxAllowedQuantityInOneOrder: option.flashDiscount?.maxAllowedQuantityInOneOrder ?? "",
                        expiryDate: option.expiryDate || ""
                    };
                });
                setProductOptions(processedOptions);

                // Set mainMetric from saved data (product level or first option)
                const savedMainMetric = location.state?.mainMetric;
                if (savedMainMetric?.metricId) {
                    // Load from product-level mainMetric if available
                    const primaryMetric = metrics.find(m =>
                        m.metricId === savedMainMetric.metricId &&
                        m.metricType === 'primary'
                    );
                    if (primaryMetric) {
                        setMainMetric(primaryMetric);
                    }
                } else if (savedProductOptions.length > 0 && savedProductOptions[0].weight?.metricId) {
                    // Fallback: Load from first product option
                    const firstOptionMetricId = savedProductOptions[0].weight.metricId;
                    const primaryMetric = metrics.find(m =>
                        m.metricId === firstOptionMetricId &&
                        m.metricType === 'primary'
                    );
                    if (primaryMetric) {
                        setMainMetric(primaryMetric);
                    }
                }

                // Load global commonInventoryType from first option (for backward compatibility)
                if (savedProductOptions.length > 0 && savedProductOptions[0].commonInventoryType !== undefined) {
                    setCommonInventoryType(savedProductOptions[0].commonInventoryType || false);
                }
            } else {
                setProductOptions([]);
            }

            // FEATURE 2: Load Multi-Attribute Mode Data
            const savedUseMultiAttributeMode = location.state?.useMultiAttributeMode;
            const savedOptionGroups = location.state?.optionGroups;

            if (savedUseMultiAttributeMode) {
                setUseMultiAttributeMode(true);

                if (savedOptionGroups && savedOptionGroups.length) {
                    setOptionGroups(savedOptionGroups);
                }

                // For multi-attribute mode, variant combinations are stored in productOptions
                // Reuse savedProductOptions already declared above
                if (savedProductOptions && savedProductOptions.length) {
                    // Process productOptions to restore variant combinations form state
                    const processedVariants = savedProductOptions
                        .filter(opt => opt.selectedOptions) // Only include options with selectedOptions (multi-attribute entries)
                        .map(opt => ({
                            _id: opt._id,
                            selectedOptions: opt.selectedOptions,
                            combinationLabel: opt.combinationLabel || opt.weight?.weightLabel || '',
                            originalPrice: opt.originalPrice,
                            discount: opt.discount,
                            discountPrice: opt.discountPrice,
                            barcode: opt.barcode || '',
                            useDifferentOfflinePrice: !!opt.offlinePrice,
                            offlineOriginalPrice: opt.offlinePrice?.originalPrice || "",
                            offlineDiscount: opt.offlinePrice?.discount ?? null,
                            offlineDiscountPrice: opt.offlinePrice?.discountPrice || "",
                            useDifferentMarketplacePrice: !!opt.marketplacePrice,
                            marketplaceOriginalPrice: opt.marketplacePrice?.originalPrice || "",
                            marketplaceDiscount: opt.marketplacePrice?.discount ?? null,
                            marketplaceDiscountPrice: opt.marketplacePrice?.discountPrice || "",
                            images: opt.images || []
                        }));
                    setVariantCombinations(processedVariants);
                    setProductOptions([]); // Clear simple options array (UI uses variantCombinations for multi-attribute)
                }
            }

            // FEATURE 3: Load Dynamic Product Details
            if (savedProductHighlights && savedProductHighlights.length) {
                // Convert old format (with icons) to new format (plain text) if needed
                setProductHighlights(savedProductHighlights.map(h => ({ text: h.text || h })));
            }
            if (savedProductDetailsTabs && savedProductDetailsTabs.length) {
                setProductDetailsTabs(savedProductDetailsTabs);
            }
            if (savedShowcaseImages && savedShowcaseImages.length) {
                setShowcaseImages(savedShowcaseImages);
            }

            // Only set checkbox states for the first time we load the location.state (to ensure saved values take precedence)
            if (!hasLoadedProductData.current) {
                if (typeof savedIsOnlineProduct !== 'undefined') setIsOnlineProduct(savedIsOnlineProduct === true);
                if (typeof savedIsOfflineProduct !== 'undefined') setIsOfflineProduct(savedIsOfflineProduct === true);
                hasLoadedProductData.current = true;
            }
            // --- END OF NEW FILTERING LOGIC ---
        }
    }, [location.state, couponsData, sectionsData, deliveryOptionsData, categories, metrics]); // Add dependencies for filtering


    useEffect(() => {
        if (location.state && location.state.gstGroups) {
            setGstGroups(location.state.gstGroups);
        } else {
            getGstGroups(); // Only fetch if not provided
        }
        getCouponsMethod({ isActive: [true] });
        fetchCategories({});
        fetchShowcaseSections({ isActive: [true] });
        fetchMasterCounts();
        fetchMetrics();
        fetchVendorsList(); // Fetch vendors for dropdown
        // Fetch branch settings (enableOnlineStore/enableOfflineStore) based on current user (or selectedBranch for super admin)
        const fetchBranchSettings = async () => {
            try {
                const branchIdToFetch = getScopedBranchIdForUser();
                if (!branchIdToFetch) return;
                const branchResp = await fetchBranchDataById(branchIdToFetch);
                if (branchResp && branchResp.success && branchResp.data) {
                    const branch = branchResp.data;
                    setEnableOnlineStore(!!branch.enableOnlineStore);
                    setEnableOfflineStore(!!branch.enableOfflineStore);
                    setEnableMarketplace(await isBranchMarketplaceEnabled(branchIdToFetch));

                    // Set default checkboxes based on branch settings
                    // Only apply branch-level defaults when creating a new product (not editing)
                    if (!location.state) {
                        // Prefer Online by default; if Online isn't available, fallback to Offline
                        if (branch.enableOnlineStore) {
                            setIsOnlineProduct(true);
                            setIsOfflineProduct(false);
                        } else if (branch.enableOfflineStore) {
                            setIsOnlineProduct(false);
                            setIsOfflineProduct(true);
                        } else {
                            setIsOnlineProduct(false);
                            setIsOfflineProduct(false);
                        }
                    }
                }
            } catch (error) {
                console.error('Error fetching branch settings:', error);
            }
        }
        fetchBranchSettings();
        // Mount-only: branch store flags are resolved once on open.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Only run on mount

    // Reset the loaded flag when the location state changes to a different product
    useEffect(() => {
        return () => { hasLoadedProductData.current = false; };
    }, [location.state?._id]);

    // Clear selectedMetric when mainMetric changes and it's no longer valid
    useEffect(() => {
        // Only check if modal is open and there's a selected metric
        if (isModalOpen && currentProductOption.selectedMetric && mainMetric) {
            // Check if the selected metric belongs to the current mainMetric
            const isValidMetric = metrics.some(m =>
                m.metricId === mainMetric.metricId &&
                m.metricId === currentProductOption.selectedMetric.metricId &&
                (m.metricType === 'primary' || m.metricType === 'supporting')
            );

            // If the selected metric is not valid for the new mainMetric, clear it
            if (!isValidMetric) {
                setCurrentProductOption(prev => ({
                    ...prev,
                    selectedMetric: null,
                    mainMetricLabel: mainMetric?.label || "",
                    mainMetricId: mainMetric?.metricId || null,
                }));
            }
        }
        // Intentionally omit currentProductOption.selectedMetric to avoid clearing loops while editing.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mainMetric, isModalOpen, metrics]);

    // Auto expand/collapse Advanced Product Details based on Multi-Attribute Options
    useEffect(() => {
        setIsAdvancedDetailsExpanded(useMultiAttributeMode);
    }, [useMultiAttributeMode]);

    // =====================================================================
    // CLONE PRODUCT: Search & Bind Logic
    // =====================================================================
    // Close clone dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (cloneSearchRef.current && !cloneSearchRef.current.contains(event.target)) {
                setShowCloneDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleCloneSearch = (value) => {
        setCloneSearchTerm(value);
        if (cloneDebounceRef.current) clearTimeout(cloneDebounceRef.current);

        if (!value.trim()) {
            setCloneSearchResults([]);
            setShowCloneDropdown(false);
            return;
        }

        cloneDebounceRef.current = setTimeout(async () => {
            setIsCloneSearching(true);
            try {
                const response = await getProducts({ searchTerm: value.trim(), isActive: [true], limit: 10, skip: 0 });
                if (response.success && response.data) {
                    setCloneSearchResults(response.data);
                    setShowCloneDropdown(true);
                } else {
                    setCloneSearchResults([]);
                }
            } catch (error) {
                console.error("Clone search error:", error);
                setCloneSearchResults([]);
            } finally {
                setIsCloneSearching(false);
            }
        }, 400);
    };

    const handleCloneProductSelect = (product) => {
        // Close the search dropdown
        setShowCloneDropdown(false);
        setCloneSearchTerm("");
        setCloneSearchResults([]);

        // ---- Bind formData fields (EXCEPT images) ----
        const clonedCategory = product.category
            ? categories.find(cat => cat.value === product.category) || null
            : null;

        setFormData({
            productName: product.productName || "",
            variantName: product.variantName || "",
            description: product.description || "",
            hideReviews: product.hideReviews || false,
            materials: product.materials || "",
            ingredients: product.ingredients || "",
            uses: product.uses || "",
            instructions: product.instructions || "",
            fullDetails: product.fullDetails || "",
            category: clonedCategory,
            images: [], // Explicitly empty - do NOT clone images
            coupons: product.coupons || [],
            sections: product.sections || [],
            gstGroupId: product.gstGroupId || null,
            barcode: "", // Clear barcode since it should be unique per product
            vendorId: product.vendorId || null,
            hsnNumber: product.hsnNumber || "",
        });

        // ---- Store type flags ----
        if (typeof product.isOnlineProduct !== 'undefined') setIsOnlineProduct(product.isOnlineProduct === true);
        if (typeof product.isOfflineProduct !== 'undefined') setIsOfflineProduct(product.isOfflineProduct === true);
        if (typeof product.isMarketplaceProduct !== 'undefined') setIsMarketplaceProduct(product.isMarketplaceProduct === true);
        if (typeof product.commonInventoryType !== 'undefined') setCommonInventoryType(product.commonInventoryType || false);

        // ---- Main Metric ----
        if (product.mainMetric?.metricId) {
            const primaryMetric = metrics.find(m =>
                m.metricId === product.mainMetric.metricId && m.metricType === 'primary'
            );
            if (primaryMetric) setMainMetric(primaryMetric);
        }

        // ---- GST Group ----
        // The formData.gstGroupId is set above; the Select component will match it from gstGroups

        // ---- Vendor ----
        // The formData.vendorId is set above; the Select component will match it from vendors

        // ---- Coupons (Online) ----
        if (product.coupons && product.coupons.length && couponsData.length) {
            const filteredCoupons = couponsData.filter(coupon => product.coupons.includes(coupon._id));
            setCoupons(filteredCoupons);
        } else {
            setCoupons([]);
        }

        // ---- Coupons (Offline) ----
        if (product.couponsOffline && product.couponsOffline.length && couponsData.length) {
            const filteredCouponsOffline = couponsData.filter(coupon => product.couponsOffline.includes(coupon._id));
            setCouponsOffline(filteredCouponsOffline);
        } else {
            setCouponsOffline([]);
        }

        // ---- Sections ----
        if (product.sections && product.sections.length && sectionsData.length) {
            const filteredSections = sectionsData.filter(section => product.sections.includes(section.value));
            setSections(filteredSections);
        } else {
            setSections([]);
        }

        // ---- Multi-Attribute Mode ----
        if (product.useMultiAttributeMode) {
            setUseMultiAttributeMode(true);
            if (product.optionGroups && product.optionGroups.length) {
                setOptionGroups(product.optionGroups);
            } else {
                setOptionGroups([]);
            }
            // Process variant combinations from productOptions
            if (product.productOptions && product.productOptions.length) {
                const processedVariants = product.productOptions
                    .filter(opt => opt.selectedOptions)
                    .map(opt => ({
                        selectedOptions: opt.selectedOptions,
                        combinationLabel: opt.combinationLabel || opt.weight?.weightLabel || '',
                        originalPrice: opt.originalPrice,
                        discount: opt.discount,
                        discountPrice: opt.discountPrice,
                        barcode: '', // Clear barcode for cloned variants
                        useDifferentOfflinePrice: !!opt.offlinePrice,
                        offlineOriginalPrice: opt.offlinePrice?.originalPrice || "",
                        offlineDiscount: opt.offlinePrice?.discount ?? null,
                        offlineDiscountPrice: opt.offlinePrice?.discountPrice || "",
                        useDifferentMarketplacePrice: !!opt.marketplacePrice,
                        marketplaceOriginalPrice: opt.marketplacePrice?.originalPrice || "",
                        marketplaceDiscount: opt.marketplacePrice?.discount ?? null,
                        marketplaceDiscountPrice: opt.marketplacePrice?.discountPrice || "",
                        images: [] // Do NOT clone variant images
                    }));
                setVariantCombinations(processedVariants);
                setProductOptions([]);
            }
        } else {
            setUseMultiAttributeMode(false);
            setOptionGroups([]);
            setVariantCombinations([]);

            // ---- Simple Product Options (with pricing, weight, bulk offers - EXCEPT images & barcodes) ----
            if (product.productOptions && product.productOptions.length && metrics.length) {
                const processedOptions = product.productOptions.map(option => {
                    const weightData = option.weight || {};
                    let weightValue = weightData.weightValue || "";
                    const metricId = weightData.metricId || null;
                    const metricType = weightData.metricType || 'primary';
                    const weightLabel = weightData.weightLabel || "";
                    const metricLabel = weightData.metricLabel || "";
                    const conversionFactor = weightData.conversionFactor || 1;

                    // Find metric from metrics list
                    const selectedMetric = metricId ? metrics.find(m => m.metricId === metricId && m.metricType === metricType) : null;

                    // Reverse convert: if supporting metric, convert back from primary to supporting
                    if (metricType === 'supporting' && conversionFactor && weightValue) {
                        weightValue = parseFloat(weightValue) / conversionFactor;
                    }

                    return {
                        weightValue: weightValue,
                        selectedMetric: selectedMetric,
                        weightLabel: weightLabel,
                        mainMetricLabel: metricLabel,
                        mainMetricId: metricId,
                        originalPrice: option.originalPrice,
                        discount: option.discount,
                        discountPrice: option.discountPrice,
                        barcode: '', // Clear barcode for cloned options
                        useDifferentOfflinePrice: !!option.offlinePrice,
                        offlineOriginalPrice: option.offlinePrice?.originalPrice || "",
                        offlineDiscount: option.offlinePrice?.discount ?? null,
                        offlineDiscountPrice: option.offlinePrice?.discountPrice || "",
                        useDifferentMarketplacePrice: !!option.marketplacePrice,
                        marketplaceOriginalPrice: option.marketplacePrice?.originalPrice || "",
                        marketplaceDiscount: option.marketplacePrice?.discount ?? null,
                        marketplaceDiscountPrice: option.marketplacePrice?.discountPrice || "",
                        images: [], // Do NOT clone option images
                        bulkOffers: option.bulkOffers ? option.bulkOffers.map(bo => ({
                            minQuantity: bo.minQuantity,
                            discountPercentage: bo.discountPercentage
                        })) : [],
                        isFlashDiscount: !!option.flashDiscount?.enabled,
                        flashDiscountPrice: option.flashDiscount?.discountPrice ?? "",
                        flashMinimumCartValue: option.flashDiscount?.minimumCartValue ?? "",
                        maxAllowedQuantityInOneOrder: option.flashDiscount?.maxAllowedQuantityInOneOrder ?? "",
                        expiryDate: option.expiryDate || ""
                    };
                });
                setProductOptions(processedOptions);
            } else {
                setProductOptions([]);
            }
        }

        // ---- FEATURE 3: Dynamic Product Details ----
        // Product Highlights
        if (product.productHighlights && product.productHighlights.length) {
            setProductHighlights(product.productHighlights.map(h => ({ text: h.text || h })));
        } else {
            setProductHighlights([]);
        }

        // Product Details Tabs
        if (product.productDetailsTabs && product.productDetailsTabs.length) {
            setProductDetailsTabs(product.productDetailsTabs);
        } else {
            setProductDetailsTabs([]);
        }

        // Showcase Images - Do NOT clone
        setShowcaseImages([]);

        // Expand advanced details if there is relevant data
        if ((product.productHighlights && product.productHighlights.length) ||
            (product.productDetailsTabs && product.productDetailsTabs.length) ||
            product.useMultiAttributeMode) {
            setIsAdvancedDetailsExpanded(true);
        }

        // Clear errors
        setErrors({});

        // Show success message
        setSnackBarMessage(`Product data cloned from "${product.productName}". Images excluded.`);
        setIsSnackBarVisible(true);
    };

    const generateAIDescription = async () => {
        if (!formData.productName || !formData.category) {
            setSnackBarMessage("Product name and category are required for AI generation");
            setIsSnackBarVisible(true);
            return;
        }

        setIsGenerating(true);
        try {
            // Call your backend API endpoint
            const response = await generateProductDescription({
                productName: formData.productName,
                category: formData.category.label,
            });

            if (response.success && response.data && response.data.description) {
                setFormData(prev => ({ ...prev, description: response.data.description }));
                setErrors(prevErrors => ({ ...prevErrors, description: "" }));
            } else {
                setSnackBarMessage("Failed to generate AI description");
                setIsSnackBarVisible(true);
            }
        } catch (error) {
            console.error("Error calling generateProductDescription API:", error);
            setSnackBarMessage("Failed to generate AI description");
            setIsSnackBarVisible(true);
        } finally {
            setIsGenerating(false);
        }
    };

    const fetchCategories = async (params) => {
        try {
            const data = await getCategories(params);
            if (data.success) {
                // Flatten hierarchical data: include parent categories and subcategories
                let localData = [];
                if (data.data?.length) {
                    data.data.forEach(parent => {
                        // Add parent category
                        localData.push({
                            value: parent._id,
                            label: parent.categoryName,
                            isParent: true
                        });
                        // Add subcategories with indentation
                        if (parent.subcategories?.length) {
                            parent.subcategories.forEach(sub => {
                                localData.push({
                                    value: sub._id,
                                    label: `${parent.categoryName} > ${sub.categoryName}`,
                                    parentLabel: parent.categoryName,
                                    subcategoryLabel: sub.categoryName,
                                    isSubcategory: true
                                });
                            });
                        }
                    });
                }
                setCategories(localData);
            } else {
                setCategories([]);
            }
        } catch (error) {
            console.error("Error fetching Categories:", error);
            setCategories([]);
        }
    };

    // eslint-disable-next-line no-unused-vars -- retained helper for delivery option loading
    const fetchDeliveryOptions = async (params) => {
        try {
            const data = await getDeliveryOptions(params);
            if (data.success) {
                let user = JSON.parse(localStorage.getItem("userData"));
                let formattedOptions = [];
                console.log(data?.subPlanData?.deliveryLocations, "Delivery Locations Data");

                setSelectedSubscription(data?.subPlanData?.selectedSubscription);
                setDeliveryLocations(user?.deliveryLocations || []); // Set delivery locations from subPlanData
                if (data?.subPlanData?.selectedSubscription === "Bronze") {
                    formattedOptions = []
                } else if (data?.subPlanData?.selectedSubscription === "Silver") {
                    formattedOptions = data.data.map(option => ({
                        value: option.value, // Unique identifier
                        label: option.label, // Display label
                    }));
                } else if (data?.subPlanData?.selectedSubscription === "Gold" || data?.subPlanData?.selectedSubscription === "Platinum") {
                    if (data?.subPlanData?.enableShipRocket) {
                        formattedOptions = data.data.map(option => ({
                            value: option.value, // Unique identifier
                            label: option.label, // Display label
                        }));
                    } else {
                        formattedOptions = data.data.map(option => ({
                            value: option.deliveryOptionName.value, // Unique identifier
                            label: option.deliveryOptionName.label, // Display label
                        }));
                    }
                }
                setDeliveryOptionsData(formattedOptions);
            } else {
                setDeliveryOptionsData([]);
                setDeliveryLocations([]); // Clear delivery locations if fetch fails
            }
        } catch (error) {
            setDeliveryOptionsData([]);
            setDeliveryLocations([]); // Clear delivery locations on error
            console.error("Error fetching Delivery Options:", error);
        }
    };

    const getCouponsMethod = async (params) => {
        try {
            const data = await getCoupons(params);
            if (data.success) {
                const allCoupons = data.data?.length ? data.data.map(e => ({ _id: e._id, value: e._id, label: e.name, couponName: e.name, storeType: e.storeType })) : [];
                setCouponsData(allCoupons);
                // Filter coupons by store type
                const onlineCoupons = allCoupons.filter(c => c.storeType === 'online');
                const offlineCoupons = allCoupons.filter(c => c.storeType === 'offline');
                setCouponsDataOnline(onlineCoupons);
                setCouponsDataOffline(offlineCoupons);
            } else {
                setCouponsData([]);
                setCouponsDataOnline([]);
                setCouponsDataOffline([]);
            }
        } catch (error) {
            console.error("Error fetching branch data:", error);
            setCouponsData([]);
            setCouponsDataOnline([]);
            setCouponsDataOffline([]);
        }
    };

    const fetchShowcaseSections = async (params) => {
        try {
            const data = await getShowcaseSections(params);
            if (data.success && data.data) {
                const formattedOptions = data.data.map(({ _id, sectionName }) => ({
                    value: _id,
                    label: sectionName,
                    sectionName,
                }));
                setSectionsData(formattedOptions);
            } else {
                setSectionsData([]);
            }
        } catch (error) {
            console.error("Error fetching sections:", error);
        }
    };

    const fetchMasterCounts = async () => {
        try {
            const data = await getMasterProductCounts();
            if (data && data.success) {
                setMasterCountData(data.data);
            }
        } catch (error) {
            console.error('Error fetching master counts', error);
        }
    }

    const getGstGroups = async () => {
        setGstGroupLoading(true);
        try {
            const data = await fetchGstGroups();

            if (data.success && data.data) {
                const formattedGroups = data.data[0].gstGroups.map(group => ({
                    value: group._id,
                    label: group.name,
                }));
                setGstGroups(formattedGroups);
            } else {
                setGstGroups([]);
            }
        } catch (error) {
            console.error("Error fetching GST groups:", error);
            setGstGroups([]);
        } finally {
            setGstGroupLoading(false);
        }
    };

    // Fetch vendors for dropdown
    const fetchVendorsList = async () => {
        setVendorsLoading(true);
        try {
            const response = await getVendors({});
            if (response && response.vendors) {
                const formattedVendors = response.vendors.map(vendor => ({
                    value: vendor._id,
                    label: vendor.vendorName,
                    vendorMobile: vendor.vendorMobile,
                    vendorEmail: vendor.vendorEmail,
                    vendorLocation: vendor.vendorLocation,
                }));
                setVendors(formattedVendors);
            } else {
                setVendors([]);
            }
        } catch (error) {
            console.error("Error fetching vendors:", error);
            setVendors([]);
        } finally {
            setVendorsLoading(false);
        }
    };

    const fetchMetrics = async () => {
        try {
            const data = await getMetricsForProducts({});
            if (data.success && data.data) {
                const formattedMetrics = [];

                data.data.forEach(metric => {
                    // Add primary metric
                    formattedMetrics.push({
                        value: `${metric._id}_primary`,
                        label: metric.metricLabel,
                        metricId: metric._id,
                        metricName: metric.metricName,
                        metricLabel: metric.metricLabel,
                        metricType: 'primary',
                        conversionFactor: 1,
                        supportingMetricName: metric.supportingMetricName,
                        supportingMetricLabel: metric.supportingMetricLabel,
                        primaryToSupporting: metric.primaryToSupporting,
                        supportingToPrimary: metric.supportingToPrimary,
                        isDefault: metric.isDefault
                    });

                    // Add supporting metric if exists
                    if (metric.supportingMetricLabel) {
                        formattedMetrics.push({
                            value: `${metric._id}_supporting`,
                            label: metric.supportingMetricLabel,
                            metricId: metric._id,
                            metricName: metric.supportingMetricName,
                            metricLabel: metric.supportingMetricLabel,
                            metricType: 'supporting',
                            conversionFactor: metric.supportingToPrimary,
                            primaryMetricLabel: metric.metricLabel,
                            supportingMetricName: metric.supportingMetricName,
                            supportingMetricLabel: metric.supportingMetricLabel,
                            primaryToSupporting: metric.primaryToSupporting,
                            supportingToPrimary: metric.supportingToPrimary,
                            isDefault: metric.isDefault
                        });
                    }
                });

                setMetrics(formattedMetrics);
            } else {
                setMetrics([]);
            }
        } catch (error) {
            console.error("Error fetching metrics:", error);
            setMetrics([]);
        }
    };

    // eslint-disable-next-line no-unused-vars -- retained label formatter for delivery options UI
    const formatOptionLabel = ({ label, kmsRange }) => (
        <div>
            <div className="font-semibold text-gray-900">{label}</div>
        </div>
    );

    const formatCouponLabel = ({ label }) => (
        <div>
            <div className="font-semibold text-gray-900">{label}</div>
        </div>
    );

    const formatSectionLabel = ({ sectionName }) => (
        <div>
            <div className="font-semibold">{sectionName}</div>
        </div>
    );

    const formatMetricLabel = ({ label, metricType, metricName }) => (
        <div>
            <div className="font-semibold text-gray-900">{label}</div>
            {metricType && (
                <div className="text-xs text-gray-500">
                    {metricType === 'primary' ? `${metricName} (Primary)` : `${metricName} (Supporting)`}
                </div>
            )}
        </div>
    );

    // eslint-disable-next-line no-unused-vars -- retained discount presets for option pricing UI
    const discountOptions = [
        { value: 0, label: "0%" },
        { value: 5, label: "5%" },
        { value: 10, label: "10%" },
        { value: 20, label: "20%" },
        { value: 30, label: "30%" },
        { value: 50, label: "50%" },
    ];

    // Unified Product Option Validation
    const validateProductOption = () => {
        const newErrors = {};

        // Check if main metric is selected
        if (!mainMetric) {
            newErrors.mainMetric = "Please select a Main Metric from the product form first.";
        }

        // Weight validations - ONLY if main metric has sub-units configured
        // For metrics like "Unit" or "Pair" (no sub-units), skip weight value and metric selection validation
        if (mainMetricHasSubUnits) {
            if (!currentProductOption.weightValue || currentProductOption.weightValue === "") {
                newErrors.weightValue = "Weight value is required.";
            } else if (isNaN(parseFloat(currentProductOption.weightValue)) || parseFloat(currentProductOption.weightValue) <= 0) {
                newErrors.weightValue = "Weight value must be a positive number.";
            }

            if (!currentProductOption.selectedMetric) {
                newErrors.selectedMetric = "Metric selection is required.";
            }
        }

        if (!currentProductOption.weightLabel || currentProductOption.weightLabel.trim() === "") {
            newErrors.weightLabel = "Weight label is required.";
        }

        // Price validations
        if (typeof currentProductOption.originalPrice !== 'number' || isNaN(currentProductOption.originalPrice)) {
            newErrors.originalPrice = "Original price is required.";
        }
        if (typeof currentProductOption.discount !== 'number' || isNaN(currentProductOption.discount) || currentProductOption.discount < 0 || currentProductOption.discount > 100) {
            newErrors.discount = "Discount must be between 0% and 100%.";
        }

        if (currentProductOption.isFlashDiscount) {
            const flashPrice = Number(currentProductOption.flashDiscountPrice);
            const minCartValue = Number(currentProductOption.flashMinimumCartValue);
            const maxQty = Number(currentProductOption.maxAllowedQuantityInOneOrder);
            if (isNaN(flashPrice) || flashPrice <= 0) {
                newErrors.flashDiscountPrice = "Flash discount price must be greater than 0.";
            } else if (!isNaN(currentProductOption.discountPrice) && flashPrice >= Number(currentProductOption.discountPrice)) {
                newErrors.flashDiscountPrice = "Flash discount price should be lower than regular discount price.";
            }
            if (isNaN(minCartValue) || minCartValue < 0) {
                newErrors.flashMinimumCartValue = "Minimum cart value must be 0 or more.";
            }
            if (isNaN(maxQty) || maxQty < 1) {
                newErrors.maxAllowedQuantityInOneOrder = "Max allowed quantity must be at least 1.";
            }
        }
        if (!isValidExpiryDateFormat(currentProductOption.expiryDate)) {
            newErrors.expiryDate = "Expiry date must be in DD/MM/YYYY format.";
        }

        // If different offline price is checked and product is for offline, validate offline fields
        if (currentProductOption.useDifferentOfflinePrice && isOfflineProduct) {
            if (typeof currentProductOption.offlineOriginalPrice !== 'number' || isNaN(currentProductOption.offlineOriginalPrice)) {
                newErrors.offlineOriginalPrice = "Offline original price is required.";
            }
            if (typeof currentProductOption.offlineDiscount !== 'number' || isNaN(currentProductOption.offlineDiscount) || currentProductOption.offlineDiscount < 0 || currentProductOption.offlineDiscount > 100) {
                newErrors.offlineDiscount = "Offline discount must be between 0% and 100%.";
            }
        }

        // If different marketplace price is checked and product is for marketplace, validate marketplace fields
        if (currentProductOption.useDifferentMarketplacePrice && isMarketplaceProduct) {
            if (typeof currentProductOption.marketplaceOriginalPrice !== 'number' || isNaN(currentProductOption.marketplaceOriginalPrice)) {
                newErrors.marketplaceOriginalPrice = "Marketplace original price is required.";
            }
            if (typeof currentProductOption.marketplaceDiscount !== 'number' || isNaN(currentProductOption.marketplaceDiscount) || currentProductOption.marketplaceDiscount < 0 || currentProductOption.marketplaceDiscount > 100) {
                newErrors.marketplaceDiscount = "Marketplace discount must be between 0% and 100%.";
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Validation function for form fields
    const validateForm = () => {
        const newErrors = {};

        // Check at least one checkbox is selected
        if (!isOnlineProduct && !isOfflineProduct && !isMarketplaceProduct) {
            newErrors.storeType = "Please select at least one store type (Online, Offline or Marketplace).";
        }

        // Common validations
        if (!formData.productName) newErrors.productName = "Product Name is required.";

        // Validate product options based on mode
        if (useMultiAttributeMode) {
            // Multi-attribute mode validations
            if (optionGroups.length === 0) {
                newErrors.optionGroups = "At least one option group is required (e.g., RAM, ROM).";
            }
            if (variantCombinations.length === 0) {
                newErrors.variantCombinations = "At least one variant combination with pricing is required.";
            }
        } else {
            // Simple mode validations
            if (productOptions.length === 0) {
                newErrors.productOptions = "At least one product option is required.";
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const formatExpiryDateInput = (value) => {
        const digits = String(value || "").replace(/\D/g, "").slice(0, 8);
        if (digits.length <= 2) return digits;
        if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
        return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
    };

    // Unified Product Option Change Handler
    const handleProductOptionChange = (field, value, isOffline = false) => {
        let parsedValue = value;
        let error = "";

        const fieldKey = isOffline ? `offline${field.charAt(0).toUpperCase() + field.slice(1)}` : field;
        const errorKey = isOffline ? `offline${field.charAt(0).toUpperCase() + field.slice(1)}` : field;

        if (field === "originalPrice") {
            parsedValue = parseInt(value, 10);
            if (isNaN(parsedValue) && value !== "") {
                error = `${isOffline ? 'Offline ' : ''}Original price must be a number.`;
            } else if (!isNaN(parsedValue) && parsedValue < 0) {
                error = `${isOffline ? 'Offline ' : ''}Original price cannot be negative.`;
            } else if (isNaN(parsedValue) && value === "") {
                parsedValue = "";
            }
        } else if (field === "discount") {
            parsedValue = parseInt(value, 10);
            if (isNaN(parsedValue) && value !== "") {
                error = `${isOffline ? 'Offline ' : ''}Discount must be a number.`;
            } else if (!isNaN(parsedValue) && (parsedValue < 0 || parsedValue > 100)) {
                error = `${isOffline ? 'Offline ' : ''}Discount must be between 0% and 100%.`;
            } else if (isNaN(parsedValue) && value === "") {
                parsedValue = null;
            }
        }

        if (error) {
            setErrors(prev => ({ ...prev, [errorKey]: error }));
            return;
        }

        setErrors(prev => ({ ...prev, [errorKey]: "" }));

        setCurrentProductOption(prev => {
            const updated = { ...prev, [fieldKey]: parsedValue };

            if (isOffline) {
                const originalPrice = fieldKey === "offlineOriginalPrice" ? parsedValue : prev.offlineOriginalPrice;
                const discount = fieldKey === "offlineDiscount" ? parsedValue : prev.offlineDiscount;

                if (typeof originalPrice === 'number' && !isNaN(originalPrice) &&
                    typeof discount === 'number' && !isNaN(discount)) {
                    updated.offlineDiscountPrice = Math.floor(originalPrice - (originalPrice * discount) / 100);
                } else {
                    updated.offlineDiscountPrice = "";
                }
            } else {
                const originalPrice = fieldKey === "originalPrice" ? parsedValue : prev.originalPrice;
                const discount = fieldKey === "discount" ? parsedValue : prev.discount;

                if (typeof originalPrice === 'number' && !isNaN(originalPrice) &&
                    typeof discount === 'number' && !isNaN(discount)) {
                    updated.discountPrice = Math.floor(originalPrice - (originalPrice * discount) / 100);
                } else {
                    updated.discountPrice = "";
                }
            }

            return updated;
        });
    };

    // Dedicated handler for marketplace (B2B) option pricing (mirrors the offline branch).
    const handleMarketplacePriceChange = (field, value) => {
        let parsedValue = value;
        let error = "";
        const fieldKey = `marketplace${field.charAt(0).toUpperCase() + field.slice(1)}`;

        if (field === "originalPrice") {
            parsedValue = parseInt(value, 10);
            if (isNaN(parsedValue) && value !== "") error = "Marketplace original price must be a number.";
            else if (!isNaN(parsedValue) && parsedValue < 0) error = "Marketplace original price cannot be negative.";
            else if (isNaN(parsedValue) && value === "") parsedValue = "";
        } else if (field === "discount") {
            parsedValue = parseInt(value, 10);
            if (isNaN(parsedValue) && value !== "") error = "Marketplace discount must be a number.";
            else if (!isNaN(parsedValue) && (parsedValue < 0 || parsedValue > 100)) error = "Marketplace discount must be between 0% and 100%.";
            else if (isNaN(parsedValue) && value === "") parsedValue = null;
        }

        if (error) {
            setErrors(prev => ({ ...prev, [fieldKey]: error }));
            return;
        }
        setErrors(prev => ({ ...prev, [fieldKey]: "" }));

        setCurrentProductOption(prev => {
            const updated = { ...prev, [fieldKey]: parsedValue };
            const originalPrice = fieldKey === "marketplaceOriginalPrice" ? parsedValue : prev.marketplaceOriginalPrice;
            const discount = fieldKey === "marketplaceDiscount" ? parsedValue : prev.marketplaceDiscount;
            if (typeof originalPrice === 'number' && !isNaN(originalPrice) && typeof discount === 'number' && !isNaN(discount)) {
                updated.marketplaceDiscountPrice = Math.floor(originalPrice - (originalPrice * discount) / 100);
            } else {
                updated.marketplaceDiscountPrice = "";
            }
            return updated;
        });
    };

    const handleImageUpload = (e) => {
        const files = Array.from(e.target.files);

        // Add files to formData.images without uploading
        const newImages = files.map((file) => ({
            file, // Store the file for later upload
            preview: URL.createObjectURL(file), // Local preview
            isUploading: false, // Not uploaded yet
        }));

        setFormData((prevData) => ({
            ...prevData,
            images: [...prevData.images, ...newImages],
        }));

        // Reset file input value after selection
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        setIsSubmitting(true); // Start loader
        try {
            // Upload images to S3
            const uploadedImages = [];
            for (const image of formData.images) {
                if (image.file) { // Only upload new images
                    const optimizedPreview = await optimizeAndConvertToWebp(image.file);
                    const branch = "zun";
                    const fileType = "image/webp";
                    const fileName = `${branch}${Date.now()}.webp`;
                    const publicUrl = await uploadImageToS3Bucket(optimizedPreview, fileType, fileName);
                    uploadedImages.push({ preview: publicUrl, fileType, fileName });
                } else {
                    uploadedImages.push(image); // Keep already uploaded images
                }
            }

            // Update formData with uploaded images
            const updatedFormData = {
                ...formData,
                images: uploadedImages,
            };

            // Prepare request data
            const couponIds = coupons.map((coupon) => coupon.value);
            const couponIdsOffline = couponsOffline.map((coupon) => coupon.value);
            const categoryId = updatedFormData.category?.value || null;
            const sectionIds = sections.map((section) => section.value);

            // Check if main metric has sub-units at submission time
            const hasSubUnits = mainMetric && mainMetric.supportingMetricLabel && mainMetric.supportingMetricLabel.trim() !== '';

            // Create unified product options with optional offline pricing
            const restructuredProductOptions = productOptions.map((option) => {
                let finalWeightValue;
                let unified;

                if (hasSubUnits) {
                    // Metric has sub-units - use the weight value and selected metric
                    finalWeightValue = parseFloat(option.weightValue);

                    // If supporting metric was selected, convert value to primary
                    if (option.selectedMetric?.metricType === 'supporting') {
                        // Convert supporting to primary using conversionFactor
                        finalWeightValue = finalWeightValue * option.selectedMetric.conversionFactor;
                    }

                    // Store the SELECTED metric's ID, label, and type (not the primary metric's)
                    unified = {
                        weight: {
                            weightValue: finalWeightValue, // Converted to primary metric value
                            metricId: option.selectedMetric?.metricId || mainMetric?.metricId || null,
                            metricLabel: option.selectedMetric?.label || mainMetric?.label || "",
                            metricType: option.selectedMetric?.metricType || 'primary',
                            conversionFactor: option.selectedMetric?.conversionFactor || 1,
                            weightLabel: option.weightLabel
                        },
                        originalPrice: Number(option.originalPrice),
                        discount: Number(option.discount?.value || option.discount),
                        discountPrice: parseFloat(option.discountPrice),
                        _id: option._id,
                        barcode: option.barcode || '',
                    };
                } else {
                    // Metric has NO sub-units (like Unit, Pair) - set default weight values
                    // Use 1 as default weight value since it's counted as individual units
                    unified = {
                        weight: {
                            weightValue: 1, // Default to 1 for unit-based metrics
                            metricId: mainMetric?.metricId || null,
                            metricLabel: mainMetric?.label || "",
                            metricType: 'primary',
                            conversionFactor: 1,
                            weightLabel: option.weightLabel
                        },
                        originalPrice: Number(option.originalPrice),
                        discount: Number(option.discount?.value || option.discount),
                        discountPrice: parseFloat(option.discountPrice),
                        _id: option._id,
                        barcode: option.barcode || '',
                    };
                }

                // Add offline pricing if different prices are used and product is for offline
                // Only store the basic pricing, GST calculations will be done dynamically
                if (option.useDifferentOfflinePrice && isOfflineProduct) {
                    unified.offlinePrice = {
                        originalPrice: Number(option.offlineOriginalPrice),
                        discount: Number(option.offlineDiscount),
                        discountPrice: parseFloat(option.offlineDiscountPrice)
                    };
                }

                // Add marketplace pricing if a different price is used and product is for marketplace
                if (option.useDifferentMarketplacePrice && isMarketplaceProduct) {
                    unified.marketplacePrice = {
                        originalPrice: Number(option.marketplaceOriginalPrice),
                        discount: Number(option.marketplaceDiscount),
                        discountPrice: parseFloat(option.marketplaceDiscountPrice)
                    };
                }

                // Add bulk offers if present
                if (option.bulkOffers && option.bulkOffers.length > 0) {
                    unified.bulkOffers = option.bulkOffers.map(bo => ({
                        minQuantity: Number(bo.minQuantity),
                        discountPercentage: Number(bo.discountPercentage)
                    }));
                }
                if (option.isFlashDiscount) {
                    unified.flashDiscount = {
                        enabled: true,
                        discountPrice: Number(option.flashDiscountPrice),
                        minimumCartValue: Number(option.flashMinimumCartValue || 0),
                        maxAllowedQuantityInOneOrder: Number(option.maxAllowedQuantityInOneOrder || 1),
                    };
                }
                if (option.expiryDate) {
                    unified.expiryDate = option.expiryDate;
                }

                return unified;
            });

            // NEW: Upload option-specific images for each product option
            const restructuredProductOptionsWithImages = await Promise.all(
                restructuredProductOptions.map(async (unified, index) => {
                    const originalOption = productOptions[index];
                    if (originalOption.images && originalOption.images.length > 0) {
                        const uploadedOptionImages = [];
                        for (const image of originalOption.images) {
                            if (image.file) { // Only upload new images
                                const optimizedPreview = await optimizeAndConvertToWebp(image.file);
                                const branch = "zun";
                                const fileType = "image/webp";
                                const fileName = `${branch}/options/${Date.now()}_${Math.random().toString(36).substring(7)}.webp`;
                                const publicUrl = await uploadImageToS3Bucket(optimizedPreview, fileType, fileName);
                                uploadedOptionImages.push({ preview: publicUrl, fileType, fileName });
                            } else {
                                uploadedOptionImages.push(image); // Keep already uploaded images
                            }
                        }
                        return { ...unified, images: uploadedOptionImages };
                    }
                    return unified; // No option-specific images
                })
            );

            // FEATURE 2: Process multi-attribute variant combinations as productOptions
            // This ensures inventory is created for each variant combination
            async function processMultiAttributeProductOptions() {
                const processed = [];
                for (const combo of variantCombinations) {
                    const combinationLabel = getCombinationLabel(combo.selectedOptions);

                    // Create productOption structure matching regular product options
                    const productOption = {
                        // Weight structure using combinationLabel as weightLabel
                        weight: {
                            weightValue: 1, // Default to 1 for multi-attribute variants
                            metricId: mainMetric?.metricId || null,
                            metricLabel: mainMetric?.label || "",
                            metricType: 'primary',
                            conversionFactor: 1,
                            weightLabel: combinationLabel // Use combination label as weight label
                        },
                        originalPrice: Number(combo.originalPrice),
                        discount: Number(combo.discount),
                        discountPrice: parseFloat(combo.discountPrice),
                        barcode: combo.barcode || '',
                        _id: combo._id, // Keep existing _id if editing
                        // Multi-attribute specific fields
                        selectedOptions: combo.selectedOptions,
                        combinationLabel: combinationLabel,
                    };

                    // Add offline pricing if applicable
                    if (combo.useDifferentOfflinePrice && isOfflineProduct) {
                        productOption.offlinePrice = {
                            originalPrice: Number(combo.offlineOriginalPrice),
                            discount: Number(combo.offlineDiscount),
                            discountPrice: parseFloat(combo.offlineDiscountPrice)
                        };
                    }

                    // Add marketplace pricing if applicable
                    if (combo.useDifferentMarketplacePrice && isMarketplaceProduct) {
                        productOption.marketplacePrice = {
                            originalPrice: Number(combo.marketplaceOriginalPrice),
                            discount: Number(combo.marketplaceDiscount),
                            discountPrice: parseFloat(combo.marketplaceDiscountPrice)
                        };
                    }

                    // Upload variant-specific images
                    if (combo.images && combo.images.length > 0) {
                        const uploadedVariantImages = [];
                        for (const image of combo.images) {
                            if (image.file) {
                                const optimizedPreview = await optimizeAndConvertToWebp(image.file);
                                const branch = "zun";
                                const fileType = "image/webp";
                                const fileName = `${branch}/variants/${Date.now()}_${Math.random().toString(36).substring(7)}.webp`;
                                const publicUrl = await uploadImageToS3Bucket(optimizedPreview, fileType, fileName);
                                uploadedVariantImages.push({ preview: publicUrl, fileType, fileName });
                            } else {
                                uploadedVariantImages.push(image);
                            }
                        }
                        productOption.images = uploadedVariantImages;
                    }

                    processed.push(productOption);
                }
                return processed;
            }

            // For multi-attribute mode, use processed variant combinations as productOptions
            const finalProductOptions = useMultiAttributeMode
                ? await processMultiAttributeProductOptions()
                : restructuredProductOptionsWithImages;

            const requestData = {
                ...updatedFormData,
                images: uploadedImages, // Explicitly include uploaded images
                variantName: updatedFormData.variantName || '', // Variant display name for product variants
                coupons: couponIds,
                couponsOffline: couponIdsOffline,
                category: categoryId,
                sections: sectionIds,
                productOptions: finalProductOptions, // Use unified productOptions for both modes (enables inventory creation)
                isOnlineProduct: isOnlineProduct,
                isOfflineProduct: isOfflineProduct,
                isMarketplaceProduct: isMarketplaceProduct,
                commonInventoryType: hasSubUnits ? commonInventoryType : false, // Only set common inventory if metric has sub-units
                barcode: updatedFormData.barcode || '',
                vendorId: updatedFormData.vendorId || null, // Optional vendor ID
                hsnNumber: updatedFormData.hsnNumber || '', // Optional HSN number
                mainMetric: mainMetric ? {
                    metricId: mainMetric.metricId,
                    metricLabel: mainMetric.label,
                    metricName: mainMetric.metricName
                } : null, // Store main metric at product level
                // FEATURE 2: Multi-Attribute Mode Data (optionGroups for UI, productOptions for inventory)
                useMultiAttributeMode: useMultiAttributeMode,
                optionGroups: useMultiAttributeMode ? optionGroups : [],
                // FEATURE 3: Dynamic Product Details
                productHighlights: productHighlights.filter(h => h.text.trim()),
                productDetailsTabs: productDetailsTabs.filter(t => t.sections.length > 0),
                showcaseImages: await processShowcaseImages(),
            };

            // Helper function to upload showcase images
            async function processShowcaseImages() {
                if (showcaseImages.length === 0) return [];
                const uploaded = [];
                for (const image of showcaseImages) {
                    if (image.file) {
                        const optimizedPreview = await optimizeAndConvertToWebp(image.file);
                        const branch = "zun";
                        const fileType = "image/webp";
                        const fileName = `${branch}/showcase/${Date.now()}_${Math.random().toString(36).substring(7)}.webp`;
                        const publicUrl = await uploadImageToS3Bucket(optimizedPreview, fileType, fileName);
                        uploaded.push({ preview: publicUrl, fileType, fileName });
                    } else {
                        uploaded.push(image);
                    }
                }
                return uploaded;
            }

            // Call create or update API
            let data;
            if (location.state && location.state._id) {
                data = await updateProduct({ ...requestData, _id: location.state._id });
            } else {
                data = await createProduct(requestData);
            }

            if (data.success) {
                // Delete removed images from S3
                for (const image of removedImages) {
                    await deleteImageFromS3({ fileName: image.fileName });
                }

                // Clear removedImages state after deletion
                setRemovedImages([]);

                navigate(-1);
                // Refresh master counts after successful creation
                await fetchMasterCounts();
            } else {
                console.error("Failed to save product:", data.message);
                setSnackBarMessage(data.message || "Failed to save product");
                setIsSnackBarVisible(true);
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            toast.error(error.message || "Failed to create/update product.");
        } finally {
            setIsSubmitting(false); // Stop loader
        }
    };

    const removeImage = (image) => {
        setFormData((prevData) => ({
            ...prevData,
            images: prevData.images.filter((img) => img.preview !== image.preview),
        }));

        // Add the removed image to the removedImages state
        if (image.fileName) {
            setRemovedImages((prev) => [...prev, image]);
        }

        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };

    const handleToggleChange = () => {
        const isHidingReviews = !formData.hideReviews; // Calculate the new state
        setFormData({ ...formData, hideReviews: isHidingReviews });

        // Show SnackBar message only when the toggle becomes active
        if (isHidingReviews) {
            setSnackBarMessage("Reviews got hidden!");
            setIsSnackBarVisible(true);
        }
    };

    const handleInputChange = (e) => {
        if (!e || !e.target) {
            console.error("Event or event target is undefined");
            return;
        }
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    };

    const handleAddProductOption = () => {
        if (!validateProductOption()) return;

        setProductOptions((prev) => [...prev, currentProductOption]);
        setCurrentProductOption({
            weightValue: "",
            selectedMetric: null,
            weightLabel: "",
            originalPrice: "",
            discount: null,
            discountPrice: "",
            barcode: "",
            useDifferentOfflinePrice: false,
            offlineOriginalPrice: "",
            offlineDiscount: null,
            offlineDiscountPrice: "",
            mainMetricLabel: "",
            mainMetricId: null,
            images: [], // Reset images for new option
            bulkOffers: [],
            isFlashDiscount: false,
            flashDiscountPrice: "",
            flashMinimumCartValue: "",
            maxAllowedQuantityInOneOrder: "",
            expiryDate: "",
        });
        setIsModalOpen(false);
    };

    const handleEditOption = (index, event) => {
        event.preventDefault();
        event.stopPropagation();
        const selectedOption = productOptions[index];
        setEditOptionIndex(index);

        // Check if the selected metric is compatible with current mainMetric
        let validatedSelectedMetric = selectedOption.selectedMetric;
        if (mainMetric && selectedOption.selectedMetric) {
            // Check if selectedMetric belongs to current mainMetric
            const isCompatible = metrics.some(m =>
                m.metricId === mainMetric.metricId &&
                m.metricId === selectedOption.selectedMetric.metricId &&
                (m.metricType === 'primary' || m.metricType === 'supporting')
            );
            // If not compatible, clear it
            if (!isCompatible) {
                validatedSelectedMetric = null;
            }
        }

        setCurrentProductOption({
            ...selectedOption,
            selectedMetric: validatedSelectedMetric,
            useDifferentOfflinePrice: selectedOption.useDifferentOfflinePrice || false,
            offlineOriginalPrice: selectedOption.offlineOriginalPrice || "",
            offlineDiscount: selectedOption.offlineDiscount || null,
            offlineDiscountPrice: selectedOption.offlineDiscountPrice || "",
            mainMetricLabel: mainMetric?.label || selectedOption.mainMetricLabel || "",
            mainMetricId: mainMetric?.metricId || selectedOption.mainMetricId || null,
            images: selectedOption.images || [], // Load existing option images
            bulkOffers: selectedOption.bulkOffers || [],
            isFlashDiscount: !!selectedOption.isFlashDiscount,
            flashDiscountPrice: selectedOption.flashDiscountPrice ?? "",
            flashMinimumCartValue: selectedOption.flashMinimumCartValue ?? "",
            maxAllowedQuantityInOneOrder: selectedOption.maxAllowedQuantityInOneOrder ?? "",
            expiryDate: selectedOption.expiryDate || "",
        });

        setIsModalOpen(true);
    };

    const handleSaveEditedOption = () => {
        if (!validateProductOption()) return;

        setProductOptions((prev) =>
            prev.map((option, index) =>
                index === editOptionIndex ? currentProductOption : option
            )
        );
        setEditOptionIndex(null);
        setCurrentProductOption({
            weightValue: "",
            selectedMetric: null,
            weightLabel: "",
            originalPrice: "",
            discount: null,
            discountPrice: "",
            barcode: "",
            useDifferentOfflinePrice: false,
            offlineOriginalPrice: "",
            offlineDiscount: null,
            offlineDiscountPrice: "",
            mainMetricLabel: "",
            mainMetricId: null,
            images: [], // Reset images
            bulkOffers: [],
            isFlashDiscount: false,
            flashDiscountPrice: "",
            flashMinimumCartValue: "",
            maxAllowedQuantityInOneOrder: "",
            expiryDate: "",
        });
        setIsModalOpen(false);
    };

    const handleDeleteOption = (event, index) => {
        event.preventDefault();
        event.stopPropagation();
        setProductOptions((prev) => prev.filter((_, i) => i !== index));
    };

    // NEW: Handle option-specific image upload
    const handleOptionImageUpload = (e) => {
        const files = Array.from(e.target.files);

        const newImages = files.map((file) => ({
            file, // Store the file for later upload
            preview: URL.createObjectURL(file), // Local preview
            isUploading: false,
        }));

        setCurrentProductOption((prev) => ({
            ...prev,
            images: [...(prev.images || []), ...newImages],
        }));

        // Reset file input
        if (optionImageInputRef.current) {
            optionImageInputRef.current.value = null;
        }
    };

    // NEW: Remove option-specific image
    const removeOptionImage = (imageIndex) => {
        setCurrentProductOption((prev) => ({
            ...prev,
            images: prev.images.filter((_, idx) => idx !== imageIndex),
        }));
    };

    const handleCancelAddProductOption = () => {
        setIsModalOpen(false);
        setCurrentProductOption({
            weightValue: "",
            selectedMetric: null,
            weightLabel: "",
            originalPrice: "",
            discount: null,
            discountPrice: "",
            barcode: "",
            useDifferentOfflinePrice: false,
            offlineOriginalPrice: "",
            offlineDiscount: null,
            offlineDiscountPrice: "",
            mainMetricLabel: "",
            mainMetricId: null,
            bulkOffers: [],
            isFlashDiscount: false,
            flashDiscountPrice: "",
            flashMinimumCartValue: "",
            maxAllowedQuantityInOneOrder: "",
            expiryDate: "",
        });
        setErrors({});
    };

    // Add images field to cancelAddProductOption reset
    // eslint-disable-next-line no-unused-vars -- retained default option shape for reset helpers
    const resetCurrentProductOption = {
        weightValue: "",
        selectedMetric: null,
        weightLabel: "",
        originalPrice: "",
        discount: null,
        discountPrice: "",
        barcode: "",
        useDifferentOfflinePrice: false,
        offlineOriginalPrice: "",
        offlineDiscount: null,
        offlineDiscountPrice: "",
        mainMetricLabel: "",
        mainMetricId: null,
        images: [],
        bulkOffers: [],
        isFlashDiscount: false,
        flashDiscountPrice: "",
        flashMinimumCartValue: "",
        maxAllowedQuantityInOneOrder: "",
        expiryDate: "",
    };

    const handleCategoryChange = (selectedCategoryOption) => {
        setErrors((prevErrors) => ({ ...prevErrors, category: "" }));
        setFormData({ ...formData, category: selectedCategoryOption });
    };

    // =====================================================================
    // FEATURE 2: MULTI-ATTRIBUTE OPTIONS HANDLERS
    // =====================================================================

    // Add value to current option group
    const handleAddOptionGroupValue = () => {
        const trimmedValue = currentOptionGroupValue.trim();
        if (!trimmedValue) return;
        if (currentOptionGroup.values.includes(trimmedValue)) {
            setSnackBarMessage("This value already exists in the group");
            setIsSnackBarVisible(true);
            return;
        }
        setCurrentOptionGroup(prev => ({
            ...prev,
            values: [...prev.values, trimmedValue]
        }));
        setCurrentOptionGroupValue("");
    };

    // Remove value from option group
    const handleRemoveOptionGroupValue = (valueIndex) => {
        setCurrentOptionGroup(prev => ({
            ...prev,
            values: prev.values.filter((_, idx) => idx !== valueIndex)
        }));
    };

    // Validate option group
    const validateOptionGroup = () => {
        const newErrors = {};
        if (!currentOptionGroup.groupName || currentOptionGroup.groupName.trim() === "") {
            newErrors.optionGroupName = "Group name is required (e.g., RAM, ROM, Color)";
        }
        if (currentOptionGroup.values.length < 2) {
            newErrors.optionGroupValues = "At least 2 values are required for an option group";
        }
        // Check for duplicate group name
        const existingGroup = optionGroups.find((g, idx) =>
            g.groupName.toLowerCase() === currentOptionGroup.groupName.trim().toLowerCase() &&
            idx !== editOptionGroupIndex
        );
        if (existingGroup) {
            newErrors.optionGroupName = "An option group with this name already exists";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Add option group
    const handleAddOptionGroup = () => {
        if (!validateOptionGroup()) return;
        setOptionGroups(prev => [...prev, {
            groupName: currentOptionGroup.groupName.trim(),
            values: currentOptionGroup.values
        }]);
        setCurrentOptionGroup({ groupName: "", values: [] });
        setIsOptionGroupModalOpen(false);
        // Clear existing variant combinations when groups change
        setVariantCombinations([]);
    };

    // Edit option group
    const handleEditOptionGroup = (index) => {
        setEditOptionGroupIndex(index);
        setCurrentOptionGroup({ ...optionGroups[index] });
        setIsOptionGroupModalOpen(true);
    };

    // Save edited option group
    const handleSaveEditedOptionGroup = () => {
        if (!validateOptionGroup()) return;
        setOptionGroups(prev => prev.map((group, idx) =>
            idx === editOptionGroupIndex
                ? { groupName: currentOptionGroup.groupName.trim(), values: currentOptionGroup.values }
                : group
        ));
        setEditOptionGroupIndex(null);
        setCurrentOptionGroup({ groupName: "", values: [] });
        setIsOptionGroupModalOpen(false);
        // Clear variant combinations when groups change (values might have changed)
        setVariantCombinations([]);
    };

    // Delete option group
    const handleDeleteOptionGroup = (index) => {
        setOptionGroups(prev => prev.filter((_, idx) => idx !== index));
        // Clear variant combinations when groups are deleted
        setVariantCombinations([]);
    };

    // Cancel option group modal
    const handleCancelOptionGroupModal = () => {
        setIsOptionGroupModalOpen(false);
        setCurrentOptionGroup({ groupName: "", values: [] });
        setCurrentOptionGroupValue("");
        setEditOptionGroupIndex(null);
        setErrors({});
    };

    // Generate all possible combinations from option groups
    // eslint-disable-next-line no-unused-vars -- retained variant combination helper
    const generateAllCombinations = () => {
        if (optionGroups.length === 0) return [];

        const combine = (groups, current = {}) => {
            if (groups.length === 0) return [current];

            const [first, ...rest] = groups;
            const results = [];

            for (const value of first.values) {
                results.push(...combine(rest, { ...current, [first.groupName]: value }));
            }

            return results;
        };

        return combine(optionGroups);
    };

    // Check if a combination already exists
    const isCombinationExists = (selectedOptions) => {
        return variantCombinations.some(combo => {
            return Object.keys(selectedOptions).every(key =>
                combo.selectedOptions[key] === selectedOptions[key]
            );
        });
    };

    // Validate variant combination
    const validateVariantCombination = () => {
        const newErrors = {};

        // Check all option groups are selected
        for (const group of optionGroups) {
            if (!currentVariantCombination.selectedOptions[group.groupName]) {
                newErrors.selectedOptions = `Please select a value for ${group.groupName}`;
                break;
            }
        }

        // Price validations
        if (typeof currentVariantCombination.originalPrice !== 'number' || isNaN(currentVariantCombination.originalPrice)) {
            newErrors.variantOriginalPrice = "Original price is required";
        }
        if (typeof currentVariantCombination.discount !== 'number' || isNaN(currentVariantCombination.discount) || currentVariantCombination.discount < 0 || currentVariantCombination.discount > 100) {
            newErrors.variantDiscount = "Discount must be between 0% and 100%";
        }

        // Offline price validations
        if (currentVariantCombination.useDifferentOfflinePrice && isOfflineProduct) {
            if (typeof currentVariantCombination.offlineOriginalPrice !== 'number' || isNaN(currentVariantCombination.offlineOriginalPrice)) {
                newErrors.variantOfflineOriginalPrice = "Offline original price is required";
            }
            if (typeof currentVariantCombination.offlineDiscount !== 'number' || isNaN(currentVariantCombination.offlineDiscount) || currentVariantCombination.offlineDiscount < 0 || currentVariantCombination.offlineDiscount > 100) {
                newErrors.variantOfflineDiscount = "Offline discount must be between 0% and 100%";
            }
        }

        // Check for duplicate combination (only when adding new)
        if (editVariantCombinationIndex === null && isCombinationExists(currentVariantCombination.selectedOptions)) {
            newErrors.selectedOptions = "This combination already exists";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handle variant combination price change
    const handleVariantCombinationChange = (field, value, isOffline = false) => {
        let parsedValue = value;
        const fieldKey = isOffline ? `offline${field.charAt(0).toUpperCase() + field.slice(1)}` : field;

        if (field === "originalPrice") {
            parsedValue = parseInt(value, 10);
            if (isNaN(parsedValue)) parsedValue = "";
        } else if (field === "discount") {
            parsedValue = parseInt(value, 10);
            if (isNaN(parsedValue)) parsedValue = "";
        }

        // Calculate discount price
        setCurrentVariantCombination(prev => {
            const updated = { ...prev, [fieldKey]: parsedValue };

            // Auto-calculate discount price for online
            if (!isOffline && (field === "originalPrice" || field === "discount")) {
                const originalPrice = field === "originalPrice" ? parsedValue : prev.originalPrice;
                const discount = field === "discount" ? parsedValue : prev.discount;
                if (typeof originalPrice === 'number' && typeof discount === 'number') {
                    updated.discountPrice = (originalPrice - (originalPrice * discount / 100)).toFixed(2);
                }
            }

            // Auto-calculate discount price for offline
            if (isOffline && (field === "originalPrice" || field === "discount")) {
                const originalPrice = field === "originalPrice" ? parsedValue : prev.offlineOriginalPrice;
                const discount = field === "discount" ? parsedValue : prev.offlineDiscount;
                if (typeof originalPrice === 'number' && typeof discount === 'number') {
                    updated.offlineDiscountPrice = (originalPrice - (originalPrice * discount / 100)).toFixed(2);
                }
            }

            return updated;
        });
    };

    // Add variant combination
    const handleAddVariantCombination = () => {
        if (!validateVariantCombination()) return;
        setVariantCombinations(prev => [...prev, { ...currentVariantCombination }]);
        resetVariantCombination();
        setIsVariantCombinationModalOpen(false);
    };

    // Edit variant combination
    const handleEditVariantCombination = (index) => {
        setEditVariantCombinationIndex(index);
        setCurrentVariantCombination({ ...variantCombinations[index] });
        setIsVariantCombinationModalOpen(true);
    };

    // Save edited variant combination
    const handleSaveEditedVariantCombination = () => {
        if (!validateVariantCombination()) return;
        setVariantCombinations(prev => prev.map((combo, idx) =>
            idx === editVariantCombinationIndex ? { ...currentVariantCombination } : combo
        ));
        setEditVariantCombinationIndex(null);
        resetVariantCombination();
        setIsVariantCombinationModalOpen(false);
    };

    // Delete variant combination
    const handleDeleteVariantCombination = (index) => {
        setVariantCombinations(prev => prev.filter((_, idx) => idx !== index));
    };

    // Reset variant combination form
    const resetVariantCombination = () => {
        setCurrentVariantCombination({
            selectedOptions: {},
            originalPrice: "",
            discount: null,
            discountPrice: "",
            barcode: "",
            useDifferentOfflinePrice: false,
            offlineOriginalPrice: "",
            offlineDiscount: null,
            offlineDiscountPrice: "",
            images: [],
        });
        setEditVariantCombinationIndex(null);
        setErrors({});
    };

    // Cancel variant combination modal
    const handleCancelVariantCombinationModal = () => {
        setIsVariantCombinationModalOpen(false);
        resetVariantCombination();
    };

    // Handle variant-specific image upload
    const handleVariantImageUpload = (e) => {
        const files = Array.from(e.target.files);
        const newImages = files.map((file) => ({
            file,
            preview: URL.createObjectURL(file),
            isUploading: false,
        }));
        setCurrentVariantCombination(prev => ({
            ...prev,
            images: [...(prev.images || []), ...newImages],
        }));
        if (variantImageInputRef.current) {
            variantImageInputRef.current.value = null;
        }
    };

    // Remove variant-specific image
    const removeVariantImage = (imageIndex) => {
        setCurrentVariantCombination(prev => ({
            ...prev,
            images: prev.images.filter((_, idx) => idx !== imageIndex),
        }));
    };

    // Generate combination label for display
    const getCombinationLabel = (selectedOptions) => {
        return Object.entries(selectedOptions).map(([key, value]) => `${key}: ${value}`).join(' | ');
    };

    // Get the number of possible combinations
    const getTotalPossibleCombinations = () => {
        if (optionGroups.length === 0) return 0;
        return optionGroups.reduce((total, group) => total * group.values.length, 1);
    };

    // Toggle multi-attribute mode
    const handleToggleMultiAttributeMode = () => {
        if (useMultiAttributeMode) {
            // Switching to simple mode - clear multi-attribute data
            setOptionGroups([]);
            setVariantCombinations([]);
        } else {
            // Switching to multi-attribute mode - clear simple options
            setProductOptions([]);
        }
        setUseMultiAttributeMode(!useMultiAttributeMode);
    };

    // =====================================================================
    // END FEATURE 2 HANDLERS
    // =====================================================================

    // =====================================================================
    // FEATURE 3: DYNAMIC PRODUCT DETAILS HANDLERS
    // =====================================================================

    // Add Product Highlight (Plain text only - no icons)
    const handleAddHighlight = () => {
        if (!currentHighlight.text.trim()) {
            setSnackBarMessage("Please enter highlight text");
            setIsSnackBarVisible(true);
            return;
        }
        if (editHighlightIndex !== null) {
            setProductHighlights(prev => prev.map((h, idx) =>
                idx === editHighlightIndex ? { text: currentHighlight.text } : h
            ));
            setEditHighlightIndex(null);
        } else {
            setProductHighlights(prev => [...prev, { text: currentHighlight.text }]);
        }
        setCurrentHighlight({ text: '' });
        setIsHighlightModalOpen(false);
    };

    // Edit Product Highlight
    const handleEditHighlight = (index) => {
        setEditHighlightIndex(index);
        setCurrentHighlight({ text: productHighlights[index].text });
        setIsHighlightModalOpen(true);
    };

    // Delete Product Highlight
    const handleDeleteHighlight = (index) => {
        setProductHighlights(prev => prev.filter((_, idx) => idx !== index));
    };

    // Add/Save Custom Tab (Label)
    const handleSaveTab = () => {
        if (!currentTab.tabName.trim()) {
            setSnackBarMessage("Please enter tab name");
            setIsSnackBarVisible(true);
            return;
        }
        if (editTabIndex !== null) {
            setProductDetailsTabs(prev => prev.map((t, idx) =>
                idx === editTabIndex ? { ...currentTab } : t
            ));
            setEditTabIndex(null);
        } else {
            setProductDetailsTabs(prev => [...prev, { ...currentTab }]);
        }
        setCurrentTab({ tabName: '', sections: [] });
        setIsTabModalOpen(false);
    };

    // Edit Tab
    const handleEditTab = (index) => {
        setEditTabIndex(index);
        setCurrentTab({ ...productDetailsTabs[index] });
        setIsTabModalOpen(true);
    };

    // Delete Tab
    const handleDeleteTab = (index) => {
        setProductDetailsTabs(prev => prev.filter((_, idx) => idx !== index));
    };

    // Add field to current section
    const handleAddFieldToSection = () => {
        if (!currentField.fieldName.trim() || !currentField.fieldValue.trim()) {
            setSnackBarMessage("Please enter both field name and value");
            setIsSnackBarVisible(true);
            return;
        }
        setCurrentSection(prev => ({
            ...prev,
            fields: [...prev.fields, { ...currentField }]
        }));
        setCurrentField({ fieldName: '', fieldValue: '' });
    };

    // Remove field from current section
    const handleRemoveFieldFromSection = (index) => {
        setCurrentSection(prev => ({
            ...prev,
            fields: prev.fields.filter((_, idx) => idx !== index)
        }));
    };

    // Save Section to selected Tab
    const handleSaveSection = () => {
        if (!currentSection.sectionName.trim()) {
            setSnackBarMessage("Please enter section name");
            setIsSnackBarVisible(true);
            return;
        }
        if (currentSection.fields.length === 0) {
            setSnackBarMessage("Please add at least one field to the section");
            setIsSnackBarVisible(true);
            return;
        }
        if (selectedTabForSection === null) {
            setSnackBarMessage("Please select a tab first");
            setIsSnackBarVisible(true);
            return;
        }

        if (editSectionIndex !== null) {
            // Editing existing section
            setProductDetailsTabs(prev => prev.map((tab, tabIdx) => {
                if (tabIdx === selectedTabForSection) {
                    return {
                        ...tab,
                        sections: tab.sections.map((s, sIdx) =>
                            sIdx === editSectionIndex ? { ...currentSection } : s
                        )
                    };
                }
                return tab;
            }));
            setEditSectionIndex(null);
        } else {
            // Adding new section
            setProductDetailsTabs(prev => prev.map((tab, tabIdx) => {
                if (tabIdx === selectedTabForSection) {
                    return {
                        ...tab,
                        sections: [...tab.sections, { ...currentSection }]
                    };
                }
                return tab;
            }));
        }
        setCurrentSection({ sectionName: '', fields: [] });
        setCurrentField({ fieldName: '', fieldValue: '' });
        setIsSectionModalOpen(false);
    };

    // Edit Section in a Tab
    const handleEditSection = (tabIndex, sectionIndex) => {
        setSelectedTabForSection(tabIndex);
        setEditSectionIndex(sectionIndex);
        setCurrentSection({ ...productDetailsTabs[tabIndex].sections[sectionIndex] });
        setIsSectionModalOpen(true);
    };

    // Delete Section from a Tab
    const handleDeleteSection = (tabIndex, sectionIndex) => {
        setProductDetailsTabs(prev => prev.map((tab, tabIdx) => {
            if (tabIdx === tabIndex) {
                return {
                    ...tab,
                    sections: tab.sections.filter((_, sIdx) => sIdx !== sectionIndex)
                };
            }
            return tab;
        }));
    };

    // Handle Showcase Image Upload
    const handleShowcaseImageUpload = (e) => {
        const files = Array.from(e.target.files);
        const newImages = files.map((file) => ({
            file,
            preview: URL.createObjectURL(file),
            isUploading: false,
        }));
        setShowcaseImages(prev => [...prev, ...newImages]);
        if (showcaseImageInputRef.current) {
            showcaseImageInputRef.current.value = null;
        }
    };

    // Remove Showcase Image
    const removeShowcaseImage = (index) => {
        setShowcaseImages(prev => prev.filter((_, idx) => idx !== index));
    };

    // Check if any dynamic product details exist
    const hasDynamicProductDetails = () => {
        return productHighlights.length > 0 ||
            productDetailsTabs.length > 0 ||
            showcaseImages.length > 0;
    };

    // Check if any product options have option-specific images
    const hasAnyOptionSpecificImages = () => {
        return productOptions.some(option => option.images && option.images.length > 0);
    };

    // Check if common product images exist
    const hasCommonImages = () => {
        return formData.images && formData.images.length > 0;
    };

    // Import Product Detail Tabs from Last Created Product
    const handleImportTabsFromLastProduct = async () => {
        try {
            setIsImportingTabs(true);

            // Get current product ID if in edit mode to exclude it
            const excludeProductId = location.state?._id || null;

            const response = await getLastProductDetailsTabs({ excludeProductId });

            if (response?.success && response?.data?.productDetailsTabs?.length > 0) {
                // Deep clone the tabs to avoid reference issues
                const importedTabs = JSON.parse(JSON.stringify(response.data.productDetailsTabs));

                // Append imported tabs to existing tabs (don't replace)
                setProductDetailsTabs(prev => [...prev, ...importedTabs]);

                setSnackBarMessage(`Successfully imported ${importedTabs.length} tab(s) from "${response.data.productName}"`);
                setIsSnackBarVisible(true);
            } else {
                setSnackBarMessage("No product detail tabs found in previous products");
                setIsSnackBarVisible(true);
            }
        } catch (error) {
            console.error("Error importing tabs:", error);
            setSnackBarMessage(error?.message || "Failed to import tabs from last product");
            setIsSnackBarVisible(true);
        } finally {
            setIsImportingTabs(false);
        }
    };

    // =====================================================================
    // END FEATURE 3 HANDLERS
    // =====================================================================

    const handleAddNewLabelCategory = () => {
        setIsCategoryModalOpen(true);
        setNewCategoryImage(null); // Reset image when modal opens
        setNewCategoryImagePreview("");
    };

    const handleNewCategoryImageChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            // Basic validation for image type (you can add more)
            if (!file.type.startsWith('image/')) {
                toast.error('Please upload an image file.');
                return;
            }
            setNewCategoryImage(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setNewCategoryImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    // Save new category handler
    const handleSaveNewLabelCategory = async () => {
        setSaveAttempted(true);
        if (newLabelCategory.trim() === "") return; // Validation remains in handler
        if (!newCategoryImage) return;

        try {
            setIsSavingCategory(true);
            setIsUploading(true); // Indicate upload process

            let categoryImageUrl = null;
            if (newCategoryImage) {
                const optimizedPreview = await optimizeAndConvertToWebp(newCategoryImage);
                const branch = "zun"; // Assuming 'zun' is your branch
                const fileType = "image/webp";
                const fileName = `${branch}/category/${Date.now()}.webp`; // Organize category images in a subfolder
                categoryImageUrl = await uploadImageToS3Bucket(optimizedPreview, fileType, fileName);
            }

            const data = await createCatogory({ categoryName: newLabelCategory, categoryImage: categoryImageUrl }); // Send categoryImage URL

            if (data.success) {
                let localData = data.data?.length ? data.data.map(({ _id, categoryName, categoryImage }) => ({ value: _id, label: categoryName })) : [];
                setCategories(localData);
                setIsCategoryModalOpen(false);
                setNewLabelCategory("");
                setNewCategoryImage(null);
                setNewCategoryImagePreview("");
                setSnackBarMessage("Category created successfully!");
                setIsSnackBarVisible(true);
            } else {
                toast.error('Failed to save category');
            }
        } catch (error) {
            console.error('Error saving category:', error);
            toast.error('Failed to save category');
        } finally {
            setIsSavingCategory(false);
            setIsUploading(false);
        }
    };

    const handleCancelCategory = () => {
        setIsCategoryModalOpen(false);
        setNewLabelCategory("");
        setNewCategoryImage(null);
        setNewCategoryImagePreview("");
        setSaveAttempted(false);
    };

    const handleCouponsOffline = (selectedCoupons) => {
        setErrors((prevErrors) => ({ ...prevErrors, couponsOffline: [] }));
        setCouponsOffline(selectedCoupons);
        setFormData((prevFormData) => ({
            ...prevFormData,
            couponsOffline: selectedCoupons,
        }));
    };

    const handleCoupons = (selectedCoupons) => {
        setErrors((prevErrors) => ({ ...prevErrors, coupons: [] }));
        setCoupons(selectedCoupons);
    };

    const handleSections = (selectedSection) => {
        setErrors((prevErrors) => ({ ...prevErrors, sections: [] }));
        setSections(selectedSection);
        setFormData((prevFormData) => ({
            ...prevFormData,
            sections: selectedSection,
        }));
    };

    const getInputClass = (field) => {
        return errors[field] ? "border-red-500" : "border-gray-300";
    };


    const handleAccordionChange = (expandedIndexes) => {
        if (expandedIndexes.length > 0) {
            const expandedField = expandedIndexes[0]; // Assuming single-item expand behavior
            if (textAreaRefs.current[expandedField]) {
                textAreaRefs.current[expandedField].focus();
            }
        }
    };



    // Check limits based on which product types are selected
    const isEditMode = location.state && location.state._id;

    // For new products, check if any selected store type has reached its limit
    let isLimitReached = false;
    if (!isEditMode && masterCountData) {
        // Check online limit if online product is selected
        if (isOnlineProduct && masterCountData.online && masterCountData.online.limit !== Infinity) {
            if (masterCountData.online.count >= masterCountData.online.limit) {
                isLimitReached = true;
            }
        }
        // Check offline limit if offline product is selected
        if (isOfflineProduct && masterCountData.offline && masterCountData.offline.limit !== Infinity) {
            if (masterCountData.offline.count >= masterCountData.offline.limit) {
                isLimitReached = true;
            }
        }
    }

    return (
        <div className="bg-gradient-to-r from-indigo-200 to-blue-100 min-h-screen">
            <NavigateBack targetBack className="pl-3" />
            <div className="bg-white p-4 md:p-6 rounded-tl-2xl rounded-tr-2xl">
                {/* Page Header */}
                <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
                    <h1 className="text-2xl md:text-3xl font-bold text-gray-700">
                        {location.state ? 'Edit Product' : 'Create Product'}
                    </h1>

                    {/* Remaining Slots - Compact Display */}
                    {masterCountData && (
                        <div className="flex flex-wrap gap-3 mt-3 md:mt-0">
                            {enableOnlineStore && (
                                <div className="flex items-center gap-2 px-3 py-1.5 bg-blue-50 rounded-full border border-blue-200">
                                    <span className="text-xs font-medium text-gray-600">Online:</span>
                                    <span className={`text-sm font-bold ${masterCountData.online && masterCountData.online.limit !== Infinity && masterCountData.online.count >= masterCountData.online.limit ? 'text-red-500' : 'text-green-600'}`}>
                                        {masterCountData.online && masterCountData.online.limit !== Infinity ? Math.max(0, masterCountData.online.limit - masterCountData.online.count) : '∞'}
                                    </span>
                                    <span className="text-xs text-gray-400">left</span>
                                </div>
                            )}
                            {enableOfflineStore && (
                                <div className="flex items-center gap-2 px-3 py-1.5 bg-purple-50 rounded-full border border-purple-200">
                                    <span className="text-xs font-medium text-gray-600">Offline:</span>
                                    <span className={`text-sm font-bold ${masterCountData.offline && masterCountData.offline.limit !== Infinity && masterCountData.offline.count >= masterCountData.offline.limit ? 'text-red-500' : 'text-green-600'}`}>
                                        {masterCountData.offline && masterCountData.offline.limit !== Infinity ? Math.max(0, masterCountData.offline.limit - masterCountData.offline.count) : '∞'}
                                    </span>
                                    <span className="text-xs text-gray-400">left</span>
                                </div>
                            )}
                        </div>
                    )}
                </div>

                {/* ============================================================= */}
                {/* CLONE PRODUCT SECTION - Only visible when creating new product */}
                {/* ============================================================= */}
                {!location.state && (
                    <div className="mb-6">
                        <button
                            type="button"
                            onClick={() => setIsCloneExpanded(!isCloneExpanded)}
                            className="flex items-center gap-2 px-4 py-2.5 bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-lg hover:from-amber-100 hover:to-orange-100 transition-all duration-200 shadow-sm"
                        >
                            <FiCopy className="text-amber-600" size={18} />
                            <span className="text-sm font-semibold text-amber-700">Clone from Existing Product</span>
                            <FaChevronDown className={`text-amber-500 text-xs transition-transform duration-200 ${isCloneExpanded ? 'rotate-180' : ''}`} />
                        </button>

                        {isCloneExpanded && (
                            <div className="mt-3 p-4 bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-xl" ref={cloneSearchRef}>
                                <p className="text-xs text-amber-600 mb-2">Search and select a product to clone all its data (except images) into this form.</p>
                                <div className="relative">
                                    <input
                                        type="text"
                                        placeholder="Search product by name or ID..."
                                        value={cloneSearchTerm}
                                        autoComplete="off"
                                        onChange={(e) => handleCloneSearch(e.target.value)}
                                        className="w-full px-3 py-2.5 border border-amber-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-amber-400 focus:border-amber-400 bg-white"
                                    />
                                    {isCloneSearching && (
                                        <div className="absolute right-3 top-1/2 -translate-y-1/2">
                                            <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-amber-500"></div>
                                        </div>
                                    )}

                                    {/* Search Results Dropdown */}
                                    {showCloneDropdown && cloneSearchResults.length > 0 && (
                                        <div className="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-xl max-h-64 overflow-y-auto scrollbar-thin">
                                            {cloneSearchResults.map((product) => (
                                                <button
                                                    key={product._id}
                                                    type="button"
                                                    onClick={() => handleCloneProductSelect(product)}
                                                    className="w-full text-left px-4 py-3 hover:bg-amber-50 border-b border-gray-100 last:border-b-0 transition-colors duration-150"
                                                >
                                                    <div className="flex items-center gap-3">
                                                        {product.images && product.images[0]?.preview ? (
                                                            <img
                                                                src={product.images[0].preview}
                                                                alt=""
                                                                className="w-10 h-10 rounded-lg object-cover border border-gray-200 flex-shrink-0"
                                                            />
                                                        ) : (
                                                            <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center flex-shrink-0">
                                                                <span className="text-gray-400 text-xs">No img</span>
                                                            </div>
                                                        )}
                                                        <div className="min-w-0 flex-1">
                                                            <p className="text-sm font-medium text-gray-800 truncate">{product.productName}</p>
                                                            <div className="flex items-center gap-2 mt-0.5">
                                                                <span className="text-xs text-gray-500">ID: {product.productId}</span>
                                                                {product.productOptions && product.productOptions.length > 0 && (
                                                                    <span className="text-xs text-gray-400">
                                                                        | {product.productOptions.length} option{product.productOptions.length > 1 ? 's' : ''}
                                                                    </span>
                                                                )}
                                                                {product.productOptions && product.productOptions[0] && (
                                                                    <span className="text-xs font-medium text-green-600">
                                                                        ₹{product.productOptions[0].discountPrice || product.productOptions[0].originalPrice}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <FiCopy className="text-amber-400 flex-shrink-0" size={16} />
                                                    </div>
                                                </button>
                                            ))}
                                        </div>
                                    )}

                                    {/* No results */}
                                    {showCloneDropdown && cloneSearchTerm.trim() && cloneSearchResults.length === 0 && !isCloneSearching && (
                                        <div className="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-xl p-4 text-center">
                                            <p className="text-sm text-gray-500">No products found for "{cloneSearchTerm}"</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-6">

                    {/* ============================================================= */}
                    {/* SECTION 1: Store Type Selection */}
                    {/* ============================================================= */}
                    <div className="bg-gradient-to-r from-gray-50 to-slate-50 rounded-xl border border-gray-200 overflow-hidden">
                        <div className="px-4 py-3 bg-gradient-to-r from-slate-100 to-gray-100 border-b border-gray-200">
                            <h2 className="text-base md:text-lg font-semibold text-gray-700 flex items-center gap-2">
                                <span className="w-6 h-6 rounded-full bg-gray-600 text-white text-xs flex items-center justify-center font-bold">1</span>
                                Store Type
                            </h2>
                        </div>
                        <div className="p-4">
                            <div className="flex flex-wrap gap-4">
                                {enableOnlineStore && (
                                    <label className={`flex items-center gap-3 cursor-pointer px-4 py-3 rounded-lg border-2 transition-all duration-200 hover:shadow-md ${isOnlineProduct ? 'border-blue-500 bg-blue-50' : 'border-gray-200 bg-white'}`}>
                                        <input
                                            type="checkbox"
                                            checked={isOnlineProduct}
                                            onChange={(e) => setIsOnlineProduct(e.target.checked)}
                                            className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                        />
                                        <div>
                                            <span className="text-base font-medium text-gray-700 block">Online Store</span>
                                            <span className="text-xs text-gray-500">Sell on your website</span>
                                        </div>
                                    </label>
                                )}
                                {enableOfflineStore && (
                                    <label className={`flex items-center gap-3 cursor-pointer px-4 py-3 rounded-lg border-2 transition-all duration-200 hover:shadow-md ${isOfflineProduct ? 'border-purple-500 bg-purple-50' : 'border-gray-200 bg-white'}`}>
                                        <input
                                            type="checkbox"
                                            checked={isOfflineProduct}
                                            onChange={(e) => setIsOfflineProduct(e.target.checked)}
                                            className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                                        />
                                        <div>
                                            <span className="text-base font-medium text-gray-700 block">Offline Store (POS)</span>
                                            <span className="text-xs text-gray-500">Sell in physical store</span>
                                        </div>
                                    </label>
                                )}
                                {enableMarketplace && (
                                    <label className={`flex items-center gap-3 cursor-pointer px-4 py-3 rounded-lg border-2 transition-all duration-200 hover:shadow-md ${isMarketplaceProduct ? 'border-violet-500 bg-violet-50' : 'border-gray-200 bg-white'}`}>
                                        <input
                                            type="checkbox"
                                            checked={isMarketplaceProduct}
                                            onChange={(e) => setIsMarketplaceProduct(e.target.checked)}
                                            className="w-5 h-5 text-violet-600 border-gray-300 rounded focus:ring-violet-500"
                                        />
                                        <div>
                                            <span className="text-base font-medium text-gray-700 block">Marketplace (B2B)</span>
                                            <span className="text-xs text-gray-500">Sell to wholesale buyers</span>
                                        </div>
                                    </label>
                                )}
                            </div>
                            {errors.storeType && (
                                <p className="text-red-500 text-sm mt-3">{errors.storeType}</p>
                            )}
                        </div>
                    </div>

                    {/* ============================================================= */}
                    {/* SECTION 2: Basic Product Information */}
                    {/* ============================================================= */}
                    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
                        <div className="px-4 py-3 bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-gray-200">
                            <h2 className="text-base md:text-lg font-semibold text-gray-700 flex items-center gap-2">
                                <span className="w-6 h-6 rounded-full bg-blue-600 text-white text-xs flex items-center justify-center font-bold">2</span>
                                Basic Information
                            </h2>
                        </div>
                        <div className="p-4 space-y-4">
                            {/* Product Images */}
                            <div>
                                <label className="labelStyles">
                                    Upload Images (Common images for all Product Options)
                                </label>

                                {/* Info message when option-specific images exist */}
                                {hasAnyOptionSpecificImages() && (
                                    <div className="mb-3 p-3 bg-amber-50 border border-amber-200 rounded-lg flex items-start gap-2">
                                        <span className="text-amber-500 text-lg">⚠️</span>
                                        <div>
                                            <p className="text-amber-800 font-medium text-sm">Option-Specific Images Detected</p>
                                            <p className="text-amber-700 text-xs">Some product options already have their own images. Common images are disabled when option-specific images exist. Remove option images first if you want to use common images.</p>
                                        </div>
                                    </div>
                                )}

                                <div className={`relative border-dashed border-2 rounded-lg p-6 transition-all ${hasAnyOptionSpecificImages() ? 'border-gray-200 bg-gray-100 cursor-not-allowed opacity-60' : 'border-gray-300 hover:border-blue-500 bg-gray-50 hover:bg-gray-100 cursor-pointer'}`}>
                                    <input
                                        id="file-upload"
                                        type="file"
                                        multiple
                                        onChange={handleImageUpload}
                                        ref={fileInputRef}
                                        disabled={hasAnyOptionSpecificImages()}
                                        className={`absolute inset-0 w-full h-full opacity-0 ${hasAnyOptionSpecificImages() ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                                    />
                                    <div className="text-center text-gray-500">
                                        <span className="block mb-2 text-sm font-medium">
                                            {hasAnyOptionSpecificImages() ? 'Disabled - Option images in use' : 'Click to upload or drag and drop your images here'}
                                        </span>
                                        <div className={`inline-block px-6 py-2 text-white text-sm font-semibold rounded-full shadow-md transition-transform duration-150 ease-in-out ${hasAnyOptionSpecificImages() ? 'bg-gray-400' : 'bg-indigo-500 hover:bg-indigo-600 hover:scale-105'}`}>
                                            Choose Images
                                        </div>
                                    </div>
                                </div>
                                {isUploading && <p className="text-blue-500 text-sm mt-2">Uploading images...</p>}
                                {errors.images && (
                                    <p className="text-red-500 text-sm mt-1">{errors.images}</p>
                                )}
                            </div>

                            {formData.images.length > 0 && (
                                <div className="max-h-80 overflow-y-auto scrollbar-thin pr-2">
                                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
                                        {[...formData.images]
                                            .map((imageObj, index) => (
                                                <div
                                                    key={index}
                                                    className="relative border-2 border-gray-200 rounded-lg overflow-hidden h-32 sm:h-36 md:h-40 shadow-sm hover:shadow-md transition-shadow duration-200"
                                                >
                                                    {imageObj.isUploading ? (
                                                        <div className="absolute inset-0 bg-gray-100 flex justify-center items-center">
                                                            <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
                                                        </div>
                                                    ) : (
                                                        <img
                                                            src={imageObj.preview || (imageObj.file ? URL.createObjectURL(imageObj.file) : '')}
                                                            alt={`uploaded-${index}`}
                                                            className="w-full h-full object-cover"
                                                        />
                                                    )}
                                                    {!imageObj.isUploading && (
                                                        <button
                                                            type="button"
                                                            onClick={() => removeImage(imageObj)}
                                                            className="absolute top-1 right-1 bg-white text-red-500 border-2 border-red-500 p-1.5 rounded-full shadow-lg hover:bg-red-500 hover:text-white transition duration-300 ease-in-out transform hover:scale-110"
                                                        >
                                                            <IoClose className="text-sm" />
                                                        </button>
                                                    )}
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            )}

                            {/* Product Name & Category - Row */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="labelStyles">
                                        Product Name *
                                    </label>
                                    <input
                                        type="text"
                                        name="productName"
                                        autoComplete="off"
                                        placeholder="Enter Product Name"
                                        value={formData.productName}
                                        onChange={handleInputChange}
                                        className={`customInput px-3 py-[9px] ${errors.productName ? 'inputError' : 'inputNormal'}`}
                                    />
                                    {errors.productName && (
                                        <p className="text-red-500 text-sm">{errors.productName}</p>
                                    )}
                                </div>

                                <div>
                                    <label className="labelStyles">Category</label>
                                    <Select
                                        options={[
                                            { value: "add-new", label: "Add New Label" },
                                            ...categories
                                        ]}
                                        value={formData.category}
                                        placeholder={"Select"}
                                        onChange={(option) => {
                                            if (option.value === "add-new") {
                                                handleAddNewLabelCategory();
                                            } else {
                                                handleCategoryChange(option);
                                            }
                                        }}
                                        styles={customSelect}
                                        className="react-select-container scrollbar-thin"
                                        classNamePrefix="react-select"
                                    />
                                    {errors.category && <p className="text-red-500 text-sm">{errors.category}</p>}

                                    <Modal
                                        isOpen={isCategoryModalOpen}
                                        onRequestClose={handleCancelCategory}
                                        className="bg-white p-4 sm:p-6 rounded-lg shadow-2xl transform transition-transform duration-500 ease-in-out scale-100 mx-auto my-4 sm:my-8 md:my-12 lg:my-16 xl:my-20 w-[95vw] max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl max-h-[90vh] overflow-y-auto scrollbar-thin"
                                        overlayClassName="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center p-2 sm:p-4"
                                    >
                                        <div className="flex justify-between items-center mb-5">
                                            <h2 className="text-lg sm:text-xl md:text-2xl font-bold">Add New Category</h2>
                                            <button onClick={handleCancelCategory} className="focus:outline-none">
                                                <IoClose size={24} />
                                            </button>
                                        </div>
                                        <div className="mb-3">
                                            <label className="labelStyles">New Label *</label>
                                            <input
                                                type="text"
                                                id="newLabelCategory"
                                                className={`customInput px-3 py-2 ${errors.newLabelCategory ? 'inputError' : 'inputNormal'}  ${newLabelCategory.trim() === '' && saveAttempted ? 'border-red-500' : 'border-gray-300'}`}
                                                value={newLabelCategory}
                                                onChange={(e) => setNewLabelCategory(e.target.value)}
                                                placeholder="Enter new category label"
                                            />
                                            {saveAttempted && newLabelCategory.trim() === '' && (
                                                <p className="text-red-500 text-xs italic">Category name is required.</p>
                                            )}

                                        </div>
                                        <div className="mb-3">
                                            <label className="labelStyles">Category Image *</label>
                                            <input
                                                type="file"
                                                id="newCategoryImage"
                                                className={`customInput px-3 py-2 ${errors.newCategoryImage ? 'inputError' : 'inputNormal'} ${!newCategoryImage && saveAttempted ? 'border-red-500' : 'border-gray-300'}`}
                                                onChange={handleNewCategoryImageChange}
                                                ref={newCategoryImageInputRef}
                                                accept="image/*"
                                            />
                                            {saveAttempted && !newCategoryImage && (
                                                <p className="text-red-500 text-xs italic">Category image is required.</p>
                                            )}
                                            {newCategoryImagePreview && (
                                                <div className="mt-2">
                                                    <img src={newCategoryImagePreview} alt="Category Preview" className="w-20 h-20 object-cover rounded" />
                                                </div>
                                            )}
                                        </div>

                                        <div className="flex flex-col sm:flex-row mt-6 gap-3 sm:gap-6">
                                            <button
                                                type="button"
                                                onClick={handleCancelCategory}
                                                className="w-full sm:w-1/2 bg-gradient-to-r from-gray-500 to-gray-700 hover:from-gray-600 hover:to-gray-800 text-white px-4 sm:px-6 py-3 rounded-lg shadow-lg transform transition-all hover:scale-105 focus:outline-none focus:ring-4 focus:ring-gray-400 text-sm sm:text-base"
                                            >
                                                Cancel
                                            </button>

                                            <button
                                                type="button"
                                                onClick={handleSaveNewLabelCategory}
                                                disabled={isSavingCategory}
                                                className="w-full sm:w-1/2 bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-600 hover:to-blue-800 text-white px-4 sm:px-6 py-3 rounded-lg shadow-lg transform transition-all hover:scale-105 focus:outline-none focus:ring-4 focus:ring-blue-400 text-sm sm:text-base"
                                            >
                                                {isSavingCategory ? "Saving..." : "Save"}
                                            </button>
                                        </div>
                                    </Modal>
                                </div>
                            </div>

                            {/* Description */}
                            <div className="relative">
                                <label className="labelStyles">
                                    Description
                                </label>
                                <textarea
                                    name="description"
                                    value={formData.description}
                                    onChange={handleInputChange}
                                    className={`customInput scrollbar-thin h-[132px] ${getInputClass("description")} ${errors.description ? 'inputError' : 'inputNormal'}`}
                                    rows="3"
                                ></textarea>

                                <button
                                    type="button"
                                    onClick={generateAIDescription}
                                    disabled={isGenerating}
                                    className="absolute right-2 bottom-3 bg-gradient-to-r from-indigo-500 to-purple-500 text-white px-3 py-1.5 rounded-full shadow-lg hover:from-indigo-600 hover:to-purple-600 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 transition-all duration-300"
                                >
                                    {isGenerating ? (
                                        <>
                                            <span className="animate-spin">🌀</span>
                                            <span className="bg-gradient-to-r from-blue-200 to-purple-200 bg-clip-text text-white">
                                                Generating...
                                            </span>
                                        </>
                                    ) : (
                                        <>
                                            <span className="text-sm transition-transform group-hover:scale-125 group-hover:-rotate-12">
                                                🤖
                                            </span>
                                            <span className="text-sm bg-gradient-to-r from-blue-200 to-purple-200 bg-clip-text text-white">
                                                AI Generate
                                            </span>
                                        </>
                                    )}
                                </button>

                                {errors.description && <p className="text-red-500 text-sm">{errors.description}</p>}
                                <div className="absolute -bottom-3 right-0 text-xs text-gray-400">Powered by ChatGPT-4</div>
                            </div>

                            {/* Variant Name */}
                            <div>
                                <label className="labelStyles flex items-center gap-2">
                                    Variant Name
                                    <span className="text-xs text-gray-400 font-normal">(Optional - shown in variant strip)</span>
                                </label>
                                <input
                                    type="text"
                                    name="variantName"
                                    autoComplete="off"
                                    placeholder="e.g., Red, Large, 500ml"
                                    value={formData.variantName}
                                    onChange={handleInputChange}
                                    className="customInput px-3 py-[9px] inputNormal"
                                />
                                <p className="text-xs text-gray-400 mt-1">
                                    This name will be displayed under the product thumbnail when shown as a variant
                                </p>
                            </div>

                            {/* Vendor & HSN Number Row (Optional) */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="labelStyles flex items-center gap-2">
                                        Vendor
                                        <span className="text-xs text-gray-400 font-normal">(Optional)</span>
                                    </label>
                                    <Select
                                        options={vendors}
                                        value={vendors.find(v => v.value === formData.vendorId) || null}
                                        onChange={(option) => setFormData(prev => ({ ...prev, vendorId: option ? option.value : null }))}
                                        isLoading={vendorsLoading}
                                        placeholder="Select Vendor"
                                        isClearable
                                        styles={{
                                            ...customSelect,
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                        }}
                                        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                        menuPosition="fixed"
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        formatOptionLabel={({ label, vendorMobile, vendorLocation }) => (
                                            <div>
                                                <div className="font-semibold text-gray-900">{label}</div>
                                                {vendorMobile && (
                                                    <div className="text-xs text-gray-500">{vendorMobile} {vendorLocation ? `• ${vendorLocation}` : ''}</div>
                                                )}
                                            </div>
                                        )}
                                    />
                                    <p className="text-xs text-gray-400 mt-1">
                                        Select the vendor/supplier for this product
                                    </p>
                                </div>

                                <div>
                                    <label className="labelStyles flex items-center gap-2">
                                        HSN Number
                                        <span className="text-xs text-gray-400 font-normal">(Optional)</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="hsnNumber"
                                        autoComplete="off"
                                        placeholder="e.g., 1006, 8471, 6201"
                                        value={formData.hsnNumber}
                                        onChange={handleInputChange}
                                        className="customInput px-3 py-[9px] inputNormal"
                                    />
                                    <p className="text-xs text-gray-400 mt-1">
                                        Harmonized System Nomenclature code for GST classification
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ============================================================= */}
                    {/* SECTION 3: Pricing & Inventory Configuration */}
                    {/* ============================================================= */}
                    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
                        <div className="px-4 py-3 bg-gradient-to-r from-green-50 to-emerald-50 border-b border-gray-200">
                            <h2 className="text-base md:text-lg font-semibold text-gray-700 flex items-center gap-2">
                                <span className="w-6 h-6 rounded-full bg-green-600 text-white text-xs flex items-center justify-center font-bold">3</span>
                                Pricing & Inventory
                            </h2>
                        </div>
                        <div className="p-4 space-y-4">
                            {/* GST & Metric Selection Row */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="block font-medium mb-2 text-gray-700">GST Group</label>
                                    <Select
                                        options={gstGroups}
                                        value={gstGroups.find(g => g.value === formData.gstGroupId) || null}
                                        onChange={option => setFormData(prev => ({ ...prev, gstGroupId: option ? option.value : null }))}
                                        isLoading={gstGroupLoading}
                                        placeholder="Select GST Group"
                                        isClearable
                                        styles={customSelect}
                                        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                        menuPosition="fixed"
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                    />
                                    {errors.gstGroupId && (
                                        <p className="text-red-500 text-sm">{errors.gstGroupId}</p>
                                    )}
                                </div>

                                <div>
                                    <label className="flex items-center gap-2 font-medium mb-2 text-gray-700">
                                        Select Main Metric *
                                        <div className="relative group">
                                            <AiOutlineInfoCircle className="text-gray-400 cursor-help" />
                                            <div className="absolute left-0 top-6 hidden group-hover:block w-64 p-2 bg-gray-800 text-white text-xs rounded shadow-lg z-10">
                                                This metric will be used as the base unit for all product options. Supporting metrics will be automatically converted to this primary metric.
                                            </div>
                                        </div>
                                    </label>
                                    <Select
                                        options={metrics.filter(m => m.metricType === 'primary')}
                                        value={mainMetric}
                                        onChange={(option) => {
                                            setMainMetric(option);
                                            // Reset selected metric in modal when main metric changes
                                            setCurrentProductOption(prev => ({ ...prev, selectedMetric: null }));
                                        }}
                                        placeholder="Select Main Metric"
                                        isClearable
                                        styles={customSelect}
                                        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                        menuPosition="fixed"
                                        className="react-select-container scrollbar-thin"
                                        classNamePrefix="react-select"
                                        /* Show option in menu with two-line format, but show the selected value as single line */
                                        getOptionLabel={(option) => `${option.label} (${option.metricName} - Primary)`}
                                        components={{
                                            SingleValue: (props) => {
                                                const data = props.data || {};
                                                return (
                                                    <RSComponents.SingleValue {...props}>
                                                        {`${data.label} (${data.metricName} - Primary)`}
                                                    </RSComponents.SingleValue>
                                                );
                                            }
                                        }}
                                        formatOptionLabel={({ label, metricName }) => (
                                            <div>
                                                <div className="font-semibold text-gray-900">{label}</div>
                                                <div className="text-xs text-gray-500">{metricName} (Primary)</div>
                                            </div>
                                        )}
                                    />
                                    <p className="text-xs text-gray-500 mt-1">This will be used as the base metric for all product options</p>
                                </div>
                            </div>

                            {/* Hide Reviews Toggle - Only for online */}
                            {storeType === 'online' && (
                                <div className="flex items-center py-2">
                                    <label className="mr-4 text-gray-700 font-bold">Hide Reviews and Ratings</label>
                                    <div className="relative">
                                        <input
                                            type="checkbox"
                                            id="toggle-reviews"
                                            checked={formData.hideReviews}
                                            onChange={handleToggleChange}
                                            className="hidden"
                                        />
                                        <label
                                            htmlFor="toggle-reviews"
                                            className={`flex items-center cursor-pointer w-12 h-6 rounded-full p-1 transition-colors duration-300 ease-in-out ${formData.hideReviews ? 'bg-green-500' : 'bg-gray-300'}`}
                                        >
                                            <span
                                                className={`block w-[1.20rem] h-[1.20rem] bg-white rounded-full shadow-md m-[-2px] transform transition-transform duration-300 ease-in-out ${formData.hideReviews ? 'translate-x-6' : 'translate-x-0'}`}
                                            ></span>
                                        </label>
                                    </div>
                                </div>
                            )}

                            {/* Multi-Attribute Mode Toggle */}
                            {(isOnlineProduct || isOfflineProduct) && (
                                <div className="p-4 bg-gradient-to-r from-indigo-50 to-purple-50 rounded-lg border border-indigo-200">
                                    <div className="flex items-center justify-between">
                                        <div className="flex-1">
                                            <h3 className="text-base font-bold text-gray-700 flex items-center gap-2">
                                                🎛️ Multi-Attribute Options
                                                <span className="text-xs font-normal bg-indigo-100 text-indigo-700 px-2 py-1 rounded-full">
                                                    Electronics Style
                                                </span>
                                            </h3>
                                            <p className="text-sm text-gray-600 mt-1">
                                                Enable for products with multiple attributes (RAM + ROM, Size + Color).
                                            </p>
                                        </div>
                                        <div className="ml-4">
                                            <input
                                                type="checkbox"
                                                id="toggle-multi-attribute"
                                                checked={useMultiAttributeMode}
                                                onChange={handleToggleMultiAttributeMode}
                                                className="hidden"
                                            />
                                            <label
                                                htmlFor="toggle-multi-attribute"
                                                className={`flex items-center cursor-pointer w-14 h-7 rounded-full p-1 transition-colors duration-300 ease-in-out ${useMultiAttributeMode ? 'bg-indigo-500' : 'bg-gray-300'}`}
                                            >
                                                <span
                                                    className={`block w-5 h-5 bg-white rounded-full shadow-md transform transition-transform duration-300 ease-in-out ${useMultiAttributeMode ? 'translate-x-7' : 'translate-x-0'}`}
                                                ></span>
                                            </label>
                                        </div>
                                    </div>
                                    {useMultiAttributeMode && (
                                        <div className="mt-3 text-xs text-indigo-600 bg-indigo-50 p-2 rounded">
                                            <strong>Example:</strong> A phone can have RAM (4GB, 8GB) and ROM (64GB, 128GB, 256GB).
                                            Each combination like "8GB RAM + 128GB ROM" has its own price.
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Multi-Attribute Mode: Option Groups Section */}
                            {(isOnlineProduct || isOfflineProduct) && useMultiAttributeMode && (
                                <div>
                                    {/* Option Groups Header */}
                                    <div className="flex items-center space-x-2 p-4 bg-gradient-to-r from-indigo-50 to-indigo-100 rounded-lg shadow-md rounded-bl-none rounded-br-none">
                                        <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-700 hover:text-indigo-600 transition duration-300">
                                            Option Groups
                                        </h2>
                                        <span className="text-sm text-gray-500">(e.g., RAM, ROM, Color)</span>
                                        <FaAngleDoubleRight className="text-indigo-500 text-2xl mt-[6px]" />
                                        <button
                                            type="button"
                                            onClick={() => {
                                                setEditOptionGroupIndex(null);
                                                setCurrentOptionGroup({ groupName: "", values: [] });
                                                setIsOptionGroupModalOpen(true);
                                            }}
                                            className="relative flex items-center justify-center w-12 h-12 mt-[6px] bg-gradient-to-r from-indigo-500 to-indigo-700 hover:from-indigo-600 hover:to-indigo-800 text-white rounded-full shadow-lg transform transition-all hover:scale-110 focus:outline-none focus:ring-4 focus:ring-indigo-400 group"
                                        >
                                            <FiPlus className="text-3xl font-bold" />
                                        </button>
                                    </div>

                                    {errors.optionGroups && <p className="text-red-500 text-sm mt-2">{errors.optionGroups}</p>}

                                    {/* Display Added Option Groups */}
                                    {optionGroups.length > 0 && (
                                        <div className="bg-white p-4 rounded-lg shadow-lg border border-gray-200 rounded-tl-none rounded-tr-none">
                                            <div className="flex items-center mb-3">
                                                <RiAlignItemBottomFill className="text-indigo-500" />
                                                <h2 className="text-base sm:text-lg font-bold text-gray-700 ml-2">
                                                    Created Option Groups ({optionGroups.length})
                                                </h2>
                                            </div>
                                            <div className="space-y-3">
                                                {optionGroups.map((group, index) => (
                                                    <div key={index} className="bg-indigo-50 p-4 rounded-md flex justify-between items-start">
                                                        <div className="flex-1">
                                                            <h3 className="font-bold text-indigo-700 text-lg">{group.groupName}</h3>
                                                            <div className="flex flex-wrap gap-2 mt-2">
                                                                {group.values.map((value, vIdx) => (
                                                                    <span
                                                                        key={vIdx}
                                                                        className="px-3 py-1 bg-white text-indigo-700 text-sm rounded-full border border-indigo-200 shadow-sm"
                                                                    >
                                                                        {value}
                                                                    </span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                        <div className="flex space-x-3 ml-4">
                                                            <button
                                                                type="button"
                                                                onClick={() => handleEditOptionGroup(index)}
                                                                className="p-2 bg-white rounded-lg shadow hover:bg-indigo-100"
                                                                aria-label="Edit"
                                                            >
                                                                <FiEdit2 className="text-indigo-600" />
                                                            </button>
                                                            <button
                                                                type="button"
                                                                onClick={() => handleDeleteOptionGroup(index)}
                                                                className="p-2 bg-white rounded-lg shadow hover:bg-red-100"
                                                                aria-label="Delete"
                                                            >
                                                                <FiTrash2 className="text-red-600" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* Variant Combinations Section */}
                                    {optionGroups.length >= 1 && (
                                        <div className="mt-4">
                                            <div className="flex items-center space-x-2 p-4 bg-gradient-to-r from-purple-50 to-purple-100 rounded-lg shadow-md rounded-bl-none rounded-br-none">
                                                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-700 hover:text-purple-600 transition duration-300">
                                                    Variant Combinations & Pricing
                                                </h2>
                                                <span className="text-sm text-gray-500">
                                                    ({variantCombinations.length}/{getTotalPossibleCombinations()} defined)
                                                </span>
                                                <FaAngleDoubleRight className="text-purple-500 text-2xl mt-[6px]" />
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        setEditVariantCombinationIndex(null);
                                                        resetVariantCombination();
                                                        setIsVariantCombinationModalOpen(true);
                                                    }}
                                                    className="relative flex items-center justify-center w-12 h-12 mt-[6px] bg-gradient-to-r from-purple-500 to-purple-700 hover:from-purple-600 hover:to-purple-800 text-white rounded-full shadow-lg transform transition-all hover:scale-110 focus:outline-none focus:ring-4 focus:ring-purple-400 group"
                                                >
                                                    <FiPlus className="text-3xl font-bold" />
                                                </button>
                                            </div>

                                            {errors.variantCombinations && <p className="text-red-500 text-sm mt-2">{errors.variantCombinations}</p>}

                                            {/* Display Added Variant Combinations */}
                                            {variantCombinations.length > 0 && (
                                                <div className="bg-white p-4 rounded-lg shadow-lg border border-gray-200 rounded-tl-none rounded-tr-none">
                                                    <div className="flex items-center mb-3">
                                                        <RiAlignItemBottomFill className="text-purple-500" />
                                                        <h2 className="text-base sm:text-lg font-bold text-gray-700 ml-2">
                                                            Defined Combinations ({variantCombinations.length})
                                                        </h2>
                                                    </div>
                                                    <div className="space-y-3">
                                                        {variantCombinations.map((combo, index) => (
                                                            <div key={index} className="bg-purple-50 p-4 rounded-md flex justify-between items-start">
                                                                <div className="flex-1">
                                                                    <div className="flex flex-wrap gap-2 mb-2">
                                                                        {Object.entries(combo.selectedOptions).map(([key, value], oIdx) => (
                                                                            <span
                                                                                key={oIdx}
                                                                                className="px-3 py-1 bg-purple-600 text-white text-sm rounded-full font-medium"
                                                                            >
                                                                                {key}: {value}
                                                                            </span>
                                                                        ))}
                                                                    </div>
                                                                    <div className="text-sm text-gray-700">
                                                                        <span className="font-semibold">Price:</span> ₹{combo.originalPrice}
                                                                        {combo.discount > 0 && (
                                                                            <>
                                                                                <span className="mx-2">→</span>
                                                                                <span className="text-green-600 font-semibold">₹{combo.discountPrice}</span>
                                                                                <span className="text-gray-500 ml-1">({combo.discount}% off)</span>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                    {combo.useDifferentOfflinePrice && (
                                                                        <div className="text-sm text-indigo-600 mt-1">
                                                                            <span className="font-semibold">Offline:</span> ₹{combo.offlineOriginalPrice}
                                                                            {combo.offlineDiscount > 0 && (
                                                                                <>
                                                                                    <span className="mx-2">→</span>
                                                                                    <span className="font-semibold">₹{combo.offlineDiscountPrice}</span>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                    {combo.barcode && (
                                                                        <p className="text-xs text-gray-500 mt-1">Barcode: {combo.barcode}</p>
                                                                    )}
                                                                    {combo.images && combo.images.length > 0 && (
                                                                        <div className="mt-2 flex items-center gap-2">
                                                                            <span className="px-2 py-1 bg-purple-100 text-purple-700 text-xs font-semibold rounded-full flex items-center gap-1">
                                                                                📷 {combo.images.length} Image{combo.images.length > 1 ? 's' : ''}
                                                                            </span>
                                                                            <div className="flex gap-1">
                                                                                {combo.images.slice(0, 3).map((img, imgIdx) => (
                                                                                    <img
                                                                                        key={imgIdx}
                                                                                        src={img.preview}
                                                                                        alt={`combo-${imgIdx}`}
                                                                                        className="w-8 h-8 rounded object-cover border border-purple-200"
                                                                                    />
                                                                                ))}
                                                                                {combo.images.length > 3 && (
                                                                                    <span className="text-xs text-gray-500 self-center">+{combo.images.length - 3}</span>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div className="flex space-x-3 ml-4">
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => handleEditVariantCombination(index)}
                                                                        className="p-2 bg-white rounded-lg shadow hover:bg-purple-100"
                                                                        aria-label="Edit"
                                                                    >
                                                                        <FiEdit2 className="text-purple-600" />
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => handleDeleteVariantCombination(index)}
                                                                        className="p-2 bg-white rounded-lg shadow hover:bg-red-100"
                                                                        aria-label="Delete"
                                                                    >
                                                                        <FiTrash2 className="text-red-600" />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Simple Mode: Unified Product Options - Keep styles exactly as is */}
                            {(isOnlineProduct || isOfflineProduct) && !useMultiAttributeMode && (
                                <div>
                                    <div className="flex items-center space-x-2 p-4 bg-gradient-to-r from-green-50 to-green-100 rounded-lg shadow-md rounded-bl-none rounded-br-none">
                                        <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-700 hover:text-green-600 transition duration-300">
                                            Add Product Options
                                        </h2>
                                        <FaAngleDoubleRight className="text-green-500 text-2xl mt-[6px]" />
                                        <button
                                            type="button"
                                            onClick={() => {
                                                if (!mainMetric) {
                                                    setSnackBarMessage("Please select a Main Metric before adding product options");
                                                    setIsSnackBarVisible(true);
                                                    return;
                                                }
                                                setEditOptionIndex(null); // Reset edit index when opening for new option
                                                setIsModalOpen(true);
                                            }}
                                            className="relative flex items-center justify-center w-12 h-12 mt-[6px] bg-gradient-to-r from-green-500 to-green-700 hover:from-green-600 hover:to-green-800 text-white rounded-full shadow-lg transform transition-all hover:scale-110 focus:outline-none focus:ring-4 focus:ring-green-400 group"
                                        >
                                            <FiPlus className="text-3xl font-bold animate-smooth-rotate" />
                                        </button>
                                    </div>

                                    {/* Global Common Inventory Checkbox - ONLY show if main metric has sub-units configured */}
                                    {mainMetricHasSubUnits && (
                                        <div className="bg-blue-50 border-l-4 border-blue-400 p-4">
                                            <div className="flex items-start">
                                                <input
                                                    type="checkbox"
                                                    id="globalCommonInventory"
                                                    checked={commonInventoryType}
                                                    onChange={(e) => setCommonInventoryType(e.target.checked)}
                                                    className="mr-3 h-4 w-4 mt-1 cursor-pointer"
                                                />
                                                <div className="flex-1">
                                                    <label htmlFor="globalCommonInventory" className="block text-sm font-semibold text-gray-700 cursor-pointer">
                                                        Common Inventory for All Options
                                                    </label>
                                                    <p className="text-xs text-gray-600 mt-1">
                                                        Enable this to share inventory across all product options. For example, if you have 150 Kg in stock,
                                                        it will automatically be available for 200gm, 500gm, 1Kg, and 5Kg options.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {errors.productOptions && <p className="text-red-500 text-sm">{errors.productOptions}</p>}
                                    {productOptions.length > 0 && (
                                        <div className="bg-gradient-to-br from-white to-gray-50/50 p-3 sm:p-4 rounded-b-lg shadow-lg border border-gray-200 border-t-0">
                                            {/* Header */}
                                            <div className="flex items-center justify-between mb-3 pb-2 border-b border-gray-200">
                                                <div className="flex items-center gap-2">
                                                    <div className="w-8 h-8 rounded-lg bg-indigo-600 flex items-center justify-center">
                                                        <RiAlignItemBottomFill className="text-white text-lg" />
                                                    </div>
                                                    <div>
                                                        <h2 className="text-sm sm:text-base font-bold text-gray-800">
                                                            Added Product Options
                                                        </h2>
                                                        <p className="text-xs text-gray-500">{productOptions.length} variant{productOptions.length !== 1 ? 's' : ''} configured</p>
                                                    </div>
                                                </div>
                                                <span className="px-2 py-1 bg-indigo-100 text-indigo-700 text-xs font-semibold rounded-full">
                                                    {productOptions.length} total
                                                </span>
                                            </div>

                                            {/* Cards Grid */}
                                            <ul className="grid grid-cols-1 lg:grid-cols-2 gap-3">
                                                {productOptions.map((option, index) => (
                                                    <li key={index} className="bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200 overflow-hidden">
                                                        {/* Card Header */}
                                                        <div className="px-3 py-2 bg-gradient-to-r from-gray-50 to-white border-b border-gray-100 flex items-center justify-between">
                                                            <div className="flex items-center gap-2 min-w-0">
                                                                <span className="w-6 h-6 rounded-md bg-slate-800 text-white text-xs font-bold flex items-center justify-center shrink-0">
                                                                    {index + 1}
                                                                </span>
                                                                <p className="font-semibold text-gray-800 text-sm truncate" title={option.weightLabel}>
                                                                    {option.weightLabel}
                                                                </p>
                                                            </div>
                                                            <div className="flex gap-1 shrink-0">
                                                                {mainMetricHasSubUnits && commonInventoryType && (
                                                                    <span className="px-1.5 py-0.5 bg-emerald-100 text-emerald-700 text-[10px] font-semibold rounded">
                                                                        Shared
                                                                    </span>
                                                                )}
                                                                {option.isFlashDiscount && (
                                                                    <span className="px-1.5 py-0.5 bg-rose-100 text-rose-700 text-[10px] font-semibold rounded">
                                                                        Flash
                                                                    </span>
                                                                )}
                                                                {option.useDifferentOfflinePrice && isOfflineProduct && (
                                                                    <span className="px-1.5 py-0.5 bg-sky-100 text-sky-700 text-[10px] font-semibold rounded">
                                                                        Offline
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>

                                                        {/* Card Body */}
                                                        <div className="p-3">
                                                            {/* Weight Info */}
                                                            {mainMetricHasSubUnits && (
                                                                <div className="flex items-center gap-2 mb-2 text-xs text-gray-600">
                                                                    <span className="w-4 h-4 rounded bg-blue-50 flex items-center justify-center">
                                                                        <svg className="w-2.5 h-2.5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
                                                                        </svg>
                                                                    </span>
                                                                    <span>{option.weightValue} {option.selectedMetric?.label}</span>
                                                                </div>
                                                            )}

                                                            {/* Pricing Row */}
                                                            <div className="flex items-center gap-3 mb-2">
                                                                <div className="flex-1 bg-gray-50 rounded-lg p-2">
                                                                    <p className="text-[10px] text-gray-500 uppercase font-medium">MRP</p>
                                                                    <p className="text-sm font-semibold text-gray-700">₹{option.originalPrice}</p>
                                                                </div>
                                                                <div className="flex-1 bg-gray-50 rounded-lg p-2">
                                                                    <p className="text-[10px] text-gray-500 uppercase font-medium">Discount</p>
                                                                    <p className="text-sm font-semibold text-gray-700">{option.discount?.value || option.discount}%</p>
                                                                </div>
                                                                <div className="flex-1 bg-emerald-50 rounded-lg p-2 border border-emerald-100">
                                                                    <p className="text-[10px] text-emerald-600 uppercase font-medium">Selling</p>
                                                                    <p className="text-sm font-bold text-emerald-700">₹{option.discountPrice}</p>
                                                                </div>
                                                            </div>

                                                            {/* Flash Discount */}
                                                            {option.isFlashDiscount && (
                                                                <div className="mb-2 p-2 bg-rose-50 rounded-lg border border-rose-100">
                                                                    <p className="text-[10px] text-rose-600 font-semibold uppercase mb-1">Flash Deal</p>
                                                                    <div className="flex gap-2 text-xs">
                                                                        <span className="text-rose-700 font-medium">₹{option.flashDiscountPrice}</span>
                                                                        <span className="text-gray-400">|</span>
                                                                        <span className="text-gray-600">Min ₹{option.flashMinimumCartValue || 0}</span>
                                                                        <span className="text-gray-400">|</span>
                                                                        <span className="text-gray-600">Max {option.maxAllowedQuantityInOneOrder || 1}</span>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {/* Offline Pricing */}
                                                            {option.useDifferentOfflinePrice && isOfflineProduct && (
                                                                <div className="mb-2 p-2 bg-sky-50 rounded-lg border border-sky-100">
                                                                    <p className="text-[10px] text-sky-600 font-semibold uppercase mb-1">Offline Store</p>
                                                                    <div className="flex gap-2 text-xs">
                                                                        <span className="text-sky-700 font-medium">₹{option.offlineDiscountPrice}</span>
                                                                        <span className="text-gray-400">|</span>
                                                                        <span className="text-gray-600">{option.offlineDiscount}% off</span>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {/* Expiry & Barcode */}
                                                            <div className="flex flex-wrap gap-2 mb-2">
                                                                {option.expiryDate && (
                                                                    <div className="flex items-center gap-1 text-xs text-amber-600 bg-amber-50 px-2 py-1 rounded">
                                                                        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                                        </svg>
                                                                        <span>{option.expiryDate}</span>
                                                                    </div>
                                                                )}
                                                                {option.barcode && (
                                                                    <div className="flex items-center gap-1 text-xs text-gray-600 bg-gray-100 px-2 py-1 rounded font-mono">
                                                                        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v1m6 11h2m-6 0h-2v4h2v-4zM6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                                        </svg>
                                                                        <span className="truncate max-w-[100px]" title={option.barcode}>{option.barcode}</span>
                                                                    </div>
                                                                )}
                                                            </div>

                                                            {/* Images */}
                                                            {option.images && option.images.length > 0 && (
                                                                <div className="flex items-center gap-2 mb-2 p-2 bg-violet-50 rounded-lg">
                                                                    <span className="text-xs text-violet-700 font-medium">📷 {option.images.length}</span>
                                                                    <div className="flex gap-1">
                                                                        {option.images.slice(0, 4).map((img, imgIdx) => (
                                                                            <img
                                                                                key={imgIdx}
                                                                                src={img.preview}
                                                                                alt={`opt-${imgIdx}`}
                                                                                className="w-7 h-7 rounded object-cover border border-violet-200"
                                                                            />
                                                                        ))}
                                                                        {option.images.length > 4 && (
                                                                            <span className="w-7 h-7 rounded bg-violet-200 text-violet-700 text-[10px] font-bold flex items-center justify-center">
                                                                                +{option.images.length - 4}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {/* Bulk Offers */}
                                                            {option.bulkOffers && option.bulkOffers.length > 0 && (
                                                                <div className="flex flex-wrap gap-1 mb-2">
                                                                    <span className="text-[10px] text-amber-700 font-semibold bg-amber-100 px-1.5 py-0.5 rounded">
                                                                        🏷️ {option.bulkOffers.length} offer{option.bulkOffers.length > 1 ? 's' : ''}
                                                                    </span>
                                                                    {option.bulkOffers.slice(0, 2).map((bo, boIdx) => (
                                                                        <span key={boIdx} className="text-[10px] text-amber-600 bg-amber-50 px-1.5 py-0.5 rounded border border-amber-200">
                                                                            {bo.minQuantity}+ @{bo.discountPercentage}%
                                                                        </span>
                                                                    ))}
                                                                    {option.bulkOffers.length > 2 && (
                                                                        <span className="text-[10px] text-amber-600 bg-amber-50 px-1.5 py-0.5 rounded">
                                                                            +{option.bulkOffers.length - 2}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            )}

                                                            {/* Action Buttons */}
                                                            <div className="flex gap-4 pt-2 border-t border-gray-100">
                                                                <button
                                                                    type="button"
                                                                    onClick={(event) => handleDeleteOption(event, index)}
                                                                    className="flex-1 flex items-center justify-center gap-1.5 px-3 py-3 bg-rose-50 text-rose-700 text-xs font-medium rounded-lg hover:bg-rose-100 transition-colors"
                                                                >
                                                                    <FiTrash2 className="w-3.5 h-3.5" />
                                                                    Delete
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    onClick={(event) => handleEditOption(index, event)}
                                                                    className="flex-1 flex items-center justify-center gap-1.5 px-3 py-3 bg-indigo-50 text-indigo-700 text-xs font-medium rounded-lg hover:bg-indigo-100 transition-colors"
                                                                >
                                                                    <FiEdit2 className="w-3.5 h-3.5" />
                                                                    Edit
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* ============================================================= */}
                    {/* SECTION 4: Coupons & Display Sections */}
                    {/* ============================================================= */}
                    {(isOnlineProduct || isOfflineProduct) && (
                        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
                            <div className="px-4 py-3 bg-gradient-to-r from-amber-50 to-orange-50 border-b border-gray-200">
                                <h2 className="text-base md:text-lg font-semibold text-gray-700 flex items-center gap-2">
                                    <span className="w-6 h-6 rounded-full bg-amber-600 text-white text-xs flex items-center justify-center font-bold">4</span>
                                    Coupons & Display Sections
                                </h2>
                            </div>
                            <div className="p-4 space-y-4">
                                {/* Online Store Settings */}
                                {isOnlineProduct && (
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block font-medium mb-2 text-gray-700">Coupons Online</label>
                                            <Select
                                                isMulti
                                                options={couponsDataOnline}
                                                value={coupons}
                                                onChange={handleCoupons}
                                                styles={customSelect}
                                                placeholder="Select Online Coupons"
                                                className="react-select-container scrollbar-thin"
                                                classNamePrefix="react-select"
                                                formatOptionLabel={formatCouponLabel}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                            />
                                            {errors.coupons && (
                                                <p className="text-red-500 text-sm">{errors.coupons}</p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block font-medium mb-2 text-gray-700">Sections</label>
                                            <Select
                                                isMulti
                                                options={sectionsData}
                                                value={sections}
                                                onChange={handleSections}
                                                styles={customSelect}
                                                placeholder="Select Sections"
                                                className="react-select-container scrollbar-thin"
                                                classNamePrefix="react-select"
                                                formatOptionLabel={formatSectionLabel}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                            />
                                            {errors.sections && (
                                                <p className="text-red-500 text-sm">{errors.sections}</p>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {/* Offline Store Settings */}
                                {isOfflineProduct && (
                                    <div>
                                        <label className="block font-medium mb-2 text-gray-700">Coupons Offline</label>
                                        <Select
                                            isMulti
                                            options={couponsDataOffline}
                                            value={couponsOffline}
                                            onChange={handleCouponsOffline}
                                            styles={customSelect}
                                            placeholder="Select Offline Coupons"
                                            className="react-select-container scrollbar-thin"
                                            classNamePrefix="react-select"
                                            formatOptionLabel={formatCouponLabel}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                        />
                                        {errors.couponsOffline && (
                                            <p className="text-red-500 text-sm">{errors.couponsOffline}</p>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* ============================================================= */}
                    {/* SECTION 5: Advanced Product Details (Online Only) */}
                    {/* ============================================================= */}
                    {isOnlineProduct && (
                        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
                            <div
                                className="px-4 py-3 bg-gradient-to-r from-teal-50 to-cyan-50 border-b border-gray-200 cursor-pointer hover:bg-gradient-to-r hover:from-teal-100 hover:to-cyan-100 transition-colors duration-200"
                                onClick={() => setIsAdvancedDetailsExpanded(!isAdvancedDetailsExpanded)}
                            >
                                <h2 className="text-base md:text-lg font-semibold text-gray-700 flex items-center gap-2">
                                    <span className="w-6 h-6 rounded-full bg-teal-600 text-white text-xs flex items-center justify-center font-bold">5</span>
                                    Advanced Product Details
                                    <span className="text-xs font-normal text-gray-500">(Highlights, Tabs, Showcase)</span>
                                    <span className="ml-auto">
                                        {isAdvancedDetailsExpanded ? (
                                            <svg className="w-5 h-5 transform transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                                            </svg>
                                        ) : (
                                            <svg className="w-5 h-5 transform transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                            </svg>
                                        )}
                                    </span>
                                </h2>
                            </div>
                            {isAdvancedDetailsExpanded && (
                                <div className="p-4 space-y-5">

                                    {/* Product Highlights Section - Plain Text Only */}
                                    <div className="p-4 bg-gradient-to-br from-teal-50 to-emerald-50 rounded-xl border border-teal-200 shadow-sm">
                                        <div className="flex items-center justify-between mb-4">
                                            <div className="flex items-center gap-3">
                                                <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-xl flex items-center justify-center shadow-lg">
                                                    <HiSparkles className="text-white text-xl" />
                                                </div>
                                                <div>
                                                    <h3 className="text-lg font-bold text-teal-800">Product Highlights</h3>
                                                    <span className="text-xs text-teal-600">Key features shown at top of product page</span>
                                                </div>
                                            </div>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    setEditHighlightIndex(null);
                                                    setCurrentHighlight({ text: '' });
                                                    setIsHighlightModalOpen(true);
                                                }}
                                                className="flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-teal-500 to-emerald-500 text-white rounded-xl shadow-lg hover:from-teal-600 hover:to-emerald-600 hover:shadow-xl transition-all duration-300 transform hover:scale-105 text-sm font-semibold border border-teal-400/30 hover:border-teal-300"
                                            >
                                                <FiPlus className="text-lg font-bold" /> Add Highlight
                                            </button>
                                        </div>

                                        {productHighlights.length > 0 ? (
                                            <div className="space-y-2">
                                                {productHighlights.map((highlight, index) => (
                                                    <div key={index} className="flex items-center justify-between p-3 bg-white rounded-lg border border-teal-200 shadow-sm hover:shadow-md transition-shadow">
                                                        <div className="flex items-center gap-3">
                                                            <span className="w-6 h-6 bg-teal-500 text-white rounded-full flex items-center justify-center text-xs font-bold">{index + 1}</span>
                                                            <span className="text-gray-700 font-medium">{highlight.text}</span>
                                                        </div>
                                                        <div className="flex gap-2">
                                                            <button type="button" onClick={() => handleEditHighlight(index)} className="p-2 bg-blue-50 rounded-lg shadow-sm hover:bg-blue-100 transition-colors">
                                                                <FiEdit2 className="text-blue-600 text-sm" />
                                                            </button>
                                                            <button type="button" onClick={() => handleDeleteHighlight(index)} className="p-2 bg-red-50 rounded-lg shadow-sm hover:bg-red-100 transition-colors">
                                                                <FiTrash2 className="text-red-500 text-sm" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <div className="bg-white/60 rounded-lg p-6 text-center border border-dashed border-teal-300">
                                                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3">
                                                    <MdLightbulb className="text-teal-500 text-2xl" />
                                                </div>
                                                <p className="text-teal-700 font-medium">No highlights added yet</p>
                                                <p className="text-teal-600 text-sm">Click "Add Highlight" to showcase key product features</p>
                                            </div>
                                        )}
                                    </div>

                                    {/* Custom Product Detail Tabs - User Creates Own Labels */}
                                    <div className="p-4 bg-gradient-to-br from-indigo-50 to-purple-50 rounded-xl border border-indigo-200 shadow-sm">
                                        <div className="flex items-center justify-between mb-4">
                                            <div className="flex items-center gap-3">
                                                <div className="w-10 h-10 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-xl flex items-center justify-center shadow-lg">
                                                    <MdTab className="text-white text-xl" />
                                                </div>
                                                <div>
                                                    <h3 className="text-lg font-bold text-indigo-800">Product Detail Tabs</h3>
                                                    <span className="text-xs text-indigo-600">Specifications, Warranty, Features etc.</span>
                                                </div>
                                            </div>
                                            <div className="flex items-center gap-2 flex-wrap">
                                                <button
                                                    type="button"
                                                    onClick={handleImportTabsFromLastProduct}
                                                    disabled={isImportingTabs}
                                                    className="flex items-center gap-2 px-4 py-2 bg-white text-indigo-600 border-2 border-indigo-300 rounded-xl shadow-sm hover:bg-indigo-50 hover:border-indigo-400 hover:shadow-md transition-all duration-300 text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                                                    title="Import tabs from the last created product"
                                                >
                                                    {isImportingTabs ? (
                                                        <>
                                                            <svg className="animate-spin h-4 w-4 text-indigo-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                            </svg>
                                                            <span>Importing...</span>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <FiDownload className="text-base" />
                                                            <span className="hidden sm:inline">Import from Last Product</span>
                                                            <span className="sm:hidden">Import</span>
                                                        </>
                                                    )}
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        setEditTabIndex(null);
                                                        setCurrentTab({ tabName: '', sections: [] });
                                                        setIsTabModalOpen(true);
                                                    }}
                                                    className="flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-indigo-500 to-purple-500 text-white rounded-xl shadow-lg hover:from-indigo-600 hover:to-purple-600 hover:shadow-xl transition-all duration-300 transform hover:scale-105 text-sm font-semibold border border-indigo-400/30 hover:border-indigo-300"
                                                >
                                                    <FiPlus className="text-lg font-bold" /> Add Tab
                                                </button>
                                            </div>
                                        </div>

                                        {productDetailsTabs.length > 0 ? (
                                            <div className="space-y-4">
                                                {productDetailsTabs.map((tab, tabIndex) => (
                                                    <div key={tabIndex} className="bg-white border border-indigo-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow">
                                                        {/* Tab Header */}
                                                        <div className="flex items-center justify-between p-3 bg-gradient-to-r from-indigo-100 to-purple-100 border-b border-indigo-200">
                                                            <div className="flex items-center gap-3">
                                                                <span className="w-8 h-8 bg-indigo-500 text-white rounded-lg flex items-center justify-center text-sm font-bold shadow">{tabIndex + 1}</span>
                                                                <span className="font-bold text-indigo-800">{tab.tabName}</span>
                                                                <span className="text-xs bg-white text-indigo-600 px-2 py-1 rounded-full shadow-sm">{tab.sections.length} section{tab.sections.length !== 1 ? 's' : ''}</span>
                                                            </div>
                                                            <div className="flex gap-4">
                                                                <button
                                                                    type="button"
                                                                    onClick={() => {
                                                                        setSelectedTabForSection(tabIndex);
                                                                        setEditSectionIndex(null);
                                                                        setCurrentSection({ sectionName: '', fields: [] });
                                                                        setCurrentField({ fieldName: '', fieldValue: '' });
                                                                        setIsSectionModalOpen(true);
                                                                    }}
                                                                    className="p-2 bg-white rounded-lg shadow-sm hover:bg-green-50 text-green-600 transition-colors"
                                                                    title="Add Section"
                                                                >
                                                                    <FiPlus className="text-sm" />
                                                                </button>
                                                                <button type="button" onClick={() => handleEditTab(tabIndex)} className="p-2 bg-white rounded-lg shadow-sm hover:bg-blue-50 transition-colors">
                                                                    <FiEdit2 className="text-blue-600 text-sm" />
                                                                </button>
                                                                <button type="button" onClick={() => handleDeleteTab(tabIndex)} className="p-2 bg-white rounded-lg shadow-sm hover:bg-red-50 transition-colors">
                                                                    <FiTrash2 className="text-red-500 text-sm" />
                                                                </button>
                                                            </div>
                                                        </div>

                                                        {/* Tab Sections */}
                                                        <div className="p-3 bg-gray-50">
                                                            {tab.sections.length > 0 ? (
                                                                <div className="space-y-3">
                                                                    {tab.sections.map((section, sIndex) => (
                                                                        <div key={sIndex} className="border border-blue-100 rounded-lg overflow-hidden">
                                                                            <div className="flex items-center justify-between p-2 bg-blue-50 border-b border-blue-100">
                                                                                <h5 className="font-medium text-blue-600 text-sm">{section.sectionName}</h5>
                                                                                <div className="flex gap-5">
                                                                                    <button type="button" onClick={() => handleEditSection(tabIndex, sIndex)} className="p-1 bg-white rounded hover:bg-gray-100">
                                                                                        <FiEdit2 className="text-blue-500 text-xs" />
                                                                                    </button>
                                                                                    <button type="button" onClick={() => handleDeleteSection(tabIndex, sIndex)} className="p-1 bg-white rounded hover:bg-red-50">
                                                                                        <FiTrash2 className="text-red-500 text-xs" />
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                            <div className="p-2 bg-white">
                                                                                {section.fields.map((field, fIndex) => (
                                                                                    <div key={fIndex} className="flex justify-between py-1 border-b border-gray-50 last:border-0 text-sm">
                                                                                        <span className="text-gray-500">{field.fieldName}</span>
                                                                                        <span className="text-gray-800 font-medium">{field.fieldValue}</span>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            ) : (
                                                                <p className="text-indigo-400 text-sm text-center py-3">No sections yet. Click + to add sections.</p>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <div className="bg-white/60 rounded-lg p-6 text-center border border-dashed border-indigo-300">
                                                <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-3">
                                                    <MdDescription className="text-indigo-500 text-2xl" />
                                                </div>
                                                <p className="text-indigo-700 font-medium">No tabs added yet</p>
                                                <p className="text-indigo-600 text-sm">Click "Add Tab" to create custom tabs like Specifications, Warranty, etc.</p>
                                            </div>
                                        )}
                                    </div>

                                    {/* Showcase Images Section */}
                                    <div className="p-4 bg-gradient-to-br from-rose-50 to-pink-50 rounded-xl border border-rose-200 shadow-sm">
                                        <div className="flex items-center gap-3 mb-4">
                                            <div className="w-10 h-10 bg-gradient-to-br from-rose-500 to-pink-500 rounded-xl flex items-center justify-center shadow-lg">
                                                <MdImage className="text-white text-xl" />
                                            </div>
                                            <div>
                                                <h3 className="text-lg font-bold text-rose-800">Showcase Images</h3>
                                                <span className="text-xs text-rose-600">Brand imagery displayed in the Showcase tab</span>
                                            </div>
                                        </div>

                                        <div className="relative border-dashed border-2 border-rose-300 rounded-xl p-5 transition-all hover:border-rose-400 bg-white hover:bg-rose-50">
                                            <input
                                                type="file"
                                                multiple
                                                accept="image/*"
                                                onChange={handleShowcaseImageUpload}
                                                ref={showcaseImageInputRef}
                                                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                            />
                                            <div className="text-center text-gray-500">
                                                <span className="text-3xl mb-2 block">📸</span>
                                                <span className="block mb-1 text-sm font-medium text-rose-700">Click to upload showcase/brand images</span>
                                                <span className="text-xs text-rose-500">These appear in the "Showcase" tab on product page</span>
                                            </div>
                                        </div>

                                        {showcaseImages.length > 0 ? (
                                            <div className="mt-4 grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-3">
                                                {showcaseImages.map((image, index) => (
                                                    <div key={index} className="relative border-2 border-rose-200 rounded-xl overflow-hidden h-24 shadow-sm hover:shadow-md transition-shadow duration-200">
                                                        <img src={image.preview} alt={`showcase-${index}`} className="w-full h-full object-cover" />
                                                        <button type="button" onClick={() => removeShowcaseImage(index)} className="absolute top-1 right-1 bg-white text-red-500 border border-red-500 p-0.5 rounded-full shadow hover:bg-red-500 hover:text-white transition duration-300">
                                                            <IoClose className="text-xs" />
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <div className="mt-4 bg-white/60 rounded-lg p-4 text-center border border-dashed border-rose-300">
                                                <p className="text-rose-600 text-sm">No showcase images uploaded yet</p>
                                            </div>
                                        )}
                                    </div>

                                    {/* Legacy Accordions - Hidden by default, show only if no dynamic details exist */}
                                    {!hasDynamicProductDetails() && (
                                        <Accordion
                                            allowZeroExpanded
                                            className="grid grid-cols-1 md:grid-cols-2 gap-4"
                                            onChange={(expandedIndexes) => handleAccordionChange(expandedIndexes)}
                                        >
                                            {['materials', 'instructions', 'fullDetails', 'ingredients', 'uses'].map((field, index) => (
                                                <AccordionItem key={field} uuid={index}>
                                                    <AccordionItemHeading>
                                                        <AccordionItemButton className="flex justify-between items-center p-3 bg-gray-100 rounded-lg hover:bg-gray-200 transition font-medium rounded-bl-none rounded-br-none">
                                                            {field.charAt(0).toUpperCase() + field.slice(1)} <FaChevronDown className="text-gray-600" />
                                                        </AccordionItemButton>
                                                    </AccordionItemHeading>
                                                    <AccordionItemPanel className="px-4 py-2 text-gray-600 bg-white rounded-lg border border-gray-200 shadow-sm rounded-tl-none rounded-tr-none border-t-0">
                                                        <textarea name={field} value={formData[field] || ''} onChange={handleInputChange} className="border p-2 rounded w-full" rows="3" ref={(el) => (textAreaRefs.current[index] = el)}></textarea>
                                                    </AccordionItemPanel>
                                                </AccordionItem>
                                            ))}
                                        </Accordion>
                                    )}
                                </div>
                            )}
                        </div>
                    )}

                    {/* ============================================================= */}
                    {/* SUBMIT BUTTON */}
                    {/* ============================================================= */}
                    <div className="mt-6">
                        {/* Show warning when limit is reached for selected store types */}
                        {isLimitReached && !isEditMode && (
                            <div className="mb-4 p-4 bg-red-50 border-l-4 border-red-500 text-red-700 rounded">
                                <p className="font-semibold">Product Creation Limit Reached</p>
                                <p className="text-sm mt-1">
                                    {isOnlineProduct && masterCountData?.online?.count >= masterCountData?.online?.limit &&
                                        "Online store has reached its product limit. "}
                                    {isOfflineProduct && masterCountData?.offline?.count >= masterCountData?.offline?.limit &&
                                        "Offline store has reached its product limit. "}
                                    Please contact support to increase your limit or uncheck the store type that has reached its limit.
                                </p>
                            </div>
                        )}

                        <button
                            type="submit"
                            disabled={isSubmitting || isLimitReached}
                            className={`w-full bg-gradient-to-r from-blue-600 to-blue-800 hover:from-blue-700 hover:to-blue-900 text-white font-bold py-4 rounded-xl shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-75 text-lg transition-all duration-200 ${(isSubmitting || isLimitReached) ? "opacity-50 cursor-not-allowed" : "hover:shadow-2xl hover:scale-[1.01]"}`}
                        >
                            {isSubmitting ? (
                                <div className="flex items-center justify-center">
                                    <span className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white mr-2"></span>
                                    Loading...
                                </div>
                            ) : location.state ? 'Update Product' : 'Create Product'}
                        </button>
                    </div>
                </form>
            </div>

            {/* Modal for Product Options */}
            <Modal
                isOpen={isModalOpen}
                onRequestClose={() => {
                    setIsModalOpen(false);
                    setCurrentProductOption({
                        weightValue: "",
                        selectedMetric: null,
                        weightLabel: "",
                        originalPrice: "",
                        discount: null,
                        discountPrice: "",
                        barcode: "",
                        useDifferentOfflinePrice: false,
                        offlineOriginalPrice: "",
                        offlineDiscount: null,
                        offlineDiscountPrice: "",
                        mainMetricLabel: "",
                        mainMetricId: null,
                    });
                    setErrors(prevErrors => ({ ...prevErrors, weightValue: "", selectedMetric: "", weightLabel: "", originalPrice: "", discount: "", offlineOriginalPrice: "", offlineDiscount: "" }));
                }}
                className="outline-none mx-auto my-4 sm:my-8 w-[min(96vw,1180px)] max-w-[1180px] max-h-[min(92vh,900px)] flex flex-col rounded-2xl border border-slate-200/80 bg-white shadow-[0_25px_80px_-12px_rgba(15,23,42,0.35)] overflow-hidden"
                overlayClassName="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/60 backdrop-blur-[3px] p-3 sm:p-5"
            >
                <div className="flex min-h-0 max-h-[min(92vh,900px)] flex-1 flex-col">
                    <div className="shrink-0 border-b border-slate-100 bg-gradient-to-br from-slate-50 via-white to-indigo-50/40 px-5 py-5 sm:px-8 sm:py-6">
                        <div className="flex flex-col gap-1 sm:flex-row sm:items-end sm:justify-between">
                            <div>
                                {/* <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-indigo-600/90">Product option</p> */}
                                <h2 className="mt-1 text-xl font-bold tracking-tight text-slate-900 sm:text-2xl">
                                    {editOptionIndex !== null ? "Edit Product Option" : "Add Product Option"}
                                </h2>
                                <p className="mt-1 max-w-2xl text-sm text-slate-600">
                                    Configure how this variant appears, prices, and optional promotions
                                </p>
                            </div>
                            <div className="mt-3 hidden h-10 w-10 shrink-0 rounded-xl bg-indigo-600/10 ring-1 ring-indigo-200/60 sm:mt-0 sm:flex sm:items-center sm:justify-center" aria-hidden>
                                <button type="button" onClick={handleCancelAddProductOption} className="p-1 bg-white rounded hover:bg-gray-100">
                                    <IoClose className="text-2xl text-indigo-600" />
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-4 py-5 scrollbar-thin sm:px-8 sm:py-6">
                        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-x-10 lg:gap-y-0">
                            {/* —— Column 1: identity, online pricing, barcode, expiry —— */}
                            <div className="flex min-w-0 flex-col gap-6 lg:pr-2">
                                <section className="rounded-xl border border-slate-200/90 bg-gradient-to-b from-white to-slate-50/80 p-5 shadow-sm ring-1 ring-slate-100/80">
                                    <div className="mb-4 flex items-center gap-2 border-b border-slate-100 pb-3">
                                        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-indigo-600 text-xs font-bold text-white">1</span>
                                        <h3 className="text-base font-semibold text-slate-800">
                                            {mainMetricHasSubUnits ? "Weight & label" : "Option label"}
                                        </h3>
                                    </div>

                                    {mainMetricHasSubUnits && (
                                        <div className="mb-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
                                            <div>
                                                <label className="mb-1.5 block text-sm font-medium text-slate-700">Weight Value *</label>
                                                <input
                                                    type="number"
                                                    placeholder="e.g., 500, 1, 2.5"
                                                    value={currentProductOption.weightValue}
                                                    onChange={(e) => {
                                                        setCurrentProductOption(prev => ({ ...prev, weightValue: e.target.value }));
                                                        setErrors(prev => ({ ...prev, weightValue: "" }));
                                                    }}
                                                    className={`customInput w-full rounded-lg px-3 py-[9px] ${errors.weightValue ? 'inputError' : 'inputNormal'}`}
                                                    step="any"
                                                />
                                                {errors.weightValue && <p className="mt-1 text-sm text-red-500">{errors.weightValue}</p>}
                                            </div>
                                            <div>
                                                <label className="mb-1.5 block text-sm font-medium text-slate-700">Select Metric *</label>
                                                <Select
                                                    options={(() => {
                                                        if (!mainMetric) return [];
                                                        const filteredMetrics = metrics.filter(m =>
                                                            m.metricId === mainMetric.metricId &&
                                                            (m.metricType === 'primary' || m.metricType === 'supporting')
                                                        );
                                                        return filteredMetrics;
                                                    })()}
                                                    value={currentProductOption.selectedMetric}
                                                    placeholder={mainMetric ? "Select Metric" : "Please select Main Metric first"}
                                                    isDisabled={!mainMetric}
                                                    onChange={(option) => {
                                                        setCurrentProductOption(prev => ({
                                                            ...prev,
                                                            selectedMetric: option,
                                                            mainMetricLabel: mainMetric?.label || "",
                                                            mainMetricId: mainMetric?.metricId || null,
                                                        }));
                                                        setErrors(prev => ({ ...prev, selectedMetric: "" }));
                                                    }}
                                                    formatOptionLabel={formatMetricLabel}
                                                    styles={customSelect}
                                                    className="react-select-container w-full scrollbar-thin"
                                                    classNamePrefix="react-select"
                                                />
                                                {errors.selectedMetric && <p className="mt-1 text-sm text-red-500">{errors.selectedMetric}</p>}
                                                {!mainMetric && (
                                                    <p className="mt-1 text-xs text-amber-600">Please select a Main Metric from the product form first</p>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    {!mainMetricHasSubUnits && mainMetric && (
                                        <div className="mb-4 rounded-lg border border-amber-200/80 bg-amber-50/90 p-3.5">
                                            <p className="text-sm font-semibold text-amber-900">
                                                <AiOutlineInfoCircle className="mr-1 inline align-middle" /> Selected Metric: {mainMetric.label} ({mainMetric.metricName})
                                            </p>
                                            <p className="mt-1 text-xs text-amber-800/90">
                                                This metric has no sub-units configured. Weight configuration is not required.
                                            </p>
                                        </div>
                                    )}

                                    {mainMetricHasSubUnits && currentProductOption.weightValue && currentProductOption.selectedMetric && mainMetric && (() => {
                                        const weightValue = parseFloat(currentProductOption.weightValue);
                                        const metric = currentProductOption.selectedMetric;

                                        if (!isNaN(weightValue) && weightValue > 0) {
                                            if (metric.metricType === 'supporting') {
                                                const primaryValue = weightValue * metric.conversionFactor;
                                                return (
                                                    <div className="mb-4 rounded-lg border border-emerald-200/80 bg-emerald-50/90 p-3.5">
                                                        <p className="text-sm font-semibold text-emerald-900">
                                                            Conversion: {weightValue} {metric.label} = <strong>{primaryValue} {mainMetric.label}</strong>
                                                        </p>
                                                        <p className="mt-1 text-xs text-emerald-800/90">
                                                            This will be saved as {primaryValue} {mainMetric.label} in the Inventory
                                                        </p>
                                                    </div>
                                                );
                                            } else if (metric.metricType === 'primary') {
                                                return (
                                                    <div className="mb-4 rounded-lg border border-sky-200/80 bg-sky-50/90 p-3.5">
                                                        <p className="text-sm font-semibold text-sky-900">
                                                            Value: {weightValue} {metric.label}
                                                        </p>
                                                        <p className="mt-1 text-xs text-sky-800/90">
                                                            Already in primary metric format
                                                            {metric.supportingMetricLabel && ` (1 ${metric.label} = ${metric.primaryToSupporting} ${metric.supportingMetricLabel})`}
                                                        </p>
                                                    </div>
                                                );
                                            }
                                        }
                                        return null;
                                    })()}

                                    <div>
                                        <label className="mb-1.5 block text-sm font-medium text-slate-700">
                                            {mainMetricHasSubUnits ? "Weight Label *" : "Option Label *"}
                                        </label>
                                        <input
                                            type="text"
                                            placeholder={mainMetricHasSubUnits ? "e.g., 500gm, 1Kg, 2.5L" : "e.g., Pack of 6, Single Unit, Pair"}
                                            value={currentProductOption.weightLabel}
                                            onChange={(e) => {
                                                setCurrentProductOption(prev => ({ ...prev, weightLabel: e.target.value }));
                                                setErrors(prev => ({ ...prev, weightLabel: "" }));
                                            }}
                                            className={`customInput w-full rounded-lg px-3 py-[9px] ${errors.weightLabel ? 'inputError' : 'inputNormal'}`}
                                        />
                                        {errors.weightLabel && <p className="mt-1 text-sm text-red-500">{errors.weightLabel}</p>}
                                        <p className="mt-1.5 text-xs leading-relaxed text-slate-500">
                                            {mainMetricHasSubUnits
                                                ? "Shown to customers (e.g. “500gm Pack”, “1 Kg Bag”)."
                                                : "Shown to customers (e.g. “Pack of 6”, “Single Unit”, “1 Pair”)."}
                                        </p>
                                    </div>
                                </section>

                                <section className="rounded-xl border border-slate-200/90 bg-white p-5 shadow-sm ring-1 ring-slate-100/80">
                                    <div className="mb-4 flex items-center gap-2 border-b border-slate-100 pb-3">
                                        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-slate-800 text-xs font-bold text-white">2</span>
                                        <h3 className="text-base font-semibold text-slate-800">Online pricing</h3>
                                    </div>
                                    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
                                        <div className="sm:col-span-1">
                                            <label className="labelStyles mb-1.5 block">Original Price *</label>
                                            <input
                                                type="number"
                                                placeholder="Enter Original Price"
                                                value={currentProductOption.originalPrice}
                                                onChange={(e) => handleProductOptionChange('originalPrice', e.target.value)}
                                                className={`customInput w-full rounded-lg px-3 py-[9px] ${errors.originalPrice ? 'inputError' : 'inputNormal'}`}
                                            />
                                            {errors.originalPrice && <p className="mt-1 text-sm text-red-500">{errors.originalPrice}</p>}
                                        </div>
                                        <div className="sm:col-span-1">
                                            <label className="mb-1.5 block text-sm font-medium text-slate-700">Discount (%) *</label>
                                            <input
                                                type="number"
                                                placeholder="Enter Discount (%)"
                                                value={currentProductOption.discount ?? ''}
                                                onChange={(e) => handleProductOptionChange('discount', e.target.value)}
                                                className={`customInput w-full rounded-lg px-3 py-[9px] ${errors.discount ? 'inputError' : 'inputNormal'}`}
                                                min="0"
                                                max="100"
                                            />
                                            {errors.discount && <p className="mt-1 text-sm text-red-500">{errors.discount}</p>}
                                        </div>
                                        <div className="sm:col-span-1">
                                            <label className="mb-1.5 block text-sm font-medium text-slate-700">Discount Price</label>
                                            <input
                                                type="number"
                                                value={currentProductOption.discountPrice}
                                                readOnly
                                                className="w-full cursor-not-allowed rounded-lg border border-slate-200 bg-slate-100 px-3 py-[9px] text-slate-700 shadow-inner"
                                            />
                                        </div>
                                    </div>
                                </section>

                                <section className="rounded-xl border border-slate-200/90 bg-white p-5 shadow-sm ring-1 ring-slate-100/80">
                                    <div className="mb-4 flex items-center gap-2 border-b border-slate-100 pb-3">
                                        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-orange-600 text-xs font-bold text-white">3</span>
                                        <h3 className="text-base font-semibold text-slate-800">Barcode &amp; expiry</h3>
                                    </div>
                                    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
                                        <div>
                                            <label className="block text-sm font-medium text-slate-700">
                                                Barcode
                                            </label>
                                            <span className="text-xs text-slate-500 mb-1.5 block">(Mandetory for Offline - POS)</span>
                                            <input
                                                type="text"
                                                placeholder="Enter Barcode"
                                                value={currentProductOption.barcode || ''}
                                                onChange={(e) => setCurrentProductOption(prev => ({ ...prev, barcode: e.target.value }))}
                                                className="customInput w-full rounded-lg px-3 py-[9px] inputNormal"
                                            />
                                            <div role="note" className="mt-2 flex items-start gap-2 text-xs text-slate-500">
                                                <AiOutlineInfoCircle className="mt-0.5 shrink-0 text-slate-400" />
                                                <div>Focus this input and scan using your barcode scanner (gun) to auto-insert the code.</div>
                                            </div>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-slate-700">Expiry Date</label>
                                            <span className="text-xs text-slate-500 mb-1.5 block">(DD/MM/YYYY)</span>
                                            <input
                                                type="text"
                                                placeholder="e.g. 31/12/2026"
                                                value={currentProductOption.expiryDate || ""}
                                                onChange={(e) => {
                                                    const formatted = formatExpiryDateInput(e.target.value);
                                                    setCurrentProductOption(prev => ({ ...prev, expiryDate: formatted }));
                                                    setErrors(prev => ({ ...prev, expiryDate: "" }));
                                                }}
                                                className={`customInput w-full rounded-lg px-3 py-[9px] ${errors.expiryDate ? 'inputError' : 'inputNormal'}`}
                                            />
                                            {errors.expiryDate && <p className="mt-1 text-sm text-red-500">{errors.expiryDate}</p>}
                                        </div>
                                    </div>
                                </section>
                            </div>

                            {/* —— Column 2: flash, bulk, offline, images —— */}
                            <div className="flex min-w-0 flex-col gap-6 border-t border-slate-100 pt-6 lg:border-l lg:border-t-0 lg:pl-8 lg:pt-0">
                                <section className="rounded-xl border border-rose-200/70 bg-gradient-to-br from-rose-50/90 to-white p-5 shadow-sm ring-1 ring-rose-100/60">
                                    <div className="mb-3 flex flex-wrap items-center gap-2">
                                    <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-rose-600 text-xs font-bold text-white">4</span>
                                        <h3 className="text-base font-semibold text-slate-900">Flash discount</h3>
                                        <span className="rounded-md bg-rose-600 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white">Moved</span>
                                    </div>
                                    <p className="text-sm text-rose-950 leading-relaxed">
                                        Configure Flash Deals from <strong>Design → Flash Deals</strong> and Timer Deals from <strong>Design → Timer Deals</strong>.
                                        Existing flash settings on this option are preserved when you save the product; use the dedicated pages to add or change promo pricing.
                                    </p>
                                    {currentProductOption.isFlashDiscount && (
                                        <p className="mt-3 text-xs text-rose-800 font-medium">
                                            This option has flash pricing enabled (₹{currentProductOption.flashDiscountPrice || '—'}).
                                        </p>
                                    )}
                                </section>

                                <section className="rounded-xl border border-amber-200/80 bg-gradient-to-br from-amber-50/50 to-white p-5 shadow-sm ring-1 ring-amber-100/70">
                                    <div className="mb-2 flex flex-wrap items-baseline gap-2">
                                        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-yellow-600 text-xs font-bold text-white">5</span>
                                        <h3 className="text-base font-semibold text-slate-900">Bulk offers</h3>
                                        <span className="text-xs font-normal text-slate-500">(Optional)</span>
                                    </div>
                                    <p className="mb-4 text-xs leading-relaxed text-slate-600">
                                        Define quantity-based discounts. When a customer adds the specified quantity to cart, the bulk discount will automatically apply.
                                    </p>

                                    {currentProductOption.bulkOffers && currentProductOption.bulkOffers.length > 0 && (
                                        <div className="mb-4 space-y-2">
                                            {currentProductOption.bulkOffers.map((offer, idx) => {
                                                const bulkDiscountPrice = typeof currentProductOption.originalPrice === 'number' && !isNaN(currentProductOption.originalPrice)
                                                    ? Math.floor(currentProductOption.originalPrice - (currentProductOption.originalPrice * offer.discountPercentage) / 100)
                                                    : '—';
                                                return (
                                                    <div key={idx} className="flex items-center gap-3 rounded-lg border border-amber-200/60 bg-white p-3 shadow-sm">
                                                        <div className="min-w-0 flex-1 text-sm text-slate-700">
                                                            Buy <span className="font-bold text-amber-800">{offer.minQuantity}+</span>
                                                            {" → "}
                                                            <span className="font-bold text-emerald-700">{offer.discountPercentage}% OFF</span>
                                                            {bulkDiscountPrice !== '—' && (
                                                                <span className="ml-1 text-slate-500">(₹{bulkDiscountPrice} each)</span>
                                                            )}
                                                        </div>
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                setCurrentProductOption(prev => ({
                                                                    ...prev,
                                                                    bulkOffers: prev.bulkOffers.filter((_, i) => i !== idx)
                                                                }));
                                                            }}
                                                            className="shrink-0 rounded-full p-1.5 text-red-500 transition-colors hover:bg-red-50 hover:text-red-700"
                                                        >
                                                            <IoClose className="text-lg" />
                                                        </button>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}

                                    <div className="flex flex-col gap-3 sm:flex-row sm:items-end">
                                        <div className="min-w-0 flex-1">
                                            <label className="mb-1 block text-xs font-medium text-slate-600">Min Quantity</label>
                                            <input
                                                type="number"
                                                id="bulkOfferMinQty"
                                                placeholder="e.g., 4"
                                                min="2"
                                                className="customInput w-full rounded-lg px-3 py-[7px] text-sm inputNormal"
                                            />
                                        </div>
                                        <div className="min-w-0 flex-1">
                                            <label className="mb-1 block text-xs font-medium text-slate-600">Discount (%)</label>
                                            <input
                                                type="number"
                                                id="bulkOfferDiscountPct"
                                                placeholder="e.g., 20"
                                                min="1"
                                                max="100"
                                                className="customInput w-full rounded-lg px-3 py-[7px] text-sm inputNormal"
                                            />
                                        </div>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                const qtyInput = document.getElementById('bulkOfferMinQty');
                                                const pctInput = document.getElementById('bulkOfferDiscountPct');
                                                const minQty = parseInt(qtyInput?.value, 10);
                                                const discPct = parseInt(pctInput?.value, 10);

                                                if (isNaN(minQty) || minQty < 2) {
                                                    setErrors(prev => ({ ...prev, bulkOffer: "Minimum quantity must be at least 2." }));
                                                    return;
                                                }
                                                if (isNaN(discPct) || discPct < 1 || discPct > 100) {
                                                    setErrors(prev => ({ ...prev, bulkOffer: "Discount must be between 1% and 100%." }));
                                                    return;
                                                }
                                                const baseDiscount = typeof currentProductOption.discount === 'number' ? currentProductOption.discount : 0;
                                                if (discPct <= baseDiscount) {
                                                    setErrors(prev => ({ ...prev, bulkOffer: `Bulk discount (${discPct}%) must be higher than the base discount (${baseDiscount}%).` }));
                                                    return;
                                                }
                                                const existing = currentProductOption.bulkOffers || [];
                                                if (existing.some(bo => bo.minQuantity === minQty)) {
                                                    setErrors(prev => ({ ...prev, bulkOffer: `A bulk offer for quantity ${minQty} already exists.` }));
                                                    return;
                                                }

                                                setErrors(prev => ({ ...prev, bulkOffer: "" }));
                                                const newOffers = [...existing, { minQuantity: minQty, discountPercentage: discPct }]
                                                    .sort((a, b) => a.minQuantity - b.minQuantity);
                                                setCurrentProductOption(prev => ({ ...prev, bulkOffers: newOffers }));
                                                if (qtyInput) qtyInput.value = '';
                                                if (pctInput) pctInput.value = '';
                                            }}
                                            className="shrink-0 rounded-lg bg-amber-600 px-5 py-[9px] text-sm font-semibold text-white shadow-sm transition-colors hover:bg-amber-700"
                                        >
                                            + Add
                                        </button>
                                    </div>
                                    {errors.bulkOffer && <p className="mt-2 text-sm text-red-500">{errors.bulkOffer}</p>}
                                </section>

                                {isOfflineProduct && isOnlineProduct && (
                                    <div className="rounded-lg border border-slate-200 bg-slate-50/80 px-4 py-3">
                                        <div className="flex items-start gap-3">
                                            <input
                                                type="checkbox"
                                                id="useDifferentOfflinePrice"
                                                checked={currentProductOption.useDifferentOfflinePrice}
                                                onChange={(e) => setCurrentProductOption(prev => ({
                                                    ...prev,
                                                    useDifferentOfflinePrice: e.target.checked,
                                                    offlineOriginalPrice: e.target.checked ? prev.offlineOriginalPrice : "",
                                                    offlineDiscount: e.target.checked ? prev.offlineDiscount : null,
                                                    offlineDiscountPrice: e.target.checked ? prev.offlineDiscountPrice : ""
                                                }))}
                                                className="mt-1 h-4 w-4 shrink-0 rounded border-slate-400 text-indigo-600 focus:ring-indigo-500"
                                            />
                                            <label htmlFor="useDifferentOfflinePrice" className="text-sm font-medium leading-snug text-slate-800">
                                                Use different price for Offline Store! If unchecked, Online pricing will be used.
                                            </label>
                                        </div>
                                    </div>
                                )}

                                {isOfflineProduct && currentProductOption.useDifferentOfflinePrice && (
                                    <section className="rounded-xl border border-sky-200/80 bg-gradient-to-br from-sky-50/80 to-white p-5 shadow-sm ring-1 ring-sky-100/70">
                                        <h3 className="mb-4 border-b border-sky-100 pb-2 text-base font-semibold text-slate-900">Offline store pricing</h3>
                                        <div className="mb-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
                                            <div>
                                                <label className="mb-1.5 block text-sm font-medium text-slate-700">Original Price *</label>
                                                <input
                                                    type="number"
                                                    placeholder="Enter Offline Price"
                                                    value={currentProductOption.offlineOriginalPrice}
                                                    onChange={(e) => handleProductOptionChange('originalPrice', e.target.value, true)}
                                                    className={`customInput w-full rounded-lg px-3 py-[9px] ${errors.offlineOriginalPrice ? 'inputError' : 'inputNormal'}`}
                                                />
                                                {errors.offlineOriginalPrice && <p className="mt-1 text-sm text-red-500">{errors.offlineOriginalPrice}</p>}
                                            </div>
                                            <div>
                                                <label className="mb-1.5 block text-sm font-medium text-slate-700">Discount (%) *</label>
                                                <input
                                                    type="number"
                                                    placeholder="Enter Discount"
                                                    value={currentProductOption.offlineDiscount ?? ''}
                                                    onChange={(e) => handleProductOptionChange('discount', e.target.value, true)}
                                                    className={`customInput w-full rounded-lg px-3 py-[9px] ${errors.offlineDiscount ? 'inputError' : 'inputNormal'}`}
                                                    min="0"
                                                    max="100"
                                                />
                                                {errors.offlineDiscount && <p className="mt-1 text-sm text-red-500">{errors.offlineDiscount}</p>}
                                            </div>
                                        </div>
                                        <div>
                                            <label className="mb-1.5 block text-sm font-medium text-slate-700">Discount Price</label>
                                            <input
                                                type="number"
                                                value={currentProductOption.offlineDiscountPrice}
                                                readOnly
                                                className="w-full cursor-not-allowed rounded-lg border border-slate-200 bg-slate-100 px-3 py-[9px] text-slate-700 shadow-inner"
                                            />
                                        </div>
                                    </section>
                                )}

                                {isMarketplaceProduct && (
                                    <div className="rounded-lg border border-slate-200 bg-slate-50/80 px-4 py-3">
                                        <div className="flex items-start gap-3">
                                            <input
                                                type="checkbox"
                                                id="useDifferentMarketplacePrice"
                                                checked={currentProductOption.useDifferentMarketplacePrice}
                                                onChange={(e) => setCurrentProductOption(prev => ({
                                                    ...prev,
                                                    useDifferentMarketplacePrice: e.target.checked,
                                                    marketplaceOriginalPrice: e.target.checked ? prev.marketplaceOriginalPrice : "",
                                                    marketplaceDiscount: e.target.checked ? prev.marketplaceDiscount : null,
                                                    marketplaceDiscountPrice: e.target.checked ? prev.marketplaceDiscountPrice : ""
                                                }))}
                                                className="mt-1 h-4 w-4 shrink-0 rounded border-slate-400 text-violet-600 focus:ring-violet-500"
                                            />
                                            <label htmlFor="useDifferentMarketplacePrice" className="text-sm font-medium leading-snug text-slate-800">
                                                Use different price for Marketplace! If unchecked, Online pricing will be used.
                                            </label>
                                        </div>
                                    </div>
                                )}

                                {isMarketplaceProduct && currentProductOption.useDifferentMarketplacePrice && (
                                    <section className="rounded-xl border border-violet-200/80 bg-gradient-to-br from-violet-50/80 to-white p-5 shadow-sm ring-1 ring-violet-100/70">
                                        <h3 className="mb-4 border-b border-violet-100 pb-2 text-base font-semibold text-slate-900">Marketplace (B2B) pricing</h3>
                                        <div className="mb-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
                                            <div>
                                                <label className="mb-1.5 block text-sm font-medium text-slate-700">Original Price *</label>
                                                <input
                                                    type="number"
                                                    placeholder="Enter Marketplace Price"
                                                    value={currentProductOption.marketplaceOriginalPrice}
                                                    onChange={(e) => handleMarketplacePriceChange('originalPrice', e.target.value)}
                                                    className={`customInput w-full rounded-lg px-3 py-[9px] ${errors.marketplaceOriginalPrice ? 'inputError' : 'inputNormal'}`}
                                                />
                                                {errors.marketplaceOriginalPrice && <p className="mt-1 text-sm text-red-500">{errors.marketplaceOriginalPrice}</p>}
                                            </div>
                                            <div>
                                                <label className="mb-1.5 block text-sm font-medium text-slate-700">Discount (%) *</label>
                                                <input
                                                    type="number"
                                                    placeholder="Enter Discount"
                                                    value={currentProductOption.marketplaceDiscount ?? ''}
                                                    onChange={(e) => handleMarketplacePriceChange('discount', e.target.value)}
                                                    className={`customInput w-full rounded-lg px-3 py-[9px] ${errors.marketplaceDiscount ? 'inputError' : 'inputNormal'}`}
                                                    min="0"
                                                    max="100"
                                                />
                                                {errors.marketplaceDiscount && <p className="mt-1 text-sm text-red-500">{errors.marketplaceDiscount}</p>}
                                            </div>
                                        </div>
                                        <div>
                                            <label className="mb-1.5 block text-sm font-medium text-slate-700">Discount Price</label>
                                            <input
                                                type="number"
                                                value={currentProductOption.marketplaceDiscountPrice}
                                                readOnly
                                                className="w-full cursor-not-allowed rounded-lg border border-slate-200 bg-slate-100 px-3 py-[9px] text-slate-700 shadow-inner"
                                            />
                                        </div>
                                    </section>
                                )}

                                <section className="rounded-xl border border-violet-200/80 bg-gradient-to-br from-violet-50/40 to-white p-5 shadow-sm ring-1 ring-violet-100/60">
                                    <div className="mb-2 flex items-center gap-2">
                                        <span className="text-lg" aria-hidden>📷</span>
                                        <h3 className="text-base font-semibold text-slate-900">Option-specific images</h3>
                                    </div>
                                    <p className="mb-4 text-xs leading-relaxed text-slate-600">
                                        Upload images specific to this option. If no images are uploaded, the main product images will be used.
                                    </p>

                                    {hasCommonImages() && (
                                        <div className="mb-4 flex items-start gap-2 rounded-lg border border-sky-200 bg-sky-50/90 p-3">
                                            <AiOutlineInfoCircle className="mt-0.5 shrink-0 text-lg text-sky-600" />
                                            <div>
                                                <p className="text-sm font-medium text-sky-900">Common images already uploaded</p>
                                                <p className="mt-0.5 text-xs text-sky-800/90">The product has common images that apply to all options. Option-specific images are disabled. Remove common images first if you want to use option-specific images.</p>
                                            </div>
                                        </div>
                                    )}

                                    <div className={`relative overflow-hidden rounded-xl border-2 border-dashed p-5 transition-all ${hasCommonImages() ? 'cursor-not-allowed border-slate-200 bg-slate-100 opacity-60' : 'cursor-pointer border-violet-300 bg-white hover:border-violet-500 hover:bg-violet-50/50'}`}>
                                        <input
                                            type="file"
                                            multiple
                                            accept="image/*"
                                            onChange={handleOptionImageUpload}
                                            ref={optionImageInputRef}
                                            disabled={hasCommonImages()}
                                            className={`absolute inset-0 h-full w-full opacity-0 ${hasCommonImages() ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                                        />
                                        <div className="pointer-events-none text-center text-slate-500">
                                            <span className="mb-1 block text-sm font-medium text-slate-700">
                                                {hasCommonImages() ? "Disabled — common images in use" : "Click to upload option images"}
                                            </span>
                                            <span className={`text-xs ${hasCommonImages() ? 'text-slate-400' : 'text-violet-700'}`}>
                                                {hasCommonImages() ? "Remove common images to enable option-specific images" : "These images show when this option is selected"}
                                            </span>
                                        </div>
                                    </div>

                                    {currentProductOption.images && currentProductOption.images.length > 0 && (
                                        <div className="mt-4 grid grid-cols-3 gap-2 sm:grid-cols-4">
                                            {currentProductOption.images.map((imageObj, index) => (
                                                <div
                                                    key={index}
                                                    className="relative h-24 overflow-hidden rounded-lg border border-violet-200/80 shadow-sm ring-1 ring-violet-100/50 transition-shadow hover:shadow-md"
                                                >
                                                    <img
                                                        src={imageObj.preview || (imageObj.file ? URL.createObjectURL(imageObj.file) : '')}
                                                        alt={`option-${index}`}
                                                        className="h-full w-full object-cover"
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={() => removeOptionImage(index)}
                                                        className="absolute right-1 top-1 rounded-full border border-red-500 bg-white p-1 text-red-500 shadow transition hover:bg-red-500 hover:text-white"
                                                    >
                                                        <IoClose className="text-xs" />
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </section>
                            </div>
                        </div>
                    </div>

                    <div className="shrink-0 border-t border-slate-200/90 bg-slate-50/90 px-4 py-4 backdrop-blur-sm sm:px-8">
                        <div className="flex flex-col gap-1 sm:flex-row sm:items-end sm:justify-between">
                            <button
                                type="button"
                                onClick={handleCancelAddProductOption}
                                className="order-2 w-full rounded-xl border border-slate-300 bg-white px-6 py-3.5 text-sm font-semibold text-slate-700 shadow-sm transition hover:bg-slate-50 sm:order-1 sm:w-auto sm:min-w-[140px]"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                onClick={editOptionIndex !== null ? handleSaveEditedOption : handleAddProductOption}
                                className="order-1 w-full rounded-xl bg-gradient-to-r from-emerald-600 to-emerald-800 px-6 py-3.5 text-sm font-semibold text-white shadow-md transition hover:from-emerald-700 hover:to-emerald-900 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 sm:order-2 sm:w-auto sm:min-w-[180px]"
                            >
                                {editOptionIndex !== null ? "Save Changes" : "Add Option"}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* =====================================================================
                FEATURE 2: OPTION GROUP MODAL
            ===================================================================== */}
            <Modal
                isOpen={isOptionGroupModalOpen}
                onRequestClose={handleCancelOptionGroupModal}
                className="bg-white p-4 sm:p-6 rounded-lg shadow-2xl transform transition-transform duration-500 ease-in-out scale-100 mx-auto my-4 sm:my-8 md:my-12 lg:my-16 xl:my-20 w-[95vw] max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl max-h-[90vh] overflow-y-auto scrollbar-thin"
                overlayClassName="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center p-2 sm:p-4 z-50"
            >
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold mb-4 text-indigo-700 text-center">
                    {editOptionGroupIndex !== null ? "Edit Option Group" : "Add Option Group"}
                </h2>

                {/* Option Group Configuration */}
                <div className="mb-6 p-4 border-2 border-indigo-200 rounded-lg bg-indigo-50">
                    <h3 className="text-md font-semibold mb-3 text-gray-700">Group Configuration</h3>

                    {/* Group Name */}
                    <div className="mb-4">
                        <label className="block font-medium mb-2 text-gray-700">Group Name *</label>
                        <input
                            type="text"
                            placeholder="e.g., RAM, ROM, Color, Size"
                            value={currentOptionGroup.groupName}
                            onChange={(e) => setCurrentOptionGroup(prev => ({ ...prev, groupName: e.target.value }))}
                            className={`customInput px-3 py-[9px] ${errors.optionGroupName ? 'inputError' : 'inputNormal'}`}
                        />
                        {errors.optionGroupName && <p className="text-red-500 text-sm mt-1">{errors.optionGroupName}</p>}
                        <p className="text-xs text-gray-500 mt-1">This is the attribute name that will appear on the product page</p>
                    </div>

                    {/* Add Values */}
                    <div className="mb-4">
                        <label className="block font-medium mb-2 text-gray-700">Add Values *</label>
                        <div className="flex gap-2">
                            <input
                                type="text"
                                placeholder="e.g., 4GB, 8GB, Red, Large"
                                value={currentOptionGroupValue}
                                onChange={(e) => setCurrentOptionGroupValue(e.target.value)}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        handleAddOptionGroupValue();
                                    }
                                }}
                                className="customInput px-3 py-[9px] inputNormal flex-1"
                            />
                            <button
                                type="button"
                                onClick={handleAddOptionGroupValue}
                                className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition"
                            >
                                Add
                            </button>
                        </div>
                        {errors.optionGroupValues && <p className="text-red-500 text-sm mt-1">{errors.optionGroupValues}</p>}
                        <p className="text-xs text-gray-500 mt-1">Add at least 2 values for the option group (press Enter or click Add)</p>
                    </div>

                    {/* Display Added Values */}
                    {currentOptionGroup.values.length > 0 && (
                        <div className="mt-4">
                            <label className="block font-medium mb-2 text-gray-700">
                                Added Values ({currentOptionGroup.values.length})
                            </label>
                            <div className="flex flex-wrap gap-2">
                                {currentOptionGroup.values.map((value, index) => (
                                    <span
                                        key={index}
                                        className="px-3 py-1 bg-white text-indigo-700 rounded-full border border-indigo-300 flex items-center gap-2 shadow-sm"
                                    >
                                        {value}
                                        <button
                                            type="button"
                                            onClick={() => handleRemoveOptionGroupValue(index)}
                                            className="text-red-500 hover:text-red-700"
                                        >
                                            <IoClose className="text-sm" />
                                        </button>
                                    </span>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                {/* Modal Action Buttons */}
                <div className="flex flex-col sm:flex-row mt-6 gap-3 sm:gap-6">
                    <button
                        type="button"
                        onClick={handleCancelOptionGroupModal}
                        className="w-full sm:w-1/2 bg-gradient-to-r from-gray-500 to-gray-700 hover:from-gray-600 hover:to-gray-800 text-white px-4 sm:px-6 py-3 rounded-lg shadow-lg transform transition-all hover:scale-105 focus:outline-none focus:ring-4 focus:ring-gray-400 text-sm sm:text-base"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={editOptionGroupIndex !== null ? handleSaveEditedOptionGroup : handleAddOptionGroup}
                        className="w-full sm:w-1/2 bg-gradient-to-r from-indigo-500 to-indigo-700 hover:from-indigo-600 hover:to-indigo-800 text-white px-4 sm:px-6 py-3 rounded-lg shadow-lg transform transition-all hover:scale-105 focus:outline-none focus:ring-4 focus:ring-indigo-400 text-sm sm:text-base"
                    >
                        {editOptionGroupIndex !== null ? "Save Changes" : "Add Group"}
                    </button>
                </div>
            </Modal>

            {/* =====================================================================
                FEATURE 2: VARIANT COMBINATION MODAL
            ===================================================================== */}
            <Modal
                isOpen={isVariantCombinationModalOpen}
                onRequestClose={handleCancelVariantCombinationModal}
                className="bg-white p-4 sm:p-6 rounded-lg shadow-2xl transform transition-transform duration-500 ease-in-out scale-100 mx-auto my-4 sm:my-8 md:my-12 lg:my-16 xl:my-20 w-[95vw] max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl max-h-[90vh] overflow-y-auto scrollbar-thin"
                overlayClassName="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center p-2 sm:p-4 z-50"
            >
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold mb-4 text-purple-700 text-center">
                    {editVariantCombinationIndex !== null ? "Edit Variant Combination" : "Add Variant Combination"}
                </h2>

                {/* Option Selection Section */}
                <div className="mb-6 p-4 border-2 border-purple-200 rounded-lg bg-purple-50">
                    <h3 className="text-md font-semibold mb-3 text-gray-700">Select Options Combination</h3>

                    <div className="space-y-4">
                        {optionGroups.map((group, index) => (
                            <div key={index}>
                                <label className="block font-medium mb-2 text-gray-700">{group.groupName} *</label>
                                <Select
                                    options={group.values.map(v => ({ value: v, label: v }))}
                                    value={currentVariantCombination.selectedOptions[group.groupName]
                                        ? { value: currentVariantCombination.selectedOptions[group.groupName], label: currentVariantCombination.selectedOptions[group.groupName] }
                                        : null
                                    }
                                    onChange={(option) => {
                                        setCurrentVariantCombination(prev => ({
                                            ...prev,
                                            selectedOptions: {
                                                ...prev.selectedOptions,
                                                [group.groupName]: option ? option.value : null
                                            }
                                        }));
                                    }}
                                    placeholder={`Select ${group.groupName}`}
                                    styles={customSelect}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                />
                            </div>
                        ))}
                    </div>
                    {errors.selectedOptions && <p className="text-red-500 text-sm mt-2">{errors.selectedOptions}</p>}

                    {/* Show selected combination */}
                    {Object.keys(currentVariantCombination.selectedOptions).length > 0 &&
                        Object.values(currentVariantCombination.selectedOptions).every(v => v) && (
                            <div className="mt-4 p-3 bg-purple-100 rounded-lg">
                                <p className="text-sm font-semibold text-purple-700">
                                    Selected: {getCombinationLabel(currentVariantCombination.selectedOptions)}
                                </p>
                            </div>
                        )}
                </div>

                {/* Pricing Section */}
                <div className="mb-4">
                    <label className="labelStyles">Original Price *</label>
                    <input
                        type="number"
                        placeholder="Enter Original Price"
                        value={currentVariantCombination.originalPrice}
                        onChange={(e) => handleVariantCombinationChange('originalPrice', e.target.value)}
                        className={`customInput px-3 py-[9px] ${errors.variantOriginalPrice ? 'inputError' : 'inputNormal'}`}
                    />
                    {errors.variantOriginalPrice && <p className="text-red-500 text-sm">{errors.variantOriginalPrice}</p>}
                </div>

                <div className="mb-4">
                    <label className="block font-medium mb-2 text-gray-700">Discount (%)*</label>
                    <input
                        type="number"
                        placeholder="Enter Discount (%)"
                        value={currentVariantCombination.discount ?? ''}
                        onChange={(e) => handleVariantCombinationChange('discount', e.target.value)}
                        className={`customInput px-3 py-[9px] ${errors.variantDiscount ? 'inputError' : 'inputNormal'}`}
                        min="0"
                        max="100"
                    />
                    {errors.variantDiscount && <p className="text-red-500 text-sm">{errors.variantDiscount}</p>}
                </div>

                <div className="mb-4">
                    <label className="block font-medium mb-2 text-gray-700">Discount Price</label>
                    <input
                        type="number"
                        value={currentVariantCombination.discountPrice}
                        readOnly
                        className="w-full px-3 py-[9px] border-[1px] rounded-md shadow-sm bg-gray-100 cursor-not-allowed border-gray-400"
                    />
                </div>

                <div className="mb-4">
                    <label className="block font-medium mb-2 text-gray-700">
                        Barcode (Optional for POS)
                    </label>
                    <input
                        type="text"
                        placeholder="Enter Barcode"
                        value={currentVariantCombination.barcode || ''}
                        onChange={(e) => setCurrentVariantCombination(prev => ({ ...prev, barcode: e.target.value }))}
                        className="customInput px-3 py-[9px] inputNormal"
                    />
                </div>

                {/* Use Different Offline Price Checkbox */}
                {isOfflineProduct && isOnlineProduct && (
                    <div className="mb-4">
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                id="variantUseDifferentOfflinePrice"
                                checked={currentVariantCombination.useDifferentOfflinePrice}
                                onChange={(e) => setCurrentVariantCombination(prev => ({
                                    ...prev,
                                    useDifferentOfflinePrice: e.target.checked,
                                    offlineOriginalPrice: e.target.checked ? prev.offlineOriginalPrice : "",
                                    offlineDiscount: e.target.checked ? prev.offlineDiscount : null,
                                    offlineDiscountPrice: e.target.checked ? prev.offlineDiscountPrice : ""
                                }))}
                                className="mr-2 h-4 w-4"
                            />
                            <label htmlFor="variantUseDifferentOfflinePrice" className="block text-sm font-semibold text-gray-700">
                                Use different price for Offline Store!
                            </label>
                        </div>
                    </div>
                )}

                {/* Offline Pricing Fields */}
                {isOfflineProduct && currentVariantCombination.useDifferentOfflinePrice && (
                    <div className="mb-6 p-4 border-2 border-blue-200 rounded-lg bg-blue-50">
                        <h3 className="text-md font-semibold mb-3 text-gray-700">Offline Store Pricing</h3>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                            <div>
                                <label className="block font-medium mb-2 text-gray-700">Original Price *</label>
                                <input
                                    type="number"
                                    placeholder="Enter Offline Price"
                                    value={currentVariantCombination.offlineOriginalPrice}
                                    onChange={(e) => handleVariantCombinationChange('originalPrice', e.target.value, true)}
                                    className={`customInput px-3 py-[9px] ${errors.variantOfflineOriginalPrice ? 'inputError' : 'inputNormal'}`}
                                />
                                {errors.variantOfflineOriginalPrice && <p className="text-red-500 text-sm mt-1">{errors.variantOfflineOriginalPrice}</p>}
                            </div>
                            <div>
                                <label className="block font-medium mb-2 text-gray-700">Discount (%) *</label>
                                <input
                                    type="number"
                                    placeholder="Enter Discount"
                                    value={currentVariantCombination.offlineDiscount ?? ''}
                                    onChange={(e) => handleVariantCombinationChange('discount', e.target.value, true)}
                                    className={`customInput px-3 py-[9px] ${errors.variantOfflineDiscount ? 'inputError' : 'inputNormal'}`}
                                    min="0"
                                    max="100"
                                />
                                {errors.variantOfflineDiscount && <p className="text-red-500 text-sm mt-1">{errors.variantOfflineDiscount}</p>}
                            </div>
                        </div>

                        <div>
                            <label className="block font-medium mb-2 text-gray-700">Discount Price</label>
                            <input
                                type="number"
                                value={currentVariantCombination.offlineDiscountPrice}
                                readOnly
                                className="w-full px-3 py-[9px] border-[1px] rounded-md shadow-sm bg-gray-100 cursor-not-allowed border-gray-400"
                            />
                        </div>
                    </div>
                )}

                {/* Variant-Specific Images Upload */}
                <div className="mb-6 p-4 border-2 border-purple-200 rounded-lg bg-purple-50">
                    <h3 className="text-md font-semibold mb-2 text-gray-700 flex items-center gap-2">
                        <span>📷</span> Variant-Specific Images
                        <span className="text-xs font-normal text-gray-500">(Optional)</span>
                    </h3>
                    <p className="text-xs text-gray-600 mb-3">
                        Upload images specific to this variant. If no images are uploaded, the main product images will be used.
                    </p>

                    <div className="relative border-dashed border-2 border-purple-300 rounded-lg p-4 transition-all hover:border-purple-500 bg-white hover:bg-purple-50">
                        <input
                            type="file"
                            multiple
                            accept="image/*"
                            onChange={handleVariantImageUpload}
                            ref={variantImageInputRef}
                            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                        />
                        <div className="text-center text-gray-500">
                            <span className="block mb-1 text-sm font-medium">
                                Click to upload variant images
                            </span>
                            <span className="text-xs text-purple-600">
                                These images will show when this variant is selected
                            </span>
                        </div>
                    </div>

                    {/* Variant Images Preview */}
                    {currentVariantCombination.images && currentVariantCombination.images.length > 0 && (
                        <div className="mt-3 grid grid-cols-3 sm:grid-cols-4 gap-2">
                            {currentVariantCombination.images.map((imageObj, index) => (
                                <div
                                    key={index}
                                    className="relative border-2 border-purple-200 rounded-lg overflow-hidden h-20 shadow-sm hover:shadow-md transition-shadow duration-200"
                                >
                                    <img
                                        src={imageObj.preview || (imageObj.file ? URL.createObjectURL(imageObj.file) : '')}
                                        alt={`variant-${index}`}
                                        className="w-full h-full object-cover"
                                    />
                                    <button
                                        type="button"
                                        onClick={() => removeVariantImage(index)}
                                        className="absolute top-1 right-1 bg-white text-red-500 border border-red-500 p-0.5 rounded-full shadow hover:bg-red-500 hover:text-white transition duration-300"
                                    >
                                        <IoClose className="text-xs" />
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Modal Action Buttons */}
                <div className="flex flex-col sm:flex-row mt-6 gap-3 sm:gap-6">
                    <button
                        type="button"
                        onClick={handleCancelVariantCombinationModal}
                        className="w-full sm:w-1/2 bg-gradient-to-r from-gray-500 to-gray-700 hover:from-gray-600 hover:to-gray-800 text-white px-4 sm:px-6 py-3 rounded-lg shadow-lg transform transition-all hover:scale-105 focus:outline-none focus:ring-4 focus:ring-gray-400 text-sm sm:text-base"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={editVariantCombinationIndex !== null ? handleSaveEditedVariantCombination : handleAddVariantCombination}
                        className="w-full sm:w-1/2 bg-gradient-to-r from-purple-500 to-purple-700 hover:from-purple-600 hover:to-purple-800 text-white px-4 sm:px-6 py-3 rounded-lg shadow-lg transform transition-all hover:scale-105 focus:outline-none focus:ring-4 focus:ring-purple-400 text-sm sm:text-base"
                    >
                        {editVariantCombinationIndex !== null ? "Save Changes" : "Add Combination"}
                    </button>
                </div>
            </Modal>

            {/* =====================================================================
                FEATURE 3: HIGHLIGHT MODAL (Plain Text Only)
            ===================================================================== */}
            <Modal
                isOpen={isHighlightModalOpen}
                onRequestClose={() => {
                    setIsHighlightModalOpen(false);
                    setCurrentHighlight({ text: '' });
                    setEditHighlightIndex(null);
                }}
                className="bg-white p-4 sm:p-6 rounded-lg shadow-2xl transform transition-transform duration-500 ease-in-out scale-100 mx-auto my-4 sm:my-8 md:my-12 lg:my-16 xl:my-20 w-[95vw] max-w-xs sm:max-w-sm md:max-w-md max-h-[90vh] overflow-y-auto scrollbar-thin"
                overlayClassName="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center p-2 sm:p-4 z-50"
            >
                <h2 className="text-lg sm:text-xl font-bold mb-4 text-teal-700 text-center">
                    {editHighlightIndex !== null ? "Edit Highlight" : "Add Product Highlight"}
                </h2>

                <div className="mb-4">
                    <label className="block font-medium mb-2 text-gray-700">Highlight Text *</label>
                    <input
                        type="text"
                        placeholder="e.g., Apple M4 Chip | 16GB RAM | 256GB SSD"
                        value={currentHighlight.text}
                        onChange={(e) => setCurrentHighlight(prev => ({ ...prev, text: e.target.value }))}
                        className="customInput px-3 py-[9px] inputNormal"
                    />
                    <p className="text-xs text-gray-500 mt-1">
                        Enter a key feature or specification highlight
                    </p>
                </div>

                <div className="flex flex-col sm:flex-row mt-6 gap-3 sm:gap-6">
                    <button
                        type="button"
                        onClick={() => {
                            setIsHighlightModalOpen(false);
                            setCurrentHighlight({ text: '' });
                            setEditHighlightIndex(null);
                        }}
                        className="w-full sm:w-1/2 bg-gradient-to-r from-gray-500 to-gray-700 hover:from-gray-600 hover:to-gray-800 text-white px-4 sm:px-6 py-3 rounded-lg shadow-lg transform transition-all hover:scale-105 focus:outline-none focus:ring-4 focus:ring-gray-400 text-sm sm:text-base"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={handleAddHighlight}
                        className="w-full sm:w-1/2 bg-gradient-to-r from-teal-500 to-teal-700 hover:from-teal-600 hover:to-teal-800 text-white px-4 sm:px-6 py-3 rounded-lg shadow-lg transform transition-all hover:scale-105 focus:outline-none focus:ring-4 focus:ring-teal-400 text-sm sm:text-base"
                    >
                        {editHighlightIndex !== null ? "Save Changes" : "Add Highlight"}
                    </button>
                </div>
            </Modal>

            {/* =====================================================================
                FEATURE 3: TAB MODAL (Create Custom Tab Labels)
            ===================================================================== */}
            <Modal
                isOpen={isTabModalOpen}
                onRequestClose={() => {
                    setIsTabModalOpen(false);
                    setCurrentTab({ tabName: '', sections: [] });
                    setEditTabIndex(null);
                }}
                className="bg-white p-4 sm:p-6 rounded-lg shadow-2xl transform transition-transform duration-500 ease-in-out scale-100 mx-auto my-4 sm:my-8 md:my-12 lg:my-16 xl:my-20 w-[95vw] max-w-xs sm:max-w-sm md:max-w-md max-h-[90vh] overflow-y-auto scrollbar-thin"
                overlayClassName="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center p-2 sm:p-4 z-50"
            >
                <h2 className="text-lg sm:text-xl font-bold mb-4 text-indigo-700 text-center">
                    {editTabIndex !== null ? "Edit Tab" : "Add Custom Tab"}
                </h2>

                <div className="mb-4">
                    <label className="block font-medium mb-2 text-gray-700">Tab Name *</label>
                    <input
                        type="text"
                        placeholder="e.g., Specifications, Warranty, Features"
                        value={currentTab.tabName}
                        onChange={(e) => setCurrentTab(prev => ({ ...prev, tabName: e.target.value }))}
                        className="customInput px-3 py-[9px] inputNormal"
                    />
                    <p className="text-xs text-gray-500 mt-1">
                        This will appear as a scrollable tab on the product page
                    </p>
                </div>

                <div className="flex flex-col sm:flex-row mt-6 gap-3 sm:gap-6">
                    <button
                        type="button"
                        onClick={() => {
                            setIsTabModalOpen(false);
                            setCurrentTab({ tabName: '', sections: [] });
                            setEditTabIndex(null);
                        }}
                        className="w-full sm:w-1/2 bg-gradient-to-r from-gray-500 to-gray-700 hover:from-gray-600 hover:to-gray-800 text-white px-4 sm:px-6 py-3 rounded-lg shadow-lg transform transition-all hover:scale-105 focus:outline-none focus:ring-4 focus:ring-gray-400 text-sm sm:text-base"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={handleSaveTab}
                        className="w-full sm:w-1/2 bg-gradient-to-r from-indigo-500 to-indigo-700 hover:from-indigo-600 hover:to-indigo-800 text-white px-4 sm:px-6 py-3 rounded-lg shadow-lg transform transition-all hover:scale-105 focus:outline-none focus:ring-4 focus:ring-indigo-400 text-sm sm:text-base"
                    >
                        {editTabIndex !== null ? "Save Changes" : "Add Tab"}
                    </button>
                </div>
            </Modal>

            {/* =====================================================================
                FEATURE 3: SECTION MODAL (Add Section to Tab)
            ===================================================================== */}
            <Modal
                isOpen={isSectionModalOpen}
                onRequestClose={() => {
                    setIsSectionModalOpen(false);
                    setCurrentSection({ sectionName: '', fields: [] });
                    setCurrentField({ fieldName: '', fieldValue: '' });
                    setEditSectionIndex(null);
                    setSelectedTabForSection(null);
                }}
                className="bg-white p-4 sm:p-6 rounded-lg shadow-2xl transform transition-transform duration-500 ease-in-out scale-100 mx-auto my-4 sm:my-8 md:my-12 lg:my-16 xl:my-20 w-[95vw] max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl max-h-[90vh] overflow-y-auto scrollbar-thin"
                overlayClassName="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center p-2 sm:p-4 z-50"
            >
                <h2 className="text-lg sm:text-xl font-bold mb-4 text-blue-700 text-center">
                    {editSectionIndex !== null ? "Edit Section" : "Add Section"}
                    {selectedTabForSection !== null && productDetailsTabs[selectedTabForSection] && (
                        <span className="block text-sm font-normal text-gray-500 mt-1">
                            Tab: {productDetailsTabs[selectedTabForSection].tabName}
                        </span>
                    )}
                </h2>

                {/* Section Name */}
                <div className="mb-4">
                    <label className="block font-medium mb-2 text-gray-700">Section Name *</label>
                    <input
                        type="text"
                        placeholder="e.g., General, Technical Specifications, Display"
                        value={currentSection.sectionName}
                        onChange={(e) => setCurrentSection(prev => ({ ...prev, sectionName: e.target.value }))}
                        className="customInput px-3 py-[9px] inputNormal"
                    />
                </div>

                {/* Add Fields */}
                <div className="mb-4 p-4 bg-blue-50 rounded-lg border border-blue-200">
                    <h4 className="font-medium text-gray-700 mb-3">Add Fields</h4>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-3">
                        <input
                            type="text"
                            placeholder="Field Name (e.g., RAM)"
                            value={currentField.fieldName}
                            onChange={(e) => setCurrentField(prev => ({ ...prev, fieldName: e.target.value }))}
                            className="customInput px-3 py-[9px] inputNormal"
                        />
                        <input
                            type="text"
                            placeholder="Field Value (e.g., 16GB)"
                            value={currentField.fieldValue}
                            onChange={(e) => setCurrentField(prev => ({ ...prev, fieldValue: e.target.value }))}
                            className="customInput px-3 py-[9px] inputNormal"
                        />
                    </div>
                    <button
                        type="button"
                        onClick={handleAddFieldToSection}
                        className="w-full px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition flex items-center justify-center gap-2"
                    >
                        <FiPlus /> Add Field
                    </button>
                </div>

                {/* Display Added Fields */}
                {currentSection.fields.length > 0 && (
                    <div className="mb-4">
                        <h4 className="font-medium text-gray-700 mb-2">Added Fields ({currentSection.fields.length})</h4>
                        <div className="space-y-2 max-h-40 overflow-y-auto">
                            {currentSection.fields.map((field, index) => (
                                <div key={index} className="flex items-center justify-between p-2 bg-gray-100 rounded">
                                    <div className="flex-1">
                                        <span className="text-gray-500 text-sm">{field.fieldName}:</span>
                                        <span className="ml-2 text-gray-800 font-medium">{field.fieldValue}</span>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() => handleRemoveFieldFromSection(index)}
                                        className="p-1 text-red-500 hover:bg-red-100 rounded"
                                    >
                                        <FiTrash2 className="text-sm" />
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                <div className="flex flex-col sm:flex-row mt-6 gap-3 sm:gap-6">
                    <button
                        type="button"
                        onClick={() => {
                            setIsSectionModalOpen(false);
                            setCurrentSection({ sectionName: '', fields: [] });
                            setCurrentField({ fieldName: '', fieldValue: '' });
                            setEditSectionIndex(null);
                            setSelectedTabForSection(null);
                        }}
                        className="w-full sm:w-1/2 bg-gradient-to-r from-gray-500 to-gray-700 hover:from-gray-600 hover:to-gray-800 text-white px-4 sm:px-6 py-3 rounded-lg shadow-lg transform transition-all hover:scale-105 focus:outline-none focus:ring-4 focus:ring-gray-400 text-sm sm:text-base"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={handleSaveSection}
                        className="w-full sm:w-1/2 bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-600 hover:to-blue-800 text-white px-4 sm:px-6 py-3 rounded-lg shadow-lg transform transition-all hover:scale-105 focus:outline-none focus:ring-4 focus:ring-blue-400 text-sm sm:text-base"
                    >
                        {editSectionIndex !== null ? "Save Changes" : "Add Section"}
                    </button>
                </div>
            </Modal>

            <SnackBar
                message={snackBarMessage}
                isVisible={isSnackBarVisible}
                onClose={() => setIsSnackBarVisible(false)}
            />
        </div>
    );
};

export default CreateProduct;